"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.10
//   protoc               v6.33.5
// source: protos/powernode-events-svc.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetConnectedDevicesResponse = exports.ConnectedCharger = exports.OcppConnection = exports.InternetDevice = exports.STARLINK = exports.PEPLINK = exports.PowerMeterModel = exports.pxr25Rs485 = exports.PXR25 = exports.ACUVIM2 = exports.ChargerModel = exports.CS40 = exports.CS36 = exports.CS32 = exports.EEV3 = exports.DP400K = exports.XC7AM = exports.TPGHPC240 = exports.FC200K = exports.FC150K = exports.PaymentTerminal = exports.KioskV = exports.PayterApolloPolar = exports.VP6800 = exports.ChargerConnector = exports.GetOperationalStatusRequest = exports.GetConnectedDevicesRequest = exports.SyncChargingTransactionDetailsRequest = exports.SyncChargingSessionsRequest = exports.UpdateTransactionRequest = exports.RegisterTransactionRequest = exports.rfidTypeToJSON = exports.rfidTypeFromJSON = exports.RfidType = exports.entityTypeToJSON = exports.entityTypeFromJSON = exports.EntityType = exports.powernodeStatusToJSON = exports.powernodeStatusFromJSON = exports.PowernodeStatus = exports.batteryStatusToJSON = exports.batteryStatusFromJSON = exports.BatteryStatus = exports.weatherCodeToJSON = exports.weatherCodeFromJSON = exports.WeatherCode = exports.chargerAvailabilityToJSON = exports.chargerAvailabilityFromJSON = exports.ChargerAvailability = exports.protobufPackage = void 0;
exports.GetThemeRequest = exports.GetCustomerInformationResponse = exports.GetCustomerInformationRequest = exports.OnScreenValidationFeedbackResponse = exports.OnScreenValidationFeedbackRequest = exports.ChargerFeedbackResponse = exports.ChargerFeedbackRequest = exports.PlugEventResponse = exports.PlugEventRequest = exports.GetPowerProfileScheduleResponse = exports.GetPowerProfileScheduleRequest = exports.PowerProfileSchedule = exports.PowerProfile = exports.UpdateSitePowerMeterStatusResponse = exports.UpdateSitePowerMeterStatusRequest = exports.PowerSnapshot = exports.PowerEntity = exports.UpdatePowernodeStatusResponse = exports.UpdatePowernodeStatusRequest = exports.UpdateStatusResponse = exports.GetSiteEnvironmentResponse = exports.GetSiteEnvironmentRequest = exports.SiteEnvironment = exports.UpdateStatusRequest = exports.ChargerHealth = exports.PortHealth = exports.GenerateReceiptResponse = exports.GenerateReceiptRequest = exports.GetChargerOperatingStatusResponse = exports.GetChargerOperatingStatusRequest = exports.GetStatusResponse_ChargerStatusesEntry = exports.GetStatusResponse = exports.ChargerStatus = exports.GetStatusRequest = exports.GetChargerPricingInformationResponse = exports.GetChargerPricingInformationRequest = exports.GetPricingInformationResponse = exports.GetPricingInformationRequest = exports.GetChargerPaymentInformationResponse = exports.GetChargerPaymentInformationRequest = exports.GetPaymentInformationResponse = exports.GetPaymentInformationRequest = exports.SyncChargingTransactionDetailsResponse = exports.SyncChargingSessionsResponse = exports.UpdateTransactionResponse = exports.RegisterTransactionResponse = exports.GetOperationalStatusResponse = exports.MaintenanceWindow = exports.GetChargerConnectedDeviceResponse = exports.GetChargerConnectedDeviceRequest = void 0;
exports.PowernodeEventsServiceClientImpl = exports.PowernodeEventsServiceServiceName = exports.RegisterBinDataResponse = exports.RegisterBinDataRequest = exports.RegisterStartTransactionResponse = exports.RegisterStartTransactionRequest = exports.RFIDCheckResponse = exports.RFIDCheckRequest = exports.PollMembershipValidationResponse = exports.PollMembershipValidationRequest = exports.ValidateMembershipResponse = exports.ValidateMembershipRequest = exports.GetChargerStopRemotePaymentAuthorizationsResponse = exports.GetStopRemotePaymentAuthorizationsResponse = exports.StopRemotePaymentAuthorization = exports.GetChargerRemotePaymentAuthorizationsResponse = exports.GetRemotePaymentAuthorizationsResponse = exports.RemotePaymentAuthorization = exports.RemotePaymentAuthorizationDetails = exports.OCPIRemoteAuthorization = exports.CommandConsoleAuthorization = exports.GetChargerStopRemotePaymentAuthorizationsRequest = exports.GetStopRemotePaymentAuthorizationsRequest = exports.GetChargerRemotePaymentAuthorizationsRequest = exports.GetRemotePaymentAuthorizationsRequest = exports.GetChargerUiConfigResponse = exports.GetChargerUiConfigRequest = exports.GetUiConfigResponse = exports.GetUiConfigRequest = exports.GetThemeResponse = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const timestamp_1 = require("../google/protobuf/timestamp");
const charger_1 = require("./charger");
const charging_session_attempt_1 = require("./charging-session-attempt");
const money_1 = require("./money");
exports.protobufPackage = "powernode";
/** A ports's availability status */
var ChargerAvailability;
(function (ChargerAvailability) {
    ChargerAvailability[ChargerAvailability["UNAVAILABLE"] = 0] = "UNAVAILABLE";
    ChargerAvailability[ChargerAvailability["AVAILABLE"] = 1] = "AVAILABLE";
    ChargerAvailability[ChargerAvailability["IN_USE"] = 2] = "IN_USE";
    ChargerAvailability[ChargerAvailability["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ChargerAvailability = exports.ChargerAvailability || (exports.ChargerAvailability = {}));
function chargerAvailabilityFromJSON(object) {
    switch (object) {
        case 0:
        case "UNAVAILABLE":
            return ChargerAvailability.UNAVAILABLE;
        case 1:
        case "AVAILABLE":
            return ChargerAvailability.AVAILABLE;
        case 2:
        case "IN_USE":
            return ChargerAvailability.IN_USE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ChargerAvailability.UNRECOGNIZED;
    }
}
exports.chargerAvailabilityFromJSON = chargerAvailabilityFromJSON;
function chargerAvailabilityToJSON(object) {
    switch (object) {
        case ChargerAvailability.UNAVAILABLE:
            return "UNAVAILABLE";
        case ChargerAvailability.AVAILABLE:
            return "AVAILABLE";
        case ChargerAvailability.IN_USE:
            return "IN_USE";
        case ChargerAvailability.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.chargerAvailabilityToJSON = chargerAvailabilityToJSON;
/**
 * WMO-based weather interpretation codes.
 *
 * Numeric values match WMO weather codes. This is a subset of the full WMO table,
 * selected based on our weather provider's current capabilities.
 */
var WeatherCode;
(function (WeatherCode) {
    WeatherCode[WeatherCode["WEATHER_CODE_CLEAR_SKY"] = 0] = "WEATHER_CODE_CLEAR_SKY";
    WeatherCode[WeatherCode["WEATHER_CODE_MAINLY_CLEAR"] = 1] = "WEATHER_CODE_MAINLY_CLEAR";
    WeatherCode[WeatherCode["WEATHER_CODE_PARTLY_CLOUDY"] = 2] = "WEATHER_CODE_PARTLY_CLOUDY";
    WeatherCode[WeatherCode["WEATHER_CODE_OVERCAST"] = 3] = "WEATHER_CODE_OVERCAST";
    WeatherCode[WeatherCode["WEATHER_CODE_FOG"] = 45] = "WEATHER_CODE_FOG";
    WeatherCode[WeatherCode["WEATHER_CODE_DEPOSITING_RIME_FOG"] = 48] = "WEATHER_CODE_DEPOSITING_RIME_FOG";
    WeatherCode[WeatherCode["WEATHER_CODE_LIGHT_DRIZZLE"] = 51] = "WEATHER_CODE_LIGHT_DRIZZLE";
    WeatherCode[WeatherCode["WEATHER_CODE_MODERATE_DRIZZLE"] = 53] = "WEATHER_CODE_MODERATE_DRIZZLE";
    WeatherCode[WeatherCode["WEATHER_CODE_DENSE_DRIZZLE"] = 55] = "WEATHER_CODE_DENSE_DRIZZLE";
    WeatherCode[WeatherCode["WEATHER_CODE_LIGHT_FREEZING_DRIZZLE"] = 56] = "WEATHER_CODE_LIGHT_FREEZING_DRIZZLE";
    WeatherCode[WeatherCode["WEATHER_CODE_DENSE_FREEZING_DRIZZLE"] = 57] = "WEATHER_CODE_DENSE_FREEZING_DRIZZLE";
    WeatherCode[WeatherCode["WEATHER_CODE_SLIGHT_RAIN"] = 61] = "WEATHER_CODE_SLIGHT_RAIN";
    WeatherCode[WeatherCode["WEATHER_CODE_MODERATE_RAIN"] = 63] = "WEATHER_CODE_MODERATE_RAIN";
    WeatherCode[WeatherCode["WEATHER_CODE_HEAVY_RAIN"] = 65] = "WEATHER_CODE_HEAVY_RAIN";
    WeatherCode[WeatherCode["WEATHER_CODE_LIGHT_FREEZING_RAIN"] = 66] = "WEATHER_CODE_LIGHT_FREEZING_RAIN";
    WeatherCode[WeatherCode["WEATHER_CODE_HEAVY_FREEZING_RAIN"] = 67] = "WEATHER_CODE_HEAVY_FREEZING_RAIN";
    WeatherCode[WeatherCode["WEATHER_CODE_SLIGHT_SNOWFALL"] = 71] = "WEATHER_CODE_SLIGHT_SNOWFALL";
    WeatherCode[WeatherCode["WEATHER_CODE_MODERATE_SNOWFALL"] = 73] = "WEATHER_CODE_MODERATE_SNOWFALL";
    WeatherCode[WeatherCode["WEATHER_CODE_HEAVY_SNOWFALL"] = 75] = "WEATHER_CODE_HEAVY_SNOWFALL";
    WeatherCode[WeatherCode["WEATHER_CODE_SNOW_GRAINS"] = 77] = "WEATHER_CODE_SNOW_GRAINS";
    WeatherCode[WeatherCode["WEATHER_CODE_SLIGHT_RAIN_SHOWERS"] = 80] = "WEATHER_CODE_SLIGHT_RAIN_SHOWERS";
    WeatherCode[WeatherCode["WEATHER_CODE_MODERATE_RAIN_SHOWERS"] = 81] = "WEATHER_CODE_MODERATE_RAIN_SHOWERS";
    WeatherCode[WeatherCode["WEATHER_CODE_VIOLENT_RAIN_SHOWERS"] = 82] = "WEATHER_CODE_VIOLENT_RAIN_SHOWERS";
    WeatherCode[WeatherCode["WEATHER_CODE_SLIGHT_SNOW_SHOWERS"] = 85] = "WEATHER_CODE_SLIGHT_SNOW_SHOWERS";
    WeatherCode[WeatherCode["WEATHER_CODE_HEAVY_SNOW_SHOWERS"] = 86] = "WEATHER_CODE_HEAVY_SNOW_SHOWERS";
    WeatherCode[WeatherCode["WEATHER_CODE_SLIGHT_OR_MODERATE_THUNDERSTORM"] = 95] = "WEATHER_CODE_SLIGHT_OR_MODERATE_THUNDERSTORM";
    WeatherCode[WeatherCode["WEATHER_CODE_THUNDERSTORM_WITH_SLIGHT_HAIL"] = 96] = "WEATHER_CODE_THUNDERSTORM_WITH_SLIGHT_HAIL";
    WeatherCode[WeatherCode["WEATHER_CODE_THUNDERSTORM_WITH_HEAVY_HAIL"] = 99] = "WEATHER_CODE_THUNDERSTORM_WITH_HEAVY_HAIL";
    WeatherCode[WeatherCode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(WeatherCode = exports.WeatherCode || (exports.WeatherCode = {}));
function weatherCodeFromJSON(object) {
    switch (object) {
        case 0:
        case "WEATHER_CODE_CLEAR_SKY":
            return WeatherCode.WEATHER_CODE_CLEAR_SKY;
        case 1:
        case "WEATHER_CODE_MAINLY_CLEAR":
            return WeatherCode.WEATHER_CODE_MAINLY_CLEAR;
        case 2:
        case "WEATHER_CODE_PARTLY_CLOUDY":
            return WeatherCode.WEATHER_CODE_PARTLY_CLOUDY;
        case 3:
        case "WEATHER_CODE_OVERCAST":
            return WeatherCode.WEATHER_CODE_OVERCAST;
        case 45:
        case "WEATHER_CODE_FOG":
            return WeatherCode.WEATHER_CODE_FOG;
        case 48:
        case "WEATHER_CODE_DEPOSITING_RIME_FOG":
            return WeatherCode.WEATHER_CODE_DEPOSITING_RIME_FOG;
        case 51:
        case "WEATHER_CODE_LIGHT_DRIZZLE":
            return WeatherCode.WEATHER_CODE_LIGHT_DRIZZLE;
        case 53:
        case "WEATHER_CODE_MODERATE_DRIZZLE":
            return WeatherCode.WEATHER_CODE_MODERATE_DRIZZLE;
        case 55:
        case "WEATHER_CODE_DENSE_DRIZZLE":
            return WeatherCode.WEATHER_CODE_DENSE_DRIZZLE;
        case 56:
        case "WEATHER_CODE_LIGHT_FREEZING_DRIZZLE":
            return WeatherCode.WEATHER_CODE_LIGHT_FREEZING_DRIZZLE;
        case 57:
        case "WEATHER_CODE_DENSE_FREEZING_DRIZZLE":
            return WeatherCode.WEATHER_CODE_DENSE_FREEZING_DRIZZLE;
        case 61:
        case "WEATHER_CODE_SLIGHT_RAIN":
            return WeatherCode.WEATHER_CODE_SLIGHT_RAIN;
        case 63:
        case "WEATHER_CODE_MODERATE_RAIN":
            return WeatherCode.WEATHER_CODE_MODERATE_RAIN;
        case 65:
        case "WEATHER_CODE_HEAVY_RAIN":
            return WeatherCode.WEATHER_CODE_HEAVY_RAIN;
        case 66:
        case "WEATHER_CODE_LIGHT_FREEZING_RAIN":
            return WeatherCode.WEATHER_CODE_LIGHT_FREEZING_RAIN;
        case 67:
        case "WEATHER_CODE_HEAVY_FREEZING_RAIN":
            return WeatherCode.WEATHER_CODE_HEAVY_FREEZING_RAIN;
        case 71:
        case "WEATHER_CODE_SLIGHT_SNOWFALL":
            return WeatherCode.WEATHER_CODE_SLIGHT_SNOWFALL;
        case 73:
        case "WEATHER_CODE_MODERATE_SNOWFALL":
            return WeatherCode.WEATHER_CODE_MODERATE_SNOWFALL;
        case 75:
        case "WEATHER_CODE_HEAVY_SNOWFALL":
            return WeatherCode.WEATHER_CODE_HEAVY_SNOWFALL;
        case 77:
        case "WEATHER_CODE_SNOW_GRAINS":
            return WeatherCode.WEATHER_CODE_SNOW_GRAINS;
        case 80:
        case "WEATHER_CODE_SLIGHT_RAIN_SHOWERS":
            return WeatherCode.WEATHER_CODE_SLIGHT_RAIN_SHOWERS;
        case 81:
        case "WEATHER_CODE_MODERATE_RAIN_SHOWERS":
            return WeatherCode.WEATHER_CODE_MODERATE_RAIN_SHOWERS;
        case 82:
        case "WEATHER_CODE_VIOLENT_RAIN_SHOWERS":
            return WeatherCode.WEATHER_CODE_VIOLENT_RAIN_SHOWERS;
        case 85:
        case "WEATHER_CODE_SLIGHT_SNOW_SHOWERS":
            return WeatherCode.WEATHER_CODE_SLIGHT_SNOW_SHOWERS;
        case 86:
        case "WEATHER_CODE_HEAVY_SNOW_SHOWERS":
            return WeatherCode.WEATHER_CODE_HEAVY_SNOW_SHOWERS;
        case 95:
        case "WEATHER_CODE_SLIGHT_OR_MODERATE_THUNDERSTORM":
            return WeatherCode.WEATHER_CODE_SLIGHT_OR_MODERATE_THUNDERSTORM;
        case 96:
        case "WEATHER_CODE_THUNDERSTORM_WITH_SLIGHT_HAIL":
            return WeatherCode.WEATHER_CODE_THUNDERSTORM_WITH_SLIGHT_HAIL;
        case 99:
        case "WEATHER_CODE_THUNDERSTORM_WITH_HEAVY_HAIL":
            return WeatherCode.WEATHER_CODE_THUNDERSTORM_WITH_HEAVY_HAIL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return WeatherCode.UNRECOGNIZED;
    }
}
exports.weatherCodeFromJSON = weatherCodeFromJSON;
function weatherCodeToJSON(object) {
    switch (object) {
        case WeatherCode.WEATHER_CODE_CLEAR_SKY:
            return "WEATHER_CODE_CLEAR_SKY";
        case WeatherCode.WEATHER_CODE_MAINLY_CLEAR:
            return "WEATHER_CODE_MAINLY_CLEAR";
        case WeatherCode.WEATHER_CODE_PARTLY_CLOUDY:
            return "WEATHER_CODE_PARTLY_CLOUDY";
        case WeatherCode.WEATHER_CODE_OVERCAST:
            return "WEATHER_CODE_OVERCAST";
        case WeatherCode.WEATHER_CODE_FOG:
            return "WEATHER_CODE_FOG";
        case WeatherCode.WEATHER_CODE_DEPOSITING_RIME_FOG:
            return "WEATHER_CODE_DEPOSITING_RIME_FOG";
        case WeatherCode.WEATHER_CODE_LIGHT_DRIZZLE:
            return "WEATHER_CODE_LIGHT_DRIZZLE";
        case WeatherCode.WEATHER_CODE_MODERATE_DRIZZLE:
            return "WEATHER_CODE_MODERATE_DRIZZLE";
        case WeatherCode.WEATHER_CODE_DENSE_DRIZZLE:
            return "WEATHER_CODE_DENSE_DRIZZLE";
        case WeatherCode.WEATHER_CODE_LIGHT_FREEZING_DRIZZLE:
            return "WEATHER_CODE_LIGHT_FREEZING_DRIZZLE";
        case WeatherCode.WEATHER_CODE_DENSE_FREEZING_DRIZZLE:
            return "WEATHER_CODE_DENSE_FREEZING_DRIZZLE";
        case WeatherCode.WEATHER_CODE_SLIGHT_RAIN:
            return "WEATHER_CODE_SLIGHT_RAIN";
        case WeatherCode.WEATHER_CODE_MODERATE_RAIN:
            return "WEATHER_CODE_MODERATE_RAIN";
        case WeatherCode.WEATHER_CODE_HEAVY_RAIN:
            return "WEATHER_CODE_HEAVY_RAIN";
        case WeatherCode.WEATHER_CODE_LIGHT_FREEZING_RAIN:
            return "WEATHER_CODE_LIGHT_FREEZING_RAIN";
        case WeatherCode.WEATHER_CODE_HEAVY_FREEZING_RAIN:
            return "WEATHER_CODE_HEAVY_FREEZING_RAIN";
        case WeatherCode.WEATHER_CODE_SLIGHT_SNOWFALL:
            return "WEATHER_CODE_SLIGHT_SNOWFALL";
        case WeatherCode.WEATHER_CODE_MODERATE_SNOWFALL:
            return "WEATHER_CODE_MODERATE_SNOWFALL";
        case WeatherCode.WEATHER_CODE_HEAVY_SNOWFALL:
            return "WEATHER_CODE_HEAVY_SNOWFALL";
        case WeatherCode.WEATHER_CODE_SNOW_GRAINS:
            return "WEATHER_CODE_SNOW_GRAINS";
        case WeatherCode.WEATHER_CODE_SLIGHT_RAIN_SHOWERS:
            return "WEATHER_CODE_SLIGHT_RAIN_SHOWERS";
        case WeatherCode.WEATHER_CODE_MODERATE_RAIN_SHOWERS:
            return "WEATHER_CODE_MODERATE_RAIN_SHOWERS";
        case WeatherCode.WEATHER_CODE_VIOLENT_RAIN_SHOWERS:
            return "WEATHER_CODE_VIOLENT_RAIN_SHOWERS";
        case WeatherCode.WEATHER_CODE_SLIGHT_SNOW_SHOWERS:
            return "WEATHER_CODE_SLIGHT_SNOW_SHOWERS";
        case WeatherCode.WEATHER_CODE_HEAVY_SNOW_SHOWERS:
            return "WEATHER_CODE_HEAVY_SNOW_SHOWERS";
        case WeatherCode.WEATHER_CODE_SLIGHT_OR_MODERATE_THUNDERSTORM:
            return "WEATHER_CODE_SLIGHT_OR_MODERATE_THUNDERSTORM";
        case WeatherCode.WEATHER_CODE_THUNDERSTORM_WITH_SLIGHT_HAIL:
            return "WEATHER_CODE_THUNDERSTORM_WITH_SLIGHT_HAIL";
        case WeatherCode.WEATHER_CODE_THUNDERSTORM_WITH_HEAVY_HAIL:
            return "WEATHER_CODE_THUNDERSTORM_WITH_HEAVY_HAIL";
        case WeatherCode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.weatherCodeToJSON = weatherCodeToJSON;
/** The status of the battery. */
var BatteryStatus;
(function (BatteryStatus) {
    BatteryStatus[BatteryStatus["IDLE"] = 0] = "IDLE";
    BatteryStatus[BatteryStatus["CHARGING"] = 1] = "CHARGING";
    BatteryStatus[BatteryStatus["DISCHARGING"] = 2] = "DISCHARGING";
    BatteryStatus[BatteryStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(BatteryStatus = exports.BatteryStatus || (exports.BatteryStatus = {}));
function batteryStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "IDLE":
            return BatteryStatus.IDLE;
        case 1:
        case "CHARGING":
            return BatteryStatus.CHARGING;
        case 2:
        case "DISCHARGING":
            return BatteryStatus.DISCHARGING;
        case -1:
        case "UNRECOGNIZED":
        default:
            return BatteryStatus.UNRECOGNIZED;
    }
}
exports.batteryStatusFromJSON = batteryStatusFromJSON;
function batteryStatusToJSON(object) {
    switch (object) {
        case BatteryStatus.IDLE:
            return "IDLE";
        case BatteryStatus.CHARGING:
            return "CHARGING";
        case BatteryStatus.DISCHARGING:
            return "DISCHARGING";
        case BatteryStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.batteryStatusToJSON = batteryStatusToJSON;
/** The status of powernode. */
var PowernodeStatus;
(function (PowernodeStatus) {
    PowernodeStatus[PowernodeStatus["ONLINE"] = 0] = "ONLINE";
    PowernodeStatus[PowernodeStatus["MAINTENANCE"] = 1] = "MAINTENANCE";
    PowernodeStatus[PowernodeStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PowernodeStatus = exports.PowernodeStatus || (exports.PowernodeStatus = {}));
function powernodeStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "ONLINE":
            return PowernodeStatus.ONLINE;
        case 1:
        case "MAINTENANCE":
            return PowernodeStatus.MAINTENANCE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return PowernodeStatus.UNRECOGNIZED;
    }
}
exports.powernodeStatusFromJSON = powernodeStatusFromJSON;
function powernodeStatusToJSON(object) {
    switch (object) {
        case PowernodeStatus.ONLINE:
            return "ONLINE";
        case PowernodeStatus.MAINTENANCE:
            return "MAINTENANCE";
        case PowernodeStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.powernodeStatusToJSON = powernodeStatusToJSON;
var EntityType;
(function (EntityType) {
    EntityType[EntityType["CHARGER"] = 0] = "CHARGER";
    EntityType[EntityType["POWERNODE"] = 1] = "POWERNODE";
    EntityType[EntityType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(EntityType = exports.EntityType || (exports.EntityType = {}));
function entityTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "CHARGER":
            return EntityType.CHARGER;
        case 1:
        case "POWERNODE":
            return EntityType.POWERNODE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return EntityType.UNRECOGNIZED;
    }
}
exports.entityTypeFromJSON = entityTypeFromJSON;
function entityTypeToJSON(object) {
    switch (object) {
        case EntityType.CHARGER:
            return "CHARGER";
        case EntityType.POWERNODE:
            return "POWERNODE";
        case EntityType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.entityTypeToJSON = entityTypeToJSON;
var RfidType;
(function (RfidType) {
    RfidType[RfidType["RFID_AUTH_FAILED"] = 0] = "RFID_AUTH_FAILED";
    RfidType[RfidType["RFID_AUTH_WEX"] = 1] = "RFID_AUTH_WEX";
    RfidType[RfidType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(RfidType = exports.RfidType || (exports.RfidType = {}));
function rfidTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "RFID_AUTH_FAILED":
            return RfidType.RFID_AUTH_FAILED;
        case 1:
        case "RFID_AUTH_WEX":
            return RfidType.RFID_AUTH_WEX;
        case -1:
        case "UNRECOGNIZED":
        default:
            return RfidType.UNRECOGNIZED;
    }
}
exports.rfidTypeFromJSON = rfidTypeFromJSON;
function rfidTypeToJSON(object) {
    switch (object) {
        case RfidType.RFID_AUTH_FAILED:
            return "RFID_AUTH_FAILED";
        case RfidType.RFID_AUTH_WEX:
            return "RFID_AUTH_WEX";
        case RfidType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.rfidTypeToJSON = rfidTypeToJSON;
function createBaseRegisterTransactionRequest() {
    return {
        chargerOcppId: "",
        consumedEnergyKwh: 0,
        chargingSessionStartUtc: undefined,
        chargingSessionEndUtc: undefined,
        money: undefined,
        costBreakdown: undefined,
        successful: false,
        uniqueReference: "",
        peakPowerKw: 0,
        chargingDetailsJson: "",
        totalizerEndKwh: 0,
        portId: 0,
        faultCode: "",
        transactionId: "",
        paymentToken: "",
        evccid: "",
        lowRateChargingDetailsJson: "",
        authorizationType: 0,
        chargerSwVersion: "",
        chargerFwVersion: "",
        powerNodeSwVersion: "",
        authorizationStatus: 0,
        stopReason: "",
        freeReason: 0,
        ocpiTrackingId: undefined,
    };
}
exports.RegisterTransactionRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.chargerOcppId !== "") {
            writer.uint32(18).string(message.chargerOcppId);
        }
        if (message.consumedEnergyKwh !== 0) {
            writer.uint32(29).float(message.consumedEnergyKwh);
        }
        if (message.chargingSessionStartUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.chargingSessionStartUtc), writer.uint32(34).fork()).join();
        }
        if (message.chargingSessionEndUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.chargingSessionEndUtc), writer.uint32(42).fork()).join();
        }
        if (message.money !== undefined) {
            money_1.Money.encode(message.money, writer.uint32(50).fork()).join();
        }
        if (message.costBreakdown !== undefined) {
            money_1.ChargeBreakdown.encode(message.costBreakdown, writer.uint32(114).fork()).join();
        }
        if (message.successful !== false) {
            writer.uint32(56).bool(message.successful);
        }
        if (message.uniqueReference !== "") {
            writer.uint32(66).string(message.uniqueReference);
        }
        if (message.peakPowerKw !== 0) {
            writer.uint32(77).float(message.peakPowerKw);
        }
        if (message.chargingDetailsJson !== "") {
            writer.uint32(82).string(message.chargingDetailsJson);
        }
        if (message.totalizerEndKwh !== 0) {
            writer.uint32(93).float(message.totalizerEndKwh);
        }
        if (message.portId !== 0) {
            writer.uint32(96).uint32(message.portId);
        }
        if (message.faultCode !== "") {
            writer.uint32(106).string(message.faultCode);
        }
        if (message.transactionId !== "") {
            writer.uint32(122).string(message.transactionId);
        }
        if (message.paymentToken !== "") {
            writer.uint32(130).string(message.paymentToken);
        }
        if (message.evccid !== "") {
            writer.uint32(138).string(message.evccid);
        }
        if (message.lowRateChargingDetailsJson !== "") {
            writer.uint32(146).string(message.lowRateChargingDetailsJson);
        }
        if (message.authorizationType !== 0) {
            writer.uint32(152).int32(message.authorizationType);
        }
        if (message.chargerSwVersion !== "") {
            writer.uint32(162).string(message.chargerSwVersion);
        }
        if (message.chargerFwVersion !== "") {
            writer.uint32(170).string(message.chargerFwVersion);
        }
        if (message.powerNodeSwVersion !== "") {
            writer.uint32(178).string(message.powerNodeSwVersion);
        }
        if (message.authorizationStatus !== 0) {
            writer.uint32(184).int32(message.authorizationStatus);
        }
        if (message.stopReason !== "") {
            writer.uint32(194).string(message.stopReason);
        }
        if (message.freeReason !== 0) {
            writer.uint32(200).int32(message.freeReason);
        }
        if (message.ocpiTrackingId !== undefined) {
            writer.uint32(210).string(message.ocpiTrackingId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRegisterTransactionRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.chargerOcppId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 29) {
                        break;
                    }
                    message.consumedEnergyKwh = reader.float();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.chargingSessionStartUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.chargingSessionEndUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.money = money_1.Money.decode(reader, reader.uint32());
                    continue;
                }
                case 14: {
                    if (tag !== 114) {
                        break;
                    }
                    message.costBreakdown = money_1.ChargeBreakdown.decode(reader, reader.uint32());
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.successful = reader.bool();
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.uniqueReference = reader.string();
                    continue;
                }
                case 9: {
                    if (tag !== 77) {
                        break;
                    }
                    message.peakPowerKw = reader.float();
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.chargingDetailsJson = reader.string();
                    continue;
                }
                case 11: {
                    if (tag !== 93) {
                        break;
                    }
                    message.totalizerEndKwh = reader.float();
                    continue;
                }
                case 12: {
                    if (tag !== 96) {
                        break;
                    }
                    message.portId = reader.uint32();
                    continue;
                }
                case 13: {
                    if (tag !== 106) {
                        break;
                    }
                    message.faultCode = reader.string();
                    continue;
                }
                case 15: {
                    if (tag !== 122) {
                        break;
                    }
                    message.transactionId = reader.string();
                    continue;
                }
                case 16: {
                    if (tag !== 130) {
                        break;
                    }
                    message.paymentToken = reader.string();
                    continue;
                }
                case 17: {
                    if (tag !== 138) {
                        break;
                    }
                    message.evccid = reader.string();
                    continue;
                }
                case 18: {
                    if (tag !== 146) {
                        break;
                    }
                    message.lowRateChargingDetailsJson = reader.string();
                    continue;
                }
                case 19: {
                    if (tag !== 152) {
                        break;
                    }
                    message.authorizationType = reader.int32();
                    continue;
                }
                case 20: {
                    if (tag !== 162) {
                        break;
                    }
                    message.chargerSwVersion = reader.string();
                    continue;
                }
                case 21: {
                    if (tag !== 170) {
                        break;
                    }
                    message.chargerFwVersion = reader.string();
                    continue;
                }
                case 22: {
                    if (tag !== 178) {
                        break;
                    }
                    message.powerNodeSwVersion = reader.string();
                    continue;
                }
                case 23: {
                    if (tag !== 184) {
                        break;
                    }
                    message.authorizationStatus = reader.int32();
                    continue;
                }
                case 24: {
                    if (tag !== 194) {
                        break;
                    }
                    message.stopReason = reader.string();
                    continue;
                }
                case 25: {
                    if (tag !== 200) {
                        break;
                    }
                    message.freeReason = reader.int32();
                    continue;
                }
                case 26: {
                    if (tag !== 210) {
                        break;
                    }
                    message.ocpiTrackingId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chargerOcppId: isSet(object.chargerOcppId)
                ? globalThis.String(object.chargerOcppId)
                : isSet(object.charger_ocpp_id)
                    ? globalThis.String(object.charger_ocpp_id)
                    : "",
            consumedEnergyKwh: isSet(object.consumedEnergyKwh)
                ? globalThis.Number(object.consumedEnergyKwh)
                : isSet(object.consumed_energy_kwh)
                    ? globalThis.Number(object.consumed_energy_kwh)
                    : 0,
            chargingSessionStartUtc: isSet(object.chargingSessionStartUtc)
                ? fromJsonTimestamp(object.chargingSessionStartUtc)
                : isSet(object.charging_session_start_utc)
                    ? fromJsonTimestamp(object.charging_session_start_utc)
                    : undefined,
            chargingSessionEndUtc: isSet(object.chargingSessionEndUtc)
                ? fromJsonTimestamp(object.chargingSessionEndUtc)
                : isSet(object.charging_session_end_utc)
                    ? fromJsonTimestamp(object.charging_session_end_utc)
                    : undefined,
            money: isSet(object.money) ? money_1.Money.fromJSON(object.money) : undefined,
            costBreakdown: isSet(object.costBreakdown)
                ? money_1.ChargeBreakdown.fromJSON(object.costBreakdown)
                : isSet(object.cost_breakdown)
                    ? money_1.ChargeBreakdown.fromJSON(object.cost_breakdown)
                    : undefined,
            successful: isSet(object.successful)
                ? globalThis.Boolean(object.successful)
                : false,
            uniqueReference: isSet(object.uniqueReference)
                ? globalThis.String(object.uniqueReference)
                : isSet(object.unique_reference)
                    ? globalThis.String(object.unique_reference)
                    : "",
            peakPowerKw: isSet(object.peakPowerKw)
                ? globalThis.Number(object.peakPowerKw)
                : isSet(object.peak_power_kw)
                    ? globalThis.Number(object.peak_power_kw)
                    : 0,
            chargingDetailsJson: isSet(object.chargingDetailsJson)
                ? globalThis.String(object.chargingDetailsJson)
                : isSet(object.charging_details_json)
                    ? globalThis.String(object.charging_details_json)
                    : "",
            totalizerEndKwh: isSet(object.totalizerEndKwh)
                ? globalThis.Number(object.totalizerEndKwh)
                : isSet(object.totalizer_end_kwh)
                    ? globalThis.Number(object.totalizer_end_kwh)
                    : 0,
            portId: isSet(object.portId)
                ? globalThis.Number(object.portId)
                : isSet(object.port_id)
                    ? globalThis.Number(object.port_id)
                    : 0,
            faultCode: isSet(object.faultCode)
                ? globalThis.String(object.faultCode)
                : isSet(object.fault_code)
                    ? globalThis.String(object.fault_code)
                    : "",
            transactionId: isSet(object.transactionId)
                ? globalThis.String(object.transactionId)
                : isSet(object.transaction_id)
                    ? globalThis.String(object.transaction_id)
                    : "",
            paymentToken: isSet(object.paymentToken)
                ? globalThis.String(object.paymentToken)
                : isSet(object.payment_token)
                    ? globalThis.String(object.payment_token)
                    : "",
            evccid: isSet(object.evccid) ? globalThis.String(object.evccid) : "",
            lowRateChargingDetailsJson: isSet(object.lowRateChargingDetailsJson)
                ? globalThis.String(object.lowRateChargingDetailsJson)
                : isSet(object.low_rate_charging_details_json)
                    ? globalThis.String(object.low_rate_charging_details_json)
                    : "",
            authorizationType: isSet(object.authorizationType)
                ? (0, money_1.paymentAuthorizationTypeFromJSON)(object.authorizationType)
                : isSet(object.authorization_type)
                    ? (0, money_1.paymentAuthorizationTypeFromJSON)(object.authorization_type)
                    : 0,
            chargerSwVersion: isSet(object.chargerSwVersion)
                ? globalThis.String(object.chargerSwVersion)
                : isSet(object.charger_sw_version)
                    ? globalThis.String(object.charger_sw_version)
                    : "",
            chargerFwVersion: isSet(object.chargerFwVersion)
                ? globalThis.String(object.chargerFwVersion)
                : isSet(object.charger_fw_version)
                    ? globalThis.String(object.charger_fw_version)
                    : "",
            powerNodeSwVersion: isSet(object.powerNodeSwVersion)
                ? globalThis.String(object.powerNodeSwVersion)
                : isSet(object.power_node_sw_version)
                    ? globalThis.String(object.power_node_sw_version)
                    : "",
            authorizationStatus: isSet(object.authorizationStatus)
                ? (0, money_1.paymentAuthorizationStatusFromJSON)(object.authorizationStatus)
                : isSet(object.authorization_status)
                    ? (0, money_1.paymentAuthorizationStatusFromJSON)(object.authorization_status)
                    : 0,
            stopReason: isSet(object.stopReason)
                ? globalThis.String(object.stopReason)
                : isSet(object.stop_reason)
                    ? globalThis.String(object.stop_reason)
                    : "",
            freeReason: isSet(object.freeReason)
                ? (0, money_1.freeReasonFromJSON)(object.freeReason)
                : isSet(object.free_reason)
                    ? (0, money_1.freeReasonFromJSON)(object.free_reason)
                    : 0,
            ocpiTrackingId: isSet(object.ocpiTrackingId)
                ? globalThis.String(object.ocpiTrackingId)
                : isSet(object.ocpi_tracking_id)
                    ? globalThis.String(object.ocpi_tracking_id)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chargerOcppId !== "") {
            obj.chargerOcppId = message.chargerOcppId;
        }
        if (message.consumedEnergyKwh !== 0) {
            obj.consumedEnergyKwh = message.consumedEnergyKwh;
        }
        if (message.chargingSessionStartUtc !== undefined) {
            obj.chargingSessionStartUtc =
                message.chargingSessionStartUtc.toISOString();
        }
        if (message.chargingSessionEndUtc !== undefined) {
            obj.chargingSessionEndUtc = message.chargingSessionEndUtc.toISOString();
        }
        if (message.money !== undefined) {
            obj.money = money_1.Money.toJSON(message.money);
        }
        if (message.costBreakdown !== undefined) {
            obj.costBreakdown = money_1.ChargeBreakdown.toJSON(message.costBreakdown);
        }
        if (message.successful !== false) {
            obj.successful = message.successful;
        }
        if (message.uniqueReference !== "") {
            obj.uniqueReference = message.uniqueReference;
        }
        if (message.peakPowerKw !== 0) {
            obj.peakPowerKw = message.peakPowerKw;
        }
        if (message.chargingDetailsJson !== "") {
            obj.chargingDetailsJson = message.chargingDetailsJson;
        }
        if (message.totalizerEndKwh !== 0) {
            obj.totalizerEndKwh = message.totalizerEndKwh;
        }
        if (message.portId !== 0) {
            obj.portId = Math.round(message.portId);
        }
        if (message.faultCode !== "") {
            obj.faultCode = message.faultCode;
        }
        if (message.transactionId !== "") {
            obj.transactionId = message.transactionId;
        }
        if (message.paymentToken !== "") {
            obj.paymentToken = message.paymentToken;
        }
        if (message.evccid !== "") {
            obj.evccid = message.evccid;
        }
        if (message.lowRateChargingDetailsJson !== "") {
            obj.lowRateChargingDetailsJson = message.lowRateChargingDetailsJson;
        }
        if (message.authorizationType !== 0) {
            obj.authorizationType = (0, money_1.paymentAuthorizationTypeToJSON)(message.authorizationType);
        }
        if (message.chargerSwVersion !== "") {
            obj.chargerSwVersion = message.chargerSwVersion;
        }
        if (message.chargerFwVersion !== "") {
            obj.chargerFwVersion = message.chargerFwVersion;
        }
        if (message.powerNodeSwVersion !== "") {
            obj.powerNodeSwVersion = message.powerNodeSwVersion;
        }
        if (message.authorizationStatus !== 0) {
            obj.authorizationStatus = (0, money_1.paymentAuthorizationStatusToJSON)(message.authorizationStatus);
        }
        if (message.stopReason !== "") {
            obj.stopReason = message.stopReason;
        }
        if (message.freeReason !== 0) {
            obj.freeReason = (0, money_1.freeReasonToJSON)(message.freeReason);
        }
        if (message.ocpiTrackingId !== undefined) {
            obj.ocpiTrackingId = message.ocpiTrackingId;
        }
        return obj;
    },
    create(base) {
        return exports.RegisterTransactionRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRegisterTransactionRequest();
        message.chargerOcppId = object.chargerOcppId ?? "";
        message.consumedEnergyKwh = object.consumedEnergyKwh ?? 0;
        message.chargingSessionStartUtc =
            object.chargingSessionStartUtc ?? undefined;
        message.chargingSessionEndUtc = object.chargingSessionEndUtc ?? undefined;
        message.money =
            object.money !== undefined && object.money !== null
                ? money_1.Money.fromPartial(object.money)
                : undefined;
        message.costBreakdown =
            object.costBreakdown !== undefined && object.costBreakdown !== null
                ? money_1.ChargeBreakdown.fromPartial(object.costBreakdown)
                : undefined;
        message.successful = object.successful ?? false;
        message.uniqueReference = object.uniqueReference ?? "";
        message.peakPowerKw = object.peakPowerKw ?? 0;
        message.chargingDetailsJson = object.chargingDetailsJson ?? "";
        message.totalizerEndKwh = object.totalizerEndKwh ?? 0;
        message.portId = object.portId ?? 0;
        message.faultCode = object.faultCode ?? "";
        message.transactionId = object.transactionId ?? "";
        message.paymentToken = object.paymentToken ?? "";
        message.evccid = object.evccid ?? "";
        message.lowRateChargingDetailsJson =
            object.lowRateChargingDetailsJson ?? "";
        message.authorizationType = object.authorizationType ?? 0;
        message.chargerSwVersion = object.chargerSwVersion ?? "";
        message.chargerFwVersion = object.chargerFwVersion ?? "";
        message.powerNodeSwVersion = object.powerNodeSwVersion ?? "";
        message.authorizationStatus = object.authorizationStatus ?? 0;
        message.stopReason = object.stopReason ?? "";
        message.freeReason = object.freeReason ?? 0;
        message.ocpiTrackingId = object.ocpiTrackingId ?? undefined;
        return message;
    },
};
function createBaseUpdateTransactionRequest() {
    return { chargerOcppId: "", transactionId: "", authorizationStatus: 0 };
}
exports.UpdateTransactionRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.chargerOcppId !== "") {
            writer.uint32(10).string(message.chargerOcppId);
        }
        if (message.transactionId !== "") {
            writer.uint32(18).string(message.transactionId);
        }
        if (message.authorizationStatus !== 0) {
            writer.uint32(24).int32(message.authorizationStatus);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateTransactionRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.chargerOcppId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.transactionId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.authorizationStatus = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chargerOcppId: isSet(object.chargerOcppId)
                ? globalThis.String(object.chargerOcppId)
                : isSet(object.charger_ocpp_id)
                    ? globalThis.String(object.charger_ocpp_id)
                    : "",
            transactionId: isSet(object.transactionId)
                ? globalThis.String(object.transactionId)
                : isSet(object.transaction_id)
                    ? globalThis.String(object.transaction_id)
                    : "",
            authorizationStatus: isSet(object.authorizationStatus)
                ? (0, money_1.paymentAuthorizationStatusFromJSON)(object.authorizationStatus)
                : isSet(object.authorization_status)
                    ? (0, money_1.paymentAuthorizationStatusFromJSON)(object.authorization_status)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chargerOcppId !== "") {
            obj.chargerOcppId = message.chargerOcppId;
        }
        if (message.transactionId !== "") {
            obj.transactionId = message.transactionId;
        }
        if (message.authorizationStatus !== 0) {
            obj.authorizationStatus = (0, money_1.paymentAuthorizationStatusToJSON)(message.authorizationStatus);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateTransactionRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateTransactionRequest();
        message.chargerOcppId = object.chargerOcppId ?? "";
        message.transactionId = object.transactionId ?? "";
        message.authorizationStatus = object.authorizationStatus ?? 0;
        return message;
    },
};
function createBaseSyncChargingSessionsRequest() {
    return {
        chargerOcppId: "",
        chargingSessions: [],
        chargingSessionAttempts: [],
        chargingTransactions: [],
        chargingTransactionDetails: [],
        paymentTransactions: [],
        membershipTransactions: [],
    };
}
exports.SyncChargingSessionsRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.chargerOcppId !== "") {
            writer.uint32(10).string(message.chargerOcppId);
        }
        for (const v of message.chargingSessions) {
            charging_session_attempt_1.ChargingSession.encode(v, writer.uint32(18).fork()).join();
        }
        for (const v of message.chargingSessionAttempts) {
            charging_session_attempt_1.ChargingSessionAttempt.encode(v, writer.uint32(26).fork()).join();
        }
        for (const v of message.chargingTransactions) {
            charging_session_attempt_1.ChargingTransaction.encode(v, writer.uint32(34).fork()).join();
        }
        for (const v of message.chargingTransactionDetails) {
            charging_session_attempt_1.ChargingTransactionDetails.encode(v, writer.uint32(42).fork()).join();
        }
        for (const v of message.paymentTransactions) {
            charging_session_attempt_1.PaymentTransaction.encode(v, writer.uint32(50).fork()).join();
        }
        for (const v of message.membershipTransactions) {
            charging_session_attempt_1.MembershipTransaction.encode(v, writer.uint32(58).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSyncChargingSessionsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.chargerOcppId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.chargingSessions.push(charging_session_attempt_1.ChargingSession.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.chargingSessionAttempts.push(charging_session_attempt_1.ChargingSessionAttempt.decode(reader, reader.uint32()));
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.chargingTransactions.push(charging_session_attempt_1.ChargingTransaction.decode(reader, reader.uint32()));
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.chargingTransactionDetails.push(charging_session_attempt_1.ChargingTransactionDetails.decode(reader, reader.uint32()));
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.paymentTransactions.push(charging_session_attempt_1.PaymentTransaction.decode(reader, reader.uint32()));
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.membershipTransactions.push(charging_session_attempt_1.MembershipTransaction.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chargerOcppId: isSet(object.chargerOcppId)
                ? globalThis.String(object.chargerOcppId)
                : isSet(object.charger_ocpp_id)
                    ? globalThis.String(object.charger_ocpp_id)
                    : "",
            chargingSessions: globalThis.Array.isArray(object?.chargingSessions)
                ? object.chargingSessions.map((e) => charging_session_attempt_1.ChargingSession.fromJSON(e))
                : globalThis.Array.isArray(object?.charging_sessions)
                    ? object.charging_sessions.map((e) => charging_session_attempt_1.ChargingSession.fromJSON(e))
                    : [],
            chargingSessionAttempts: globalThis.Array.isArray(object?.chargingSessionAttempts)
                ? object.chargingSessionAttempts.map((e) => charging_session_attempt_1.ChargingSessionAttempt.fromJSON(e))
                : globalThis.Array.isArray(object?.charging_session_attempts)
                    ? object.charging_session_attempts.map((e) => charging_session_attempt_1.ChargingSessionAttempt.fromJSON(e))
                    : [],
            chargingTransactions: globalThis.Array.isArray(object?.chargingTransactions)
                ? object.chargingTransactions.map((e) => charging_session_attempt_1.ChargingTransaction.fromJSON(e))
                : globalThis.Array.isArray(object?.charging_transactions)
                    ? object.charging_transactions.map((e) => charging_session_attempt_1.ChargingTransaction.fromJSON(e))
                    : [],
            chargingTransactionDetails: globalThis.Array.isArray(object?.chargingTransactionDetails)
                ? object.chargingTransactionDetails.map((e) => charging_session_attempt_1.ChargingTransactionDetails.fromJSON(e))
                : globalThis.Array.isArray(object?.charging_transaction_details)
                    ? object.charging_transaction_details.map((e) => charging_session_attempt_1.ChargingTransactionDetails.fromJSON(e))
                    : [],
            paymentTransactions: globalThis.Array.isArray(object?.paymentTransactions)
                ? object.paymentTransactions.map((e) => charging_session_attempt_1.PaymentTransaction.fromJSON(e))
                : globalThis.Array.isArray(object?.payment_transactions)
                    ? object.payment_transactions.map((e) => charging_session_attempt_1.PaymentTransaction.fromJSON(e))
                    : [],
            membershipTransactions: globalThis.Array.isArray(object?.membershipTransactions)
                ? object.membershipTransactions.map((e) => charging_session_attempt_1.MembershipTransaction.fromJSON(e))
                : globalThis.Array.isArray(object?.membership_transactions)
                    ? object.membership_transactions.map((e) => charging_session_attempt_1.MembershipTransaction.fromJSON(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chargerOcppId !== "") {
            obj.chargerOcppId = message.chargerOcppId;
        }
        if (message.chargingSessions?.length) {
            obj.chargingSessions = message.chargingSessions.map((e) => charging_session_attempt_1.ChargingSession.toJSON(e));
        }
        if (message.chargingSessionAttempts?.length) {
            obj.chargingSessionAttempts = message.chargingSessionAttempts.map((e) => charging_session_attempt_1.ChargingSessionAttempt.toJSON(e));
        }
        if (message.chargingTransactions?.length) {
            obj.chargingTransactions = message.chargingTransactions.map((e) => charging_session_attempt_1.ChargingTransaction.toJSON(e));
        }
        if (message.chargingTransactionDetails?.length) {
            obj.chargingTransactionDetails = message.chargingTransactionDetails.map((e) => charging_session_attempt_1.ChargingTransactionDetails.toJSON(e));
        }
        if (message.paymentTransactions?.length) {
            obj.paymentTransactions = message.paymentTransactions.map((e) => charging_session_attempt_1.PaymentTransaction.toJSON(e));
        }
        if (message.membershipTransactions?.length) {
            obj.membershipTransactions = message.membershipTransactions.map((e) => charging_session_attempt_1.MembershipTransaction.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.SyncChargingSessionsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSyncChargingSessionsRequest();
        message.chargerOcppId = object.chargerOcppId ?? "";
        message.chargingSessions =
            object.chargingSessions?.map((e) => charging_session_attempt_1.ChargingSession.fromPartial(e)) ||
                [];
        message.chargingSessionAttempts =
            object.chargingSessionAttempts?.map((e) => charging_session_attempt_1.ChargingSessionAttempt.fromPartial(e)) || [];
        message.chargingTransactions =
            object.chargingTransactions?.map((e) => charging_session_attempt_1.ChargingTransaction.fromPartial(e)) || [];
        message.chargingTransactionDetails =
            object.chargingTransactionDetails?.map((e) => charging_session_attempt_1.ChargingTransactionDetails.fromPartial(e)) || [];
        message.paymentTransactions =
            object.paymentTransactions?.map((e) => charging_session_attempt_1.PaymentTransaction.fromPartial(e)) || [];
        message.membershipTransactions =
            object.membershipTransactions?.map((e) => charging_session_attempt_1.MembershipTransaction.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSyncChargingTransactionDetailsRequest() {
    return { chargerOcppId: "", chargingTransactionDetails: undefined };
}
exports.SyncChargingTransactionDetailsRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.chargerOcppId !== "") {
            writer.uint32(10).string(message.chargerOcppId);
        }
        if (message.chargingTransactionDetails !== undefined) {
            charging_session_attempt_1.ChargingTransactionDetails.encode(message.chargingTransactionDetails, writer.uint32(42).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSyncChargingTransactionDetailsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.chargerOcppId = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.chargingTransactionDetails =
                        charging_session_attempt_1.ChargingTransactionDetails.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chargerOcppId: isSet(object.chargerOcppId)
                ? globalThis.String(object.chargerOcppId)
                : isSet(object.charger_ocpp_id)
                    ? globalThis.String(object.charger_ocpp_id)
                    : "",
            chargingTransactionDetails: isSet(object.chargingTransactionDetails)
                ? charging_session_attempt_1.ChargingTransactionDetails.fromJSON(object.chargingTransactionDetails)
                : isSet(object.charging_transaction_details)
                    ? charging_session_attempt_1.ChargingTransactionDetails.fromJSON(object.charging_transaction_details)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chargerOcppId !== "") {
            obj.chargerOcppId = message.chargerOcppId;
        }
        if (message.chargingTransactionDetails !== undefined) {
            obj.chargingTransactionDetails = charging_session_attempt_1.ChargingTransactionDetails.toJSON(message.chargingTransactionDetails);
        }
        return obj;
    },
    create(base) {
        return exports.SyncChargingTransactionDetailsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSyncChargingTransactionDetailsRequest();
        message.chargerOcppId = object.chargerOcppId ?? "";
        message.chargingTransactionDetails =
            object.chargingTransactionDetails !== undefined &&
                object.chargingTransactionDetails !== null
                ? charging_session_attempt_1.ChargingTransactionDetails.fromPartial(object.chargingTransactionDetails)
                : undefined;
        return message;
    },
};
function createBaseGetConnectedDevicesRequest() {
    return { pnid: 0 };
}
exports.GetConnectedDevicesRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pnid !== 0) {
            writer.uint32(8).int32(message.pnid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetConnectedDevicesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pnid = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { pnid: isSet(object.pnid) ? globalThis.Number(object.pnid) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.pnid !== 0) {
            obj.pnid = Math.round(message.pnid);
        }
        return obj;
    },
    create(base) {
        return exports.GetConnectedDevicesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetConnectedDevicesRequest();
        message.pnid = object.pnid ?? 0;
        return message;
    },
};
function createBaseGetOperationalStatusRequest() {
    return { pnid: 0 };
}
exports.GetOperationalStatusRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pnid !== 0) {
            writer.uint32(8).int32(message.pnid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetOperationalStatusRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pnid = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { pnid: isSet(object.pnid) ? globalThis.Number(object.pnid) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.pnid !== 0) {
            obj.pnid = Math.round(message.pnid);
        }
        return obj;
    },
    create(base) {
        return exports.GetOperationalStatusRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetOperationalStatusRequest();
        message.pnid = object.pnid ?? 0;
        return message;
    },
};
function createBaseChargerConnector() {
    return {
        type: 0,
        maxPowerKw: 0,
        advertisedMaxPowerKw: 0,
        index: 0,
        evseId: undefined,
    };
}
exports.ChargerConnector = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.type !== 0) {
            writer.uint32(8).int32(message.type);
        }
        if (message.maxPowerKw !== 0) {
            writer.uint32(21).float(message.maxPowerKw);
        }
        if (message.advertisedMaxPowerKw !== 0) {
            writer.uint32(29).float(message.advertisedMaxPowerKw);
        }
        if (message.index !== 0) {
            writer.uint32(32).uint32(message.index);
        }
        if (message.evseId !== undefined) {
            writer.uint32(42).string(message.evseId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChargerConnector();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 21) {
                        break;
                    }
                    message.maxPowerKw = reader.float();
                    continue;
                }
                case 3: {
                    if (tag !== 29) {
                        break;
                    }
                    message.advertisedMaxPowerKw = reader.float();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.index = reader.uint32();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.evseId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? (0, charger_1.portTypeFromJSON)(object.type) : 0,
            maxPowerKw: isSet(object.maxPowerKw)
                ? globalThis.Number(object.maxPowerKw)
                : isSet(object.max_power_kw)
                    ? globalThis.Number(object.max_power_kw)
                    : 0,
            advertisedMaxPowerKw: isSet(object.advertisedMaxPowerKw)
                ? globalThis.Number(object.advertisedMaxPowerKw)
                : isSet(object.advertised_max_power_kw)
                    ? globalThis.Number(object.advertised_max_power_kw)
                    : 0,
            index: isSet(object.index) ? globalThis.Number(object.index) : 0,
            evseId: isSet(object.evseId)
                ? globalThis.String(object.evseId)
                : isSet(object.evse_id)
                    ? globalThis.String(object.evse_id)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== 0) {
            obj.type = (0, charger_1.portTypeToJSON)(message.type);
        }
        if (message.maxPowerKw !== 0) {
            obj.maxPowerKw = message.maxPowerKw;
        }
        if (message.advertisedMaxPowerKw !== 0) {
            obj.advertisedMaxPowerKw = message.advertisedMaxPowerKw;
        }
        if (message.index !== 0) {
            obj.index = Math.round(message.index);
        }
        if (message.evseId !== undefined) {
            obj.evseId = message.evseId;
        }
        return obj;
    },
    create(base) {
        return exports.ChargerConnector.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChargerConnector();
        message.type = object.type ?? 0;
        message.maxPowerKw = object.maxPowerKw ?? 0;
        message.advertisedMaxPowerKw = object.advertisedMaxPowerKw ?? 0;
        message.index = object.index ?? 0;
        message.evseId = object.evseId ?? undefined;
        return message;
    },
};
function createBaseVP6800() {
    return {
        terminalId: "",
        environment: 0,
        isPaymentTerminalControl: false,
        paymentTerminalSerialPort: "",
    };
}
exports.VP6800 = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.terminalId !== "") {
            writer.uint32(10).string(message.terminalId);
        }
        if (message.environment !== 0) {
            writer.uint32(16).int32(message.environment);
        }
        if (message.isPaymentTerminalControl !== false) {
            writer.uint32(24).bool(message.isPaymentTerminalControl);
        }
        if (message.paymentTerminalSerialPort !== "") {
            writer.uint32(34).string(message.paymentTerminalSerialPort);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseVP6800();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.terminalId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.environment = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.isPaymentTerminalControl = reader.bool();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.paymentTerminalSerialPort = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            terminalId: isSet(object.terminalId)
                ? globalThis.String(object.terminalId)
                : isSet(object.terminal_id)
                    ? globalThis.String(object.terminal_id)
                    : "",
            environment: isSet(object.environment)
                ? (0, charger_1.paymentEnvironmentFromJSON)(object.environment)
                : 0,
            isPaymentTerminalControl: isSet(object.isPaymentTerminalControl)
                ? globalThis.Boolean(object.isPaymentTerminalControl)
                : isSet(object.is_payment_terminal_control)
                    ? globalThis.Boolean(object.is_payment_terminal_control)
                    : false,
            paymentTerminalSerialPort: isSet(object.paymentTerminalSerialPort)
                ? globalThis.String(object.paymentTerminalSerialPort)
                : isSet(object.payment_terminal_serial_port)
                    ? globalThis.String(object.payment_terminal_serial_port)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.terminalId !== "") {
            obj.terminalId = message.terminalId;
        }
        if (message.environment !== 0) {
            obj.environment = (0, charger_1.paymentEnvironmentToJSON)(message.environment);
        }
        if (message.isPaymentTerminalControl !== false) {
            obj.isPaymentTerminalControl = message.isPaymentTerminalControl;
        }
        if (message.paymentTerminalSerialPort !== "") {
            obj.paymentTerminalSerialPort = message.paymentTerminalSerialPort;
        }
        return obj;
    },
    create(base) {
        return exports.VP6800.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVP6800();
        message.terminalId = object.terminalId ?? "";
        message.environment = object.environment ?? 0;
        message.isPaymentTerminalControl = object.isPaymentTerminalControl ?? false;
        message.paymentTerminalSerialPort = object.paymentTerminalSerialPort ?? "";
        return message;
    },
};
function createBasePayterApolloPolar() {
    return {};
}
exports.PayterApolloPolar = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePayterApolloPolar();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.PayterApolloPolar.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePayterApolloPolar();
        return message;
    },
};
function createBaseKioskV() {
    return { terminalId: "", environment: 0 };
}
exports.KioskV = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.terminalId !== "") {
            writer.uint32(10).string(message.terminalId);
        }
        if (message.environment !== 0) {
            writer.uint32(16).int32(message.environment);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseKioskV();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.terminalId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.environment = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            terminalId: isSet(object.terminalId)
                ? globalThis.String(object.terminalId)
                : isSet(object.terminal_id)
                    ? globalThis.String(object.terminal_id)
                    : "",
            environment: isSet(object.environment)
                ? (0, charger_1.paymentEnvironmentFromJSON)(object.environment)
                : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.terminalId !== "") {
            obj.terminalId = message.terminalId;
        }
        if (message.environment !== 0) {
            obj.environment = (0, charger_1.paymentEnvironmentToJSON)(message.environment);
        }
        return obj;
    },
    create(base) {
        return exports.KioskV.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseKioskV();
        message.terminalId = object.terminalId ?? "";
        message.environment = object.environment ?? 0;
        return message;
    },
};
function createBasePaymentTerminal() {
    return { vp6800: undefined, payterApolloPolar: undefined, kioskV: undefined };
}
exports.PaymentTerminal = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.vp6800 !== undefined) {
            exports.VP6800.encode(message.vp6800, writer.uint32(10).fork()).join();
        }
        if (message.payterApolloPolar !== undefined) {
            exports.PayterApolloPolar.encode(message.payterApolloPolar, writer.uint32(18).fork()).join();
        }
        if (message.kioskV !== undefined) {
            exports.KioskV.encode(message.kioskV, writer.uint32(26).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePaymentTerminal();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.vp6800 = exports.VP6800.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.payterApolloPolar = exports.PayterApolloPolar.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.kioskV = exports.KioskV.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            vp6800: isSet(object.vp6800) ? exports.VP6800.fromJSON(object.vp6800) : undefined,
            payterApolloPolar: isSet(object.payterApolloPolar)
                ? exports.PayterApolloPolar.fromJSON(object.payterApolloPolar)
                : isSet(object.payter_apollo_polar)
                    ? exports.PayterApolloPolar.fromJSON(object.payter_apollo_polar)
                    : undefined,
            kioskV: isSet(object.kioskV)
                ? exports.KioskV.fromJSON(object.kioskV)
                : isSet(object.kiosk_v)
                    ? exports.KioskV.fromJSON(object.kiosk_v)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.vp6800 !== undefined) {
            obj.vp6800 = exports.VP6800.toJSON(message.vp6800);
        }
        if (message.payterApolloPolar !== undefined) {
            obj.payterApolloPolar = exports.PayterApolloPolar.toJSON(message.payterApolloPolar);
        }
        if (message.kioskV !== undefined) {
            obj.kioskV = exports.KioskV.toJSON(message.kioskV);
        }
        return obj;
    },
    create(base) {
        return exports.PaymentTerminal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePaymentTerminal();
        message.vp6800 =
            object.vp6800 !== undefined && object.vp6800 !== null
                ? exports.VP6800.fromPartial(object.vp6800)
                : undefined;
        message.payterApolloPolar =
            object.payterApolloPolar !== undefined &&
                object.payterApolloPolar !== null
                ? exports.PayterApolloPolar.fromPartial(object.payterApolloPolar)
                : undefined;
        message.kioskV =
            object.kioskV !== undefined && object.kioskV !== null
                ? exports.KioskV.fromPartial(object.kioskV)
                : undefined;
        return message;
    },
};
function createBaseFC150K() {
    return { hasSerialLogs: false };
}
exports.FC150K = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.hasSerialLogs !== false) {
            writer.uint32(8).bool(message.hasSerialLogs);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFC150K();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.hasSerialLogs = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            hasSerialLogs: isSet(object.hasSerialLogs)
                ? globalThis.Boolean(object.hasSerialLogs)
                : isSet(object.has_serial_logs)
                    ? globalThis.Boolean(object.has_serial_logs)
                    : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.hasSerialLogs !== false) {
            obj.hasSerialLogs = message.hasSerialLogs;
        }
        return obj;
    },
    create(base) {
        return exports.FC150K.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFC150K();
        message.hasSerialLogs = object.hasSerialLogs ?? false;
        return message;
    },
};
function createBaseFC200K() {
    return {
        isChargerControl: false,
        mainboardSerialPort: "",
        boostModeEnabled: false,
    };
}
exports.FC200K = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.isChargerControl !== false) {
            writer.uint32(8).bool(message.isChargerControl);
        }
        if (message.mainboardSerialPort !== "") {
            writer.uint32(18).string(message.mainboardSerialPort);
        }
        if (message.boostModeEnabled !== false) {
            writer.uint32(24).bool(message.boostModeEnabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFC200K();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.isChargerControl = reader.bool();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.mainboardSerialPort = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.boostModeEnabled = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            isChargerControl: isSet(object.isChargerControl)
                ? globalThis.Boolean(object.isChargerControl)
                : isSet(object.is_charger_control)
                    ? globalThis.Boolean(object.is_charger_control)
                    : false,
            mainboardSerialPort: isSet(object.mainboardSerialPort)
                ? globalThis.String(object.mainboardSerialPort)
                : isSet(object.mainboard_serial_port)
                    ? globalThis.String(object.mainboard_serial_port)
                    : "",
            boostModeEnabled: isSet(object.boostModeEnabled)
                ? globalThis.Boolean(object.boostModeEnabled)
                : isSet(object.boost_mode_enabled)
                    ? globalThis.Boolean(object.boost_mode_enabled)
                    : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.isChargerControl !== false) {
            obj.isChargerControl = message.isChargerControl;
        }
        if (message.mainboardSerialPort !== "") {
            obj.mainboardSerialPort = message.mainboardSerialPort;
        }
        if (message.boostModeEnabled !== false) {
            obj.boostModeEnabled = message.boostModeEnabled;
        }
        return obj;
    },
    create(base) {
        return exports.FC200K.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFC200K();
        message.isChargerControl = object.isChargerControl ?? false;
        message.mainboardSerialPort = object.mainboardSerialPort ?? "";
        message.boostModeEnabled = object.boostModeEnabled ?? false;
        return message;
    },
};
function createBaseTPGHPC240() {
    return { remoteCsmsUrl: "" };
}
exports.TPGHPC240 = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.remoteCsmsUrl !== "") {
            writer.uint32(10).string(message.remoteCsmsUrl);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTPGHPC240();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.remoteCsmsUrl = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            remoteCsmsUrl: isSet(object.remoteCsmsUrl)
                ? globalThis.String(object.remoteCsmsUrl)
                : isSet(object.remote_csms_url)
                    ? globalThis.String(object.remote_csms_url)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.remoteCsmsUrl !== "") {
            obj.remoteCsmsUrl = message.remoteCsmsUrl;
        }
        return obj;
    },
    create(base) {
        return exports.TPGHPC240.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTPGHPC240();
        message.remoteCsmsUrl = object.remoteCsmsUrl ?? "";
        return message;
    },
};
function createBaseXC7AM() {
    return {};
}
exports.XC7AM = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseXC7AM();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.XC7AM.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseXC7AM();
        return message;
    },
};
function createBaseDP400K() {
    return { mainboardSerialPort: "" };
}
exports.DP400K = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.mainboardSerialPort !== "") {
            writer.uint32(18).string(message.mainboardSerialPort);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDP400K();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.mainboardSerialPort = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            mainboardSerialPort: isSet(object.mainboardSerialPort)
                ? globalThis.String(object.mainboardSerialPort)
                : isSet(object.mainboard_serial_port)
                    ? globalThis.String(object.mainboard_serial_port)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.mainboardSerialPort !== "") {
            obj.mainboardSerialPort = message.mainboardSerialPort;
        }
        return obj;
    },
    create(base) {
        return exports.DP400K.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDP400K();
        message.mainboardSerialPort = object.mainboardSerialPort ?? "";
        return message;
    },
};
function createBaseEEV3() {
    return { mainboardSerialPort: "" };
}
exports.EEV3 = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.mainboardSerialPort !== "") {
            writer.uint32(10).string(message.mainboardSerialPort);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseEEV3();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.mainboardSerialPort = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            mainboardSerialPort: isSet(object.mainboardSerialPort)
                ? globalThis.String(object.mainboardSerialPort)
                : isSet(object.mainboard_serial_port)
                    ? globalThis.String(object.mainboard_serial_port)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.mainboardSerialPort !== "") {
            obj.mainboardSerialPort = message.mainboardSerialPort;
        }
        return obj;
    },
    create(base) {
        return exports.EEV3.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEEV3();
        message.mainboardSerialPort = object.mainboardSerialPort ?? "";
        return message;
    },
};
function createBaseCS32() {
    return { mainboardSerialPort: "" };
}
exports.CS32 = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.mainboardSerialPort !== "") {
            writer.uint32(10).string(message.mainboardSerialPort);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCS32();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.mainboardSerialPort = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            mainboardSerialPort: isSet(object.mainboardSerialPort)
                ? globalThis.String(object.mainboardSerialPort)
                : isSet(object.mainboard_serial_port)
                    ? globalThis.String(object.mainboard_serial_port)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.mainboardSerialPort !== "") {
            obj.mainboardSerialPort = message.mainboardSerialPort;
        }
        return obj;
    },
    create(base) {
        return exports.CS32.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCS32();
        message.mainboardSerialPort = object.mainboardSerialPort ?? "";
        return message;
    },
};
function createBaseCS36() {
    return { mainboardSerialPort: "" };
}
exports.CS36 = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.mainboardSerialPort !== "") {
            writer.uint32(10).string(message.mainboardSerialPort);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCS36();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.mainboardSerialPort = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            mainboardSerialPort: isSet(object.mainboardSerialPort)
                ? globalThis.String(object.mainboardSerialPort)
                : isSet(object.mainboard_serial_port)
                    ? globalThis.String(object.mainboard_serial_port)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.mainboardSerialPort !== "") {
            obj.mainboardSerialPort = message.mainboardSerialPort;
        }
        return obj;
    },
    create(base) {
        return exports.CS36.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCS36();
        message.mainboardSerialPort = object.mainboardSerialPort ?? "";
        return message;
    },
};
function createBaseCS40() {
    return { mainboardSerialPort: "" };
}
exports.CS40 = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.mainboardSerialPort !== "") {
            writer.uint32(10).string(message.mainboardSerialPort);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCS40();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.mainboardSerialPort = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            mainboardSerialPort: isSet(object.mainboardSerialPort)
                ? globalThis.String(object.mainboardSerialPort)
                : isSet(object.mainboard_serial_port)
                    ? globalThis.String(object.mainboard_serial_port)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.mainboardSerialPort !== "") {
            obj.mainboardSerialPort = message.mainboardSerialPort;
        }
        return obj;
    },
    create(base) {
        return exports.CS40.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCS40();
        message.mainboardSerialPort = object.mainboardSerialPort ?? "";
        return message;
    },
};
function createBaseChargerModel() {
    return {
        fc150k: undefined,
        tpghpc240: undefined,
        fc200k: undefined,
        xc7am: undefined,
        dp400k: undefined,
        eev3: undefined,
        cs32: undefined,
        cs36: undefined,
        cs40: undefined,
    };
}
exports.ChargerModel = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.fc150k !== undefined) {
            exports.FC150K.encode(message.fc150k, writer.uint32(10).fork()).join();
        }
        if (message.tpghpc240 !== undefined) {
            exports.TPGHPC240.encode(message.tpghpc240, writer.uint32(18).fork()).join();
        }
        if (message.fc200k !== undefined) {
            exports.FC200K.encode(message.fc200k, writer.uint32(26).fork()).join();
        }
        if (message.xc7am !== undefined) {
            exports.XC7AM.encode(message.xc7am, writer.uint32(34).fork()).join();
        }
        if (message.dp400k !== undefined) {
            exports.DP400K.encode(message.dp400k, writer.uint32(42).fork()).join();
        }
        if (message.eev3 !== undefined) {
            exports.EEV3.encode(message.eev3, writer.uint32(50).fork()).join();
        }
        if (message.cs32 !== undefined) {
            exports.CS32.encode(message.cs32, writer.uint32(58).fork()).join();
        }
        if (message.cs36 !== undefined) {
            exports.CS36.encode(message.cs36, writer.uint32(66).fork()).join();
        }
        if (message.cs40 !== undefined) {
            exports.CS40.encode(message.cs40, writer.uint32(74).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChargerModel();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.fc150k = exports.FC150K.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.tpghpc240 = exports.TPGHPC240.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.fc200k = exports.FC200K.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.xc7am = exports.XC7AM.decode(reader, reader.uint32());
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.dp400k = exports.DP400K.decode(reader, reader.uint32());
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.eev3 = exports.EEV3.decode(reader, reader.uint32());
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.cs32 = exports.CS32.decode(reader, reader.uint32());
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.cs36 = exports.CS36.decode(reader, reader.uint32());
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.cs40 = exports.CS40.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            fc150k: isSet(object.fc150k) ? exports.FC150K.fromJSON(object.fc150k) : undefined,
            tpghpc240: isSet(object.tpghpc240)
                ? exports.TPGHPC240.fromJSON(object.tpghpc240)
                : undefined,
            fc200k: isSet(object.fc200k) ? exports.FC200K.fromJSON(object.fc200k) : undefined,
            xc7am: isSet(object.xc7am) ? exports.XC7AM.fromJSON(object.xc7am) : undefined,
            dp400k: isSet(object.dp400k) ? exports.DP400K.fromJSON(object.dp400k) : undefined,
            eev3: isSet(object.eev3) ? exports.EEV3.fromJSON(object.eev3) : undefined,
            cs32: isSet(object.cs32) ? exports.CS32.fromJSON(object.cs32) : undefined,
            cs36: isSet(object.cs36) ? exports.CS36.fromJSON(object.cs36) : undefined,
            cs40: isSet(object.cs40) ? exports.CS40.fromJSON(object.cs40) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.fc150k !== undefined) {
            obj.fc150k = exports.FC150K.toJSON(message.fc150k);
        }
        if (message.tpghpc240 !== undefined) {
            obj.tpghpc240 = exports.TPGHPC240.toJSON(message.tpghpc240);
        }
        if (message.fc200k !== undefined) {
            obj.fc200k = exports.FC200K.toJSON(message.fc200k);
        }
        if (message.xc7am !== undefined) {
            obj.xc7am = exports.XC7AM.toJSON(message.xc7am);
        }
        if (message.dp400k !== undefined) {
            obj.dp400k = exports.DP400K.toJSON(message.dp400k);
        }
        if (message.eev3 !== undefined) {
            obj.eev3 = exports.EEV3.toJSON(message.eev3);
        }
        if (message.cs32 !== undefined) {
            obj.cs32 = exports.CS32.toJSON(message.cs32);
        }
        if (message.cs36 !== undefined) {
            obj.cs36 = exports.CS36.toJSON(message.cs36);
        }
        if (message.cs40 !== undefined) {
            obj.cs40 = exports.CS40.toJSON(message.cs40);
        }
        return obj;
    },
    create(base) {
        return exports.ChargerModel.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChargerModel();
        message.fc150k =
            object.fc150k !== undefined && object.fc150k !== null
                ? exports.FC150K.fromPartial(object.fc150k)
                : undefined;
        message.tpghpc240 =
            object.tpghpc240 !== undefined && object.tpghpc240 !== null
                ? exports.TPGHPC240.fromPartial(object.tpghpc240)
                : undefined;
        message.fc200k =
            object.fc200k !== undefined && object.fc200k !== null
                ? exports.FC200K.fromPartial(object.fc200k)
                : undefined;
        message.xc7am =
            object.xc7am !== undefined && object.xc7am !== null
                ? exports.XC7AM.fromPartial(object.xc7am)
                : undefined;
        message.dp400k =
            object.dp400k !== undefined && object.dp400k !== null
                ? exports.DP400K.fromPartial(object.dp400k)
                : undefined;
        message.eev3 =
            object.eev3 !== undefined && object.eev3 !== null
                ? exports.EEV3.fromPartial(object.eev3)
                : undefined;
        message.cs32 =
            object.cs32 !== undefined && object.cs32 !== null
                ? exports.CS32.fromPartial(object.cs32)
                : undefined;
        message.cs36 =
            object.cs36 !== undefined && object.cs36 !== null
                ? exports.CS36.fromPartial(object.cs36)
                : undefined;
        message.cs40 =
            object.cs40 !== undefined && object.cs40 !== null
                ? exports.CS40.fromPartial(object.cs40)
                : undefined;
        return message;
    },
};
function createBaseACUVIM2() {
    return {};
}
exports.ACUVIM2 = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseACUVIM2();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ACUVIM2.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseACUVIM2();
        return message;
    },
};
function createBasePXR25() {
    return {};
}
exports.PXR25 = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePXR25();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.PXR25.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePXR25();
        return message;
    },
};
function createBasepxr25Rs485() {
    return {};
}
exports.pxr25Rs485 = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasepxr25Rs485();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.pxr25Rs485.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasepxr25Rs485();
        return message;
    },
};
function createBasePowerMeterModel() {
    return { acuvim2: undefined, pxr25: undefined, pxr25Rs485: undefined };
}
exports.PowerMeterModel = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.acuvim2 !== undefined) {
            exports.ACUVIM2.encode(message.acuvim2, writer.uint32(10).fork()).join();
        }
        if (message.pxr25 !== undefined) {
            exports.PXR25.encode(message.pxr25, writer.uint32(18).fork()).join();
        }
        if (message.pxr25Rs485 !== undefined) {
            exports.pxr25Rs485.encode(message.pxr25Rs485, writer.uint32(26).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePowerMeterModel();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.acuvim2 = exports.ACUVIM2.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.pxr25 = exports.PXR25.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.pxr25Rs485 = exports.pxr25Rs485.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            acuvim2: isSet(object.acuvim2)
                ? exports.ACUVIM2.fromJSON(object.acuvim2)
                : undefined,
            pxr25: isSet(object.pxr25) ? exports.PXR25.fromJSON(object.pxr25) : undefined,
            pxr25Rs485: isSet(object.pxr25Rs485)
                ? exports.pxr25Rs485.fromJSON(object.pxr25Rs485)
                : isSet(object.pxr25_rs485)
                    ? exports.pxr25Rs485.fromJSON(object.pxr25_rs485)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.acuvim2 !== undefined) {
            obj.acuvim2 = exports.ACUVIM2.toJSON(message.acuvim2);
        }
        if (message.pxr25 !== undefined) {
            obj.pxr25 = exports.PXR25.toJSON(message.pxr25);
        }
        if (message.pxr25Rs485 !== undefined) {
            obj.pxr25Rs485 = exports.pxr25Rs485.toJSON(message.pxr25Rs485);
        }
        return obj;
    },
    create(base) {
        return exports.PowerMeterModel.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePowerMeterModel();
        message.acuvim2 =
            object.acuvim2 !== undefined && object.acuvim2 !== null
                ? exports.ACUVIM2.fromPartial(object.acuvim2)
                : undefined;
        message.pxr25 =
            object.pxr25 !== undefined && object.pxr25 !== null
                ? exports.PXR25.fromPartial(object.pxr25)
                : undefined;
        message.pxr25Rs485 =
            object.pxr25Rs485 !== undefined && object.pxr25Rs485 !== null
                ? exports.pxr25Rs485.fromPartial(object.pxr25Rs485)
                : undefined;
        return message;
    },
};
function createBasePEPLINK() {
    return {};
}
exports.PEPLINK = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePEPLINK();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.PEPLINK.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePEPLINK();
        return message;
    },
};
function createBaseSTARLINK() {
    return {};
}
exports.STARLINK = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSTARLINK();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.STARLINK.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSTARLINK();
        return message;
    },
};
function createBaseInternetDevice() {
    return { peplink: undefined, starlink: undefined };
}
exports.InternetDevice = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.peplink !== undefined) {
            exports.PEPLINK.encode(message.peplink, writer.uint32(10).fork()).join();
        }
        if (message.starlink !== undefined) {
            exports.STARLINK.encode(message.starlink, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInternetDevice();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.peplink = exports.PEPLINK.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.starlink = exports.STARLINK.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            peplink: isSet(object.peplink)
                ? exports.PEPLINK.fromJSON(object.peplink)
                : undefined,
            starlink: isSet(object.starlink)
                ? exports.STARLINK.fromJSON(object.starlink)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.peplink !== undefined) {
            obj.peplink = exports.PEPLINK.toJSON(message.peplink);
        }
        if (message.starlink !== undefined) {
            obj.starlink = exports.STARLINK.toJSON(message.starlink);
        }
        return obj;
    },
    create(base) {
        return exports.InternetDevice.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInternetDevice();
        message.peplink =
            object.peplink !== undefined && object.peplink !== null
                ? exports.PEPLINK.fromPartial(object.peplink)
                : undefined;
        message.starlink =
            object.starlink !== undefined && object.starlink !== null
                ? exports.STARLINK.fromPartial(object.starlink)
                : undefined;
        return message;
    },
};
function createBaseOcppConnection() {
    return { ocppBaseUrl: "", basic: undefined, clientCert: undefined };
}
exports.OcppConnection = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.ocppBaseUrl !== "") {
            writer.uint32(10).string(message.ocppBaseUrl);
        }
        if (message.basic !== undefined) {
            charger_1.BasicAuthentication.encode(message.basic, writer.uint32(18).fork()).join();
        }
        if (message.clientCert !== undefined) {
            charger_1.ClientCertAuthentication.encode(message.clientCert, writer.uint32(26).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOcppConnection();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.ocppBaseUrl = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.basic = charger_1.BasicAuthentication.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.clientCert = charger_1.ClientCertAuthentication.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            ocppBaseUrl: isSet(object.ocppBaseUrl)
                ? globalThis.String(object.ocppBaseUrl)
                : isSet(object.ocpp_base_url)
                    ? globalThis.String(object.ocpp_base_url)
                    : "",
            basic: isSet(object.basic)
                ? charger_1.BasicAuthentication.fromJSON(object.basic)
                : undefined,
            clientCert: isSet(object.clientCert)
                ? charger_1.ClientCertAuthentication.fromJSON(object.clientCert)
                : isSet(object.client_cert)
                    ? charger_1.ClientCertAuthentication.fromJSON(object.client_cert)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ocppBaseUrl !== "") {
            obj.ocppBaseUrl = message.ocppBaseUrl;
        }
        if (message.basic !== undefined) {
            obj.basic = charger_1.BasicAuthentication.toJSON(message.basic);
        }
        if (message.clientCert !== undefined) {
            obj.clientCert = charger_1.ClientCertAuthentication.toJSON(message.clientCert);
        }
        return obj;
    },
    create(base) {
        return exports.OcppConnection.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOcppConnection();
        message.ocppBaseUrl = object.ocppBaseUrl ?? "";
        message.basic =
            object.basic !== undefined && object.basic !== null
                ? charger_1.BasicAuthentication.fromPartial(object.basic)
                : undefined;
        message.clientCert =
            object.clientCert !== undefined && object.clientCert !== null
                ? charger_1.ClientCertAuthentication.fromPartial(object.clientCert)
                : undefined;
        return message;
    },
};
function createBaseConnectedCharger() {
    return {
        ocppId: "",
        maxPowerKw: 0,
        paymentTerminal: undefined,
        connectors: [],
        ctepCertificateNumber: "",
        model: undefined,
        advertisedMaxPowerKw: 0,
        ntepCertificateNumber: "",
        serialNumber: "",
    };
}
exports.ConnectedCharger = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.ocppId !== "") {
            writer.uint32(10).string(message.ocppId);
        }
        if (message.maxPowerKw !== 0) {
            writer.uint32(21).float(message.maxPowerKw);
        }
        if (message.paymentTerminal !== undefined) {
            exports.PaymentTerminal.encode(message.paymentTerminal, writer.uint32(26).fork()).join();
        }
        for (const v of message.connectors) {
            exports.ChargerConnector.encode(v, writer.uint32(34).fork()).join();
        }
        if (message.ctepCertificateNumber !== "") {
            writer.uint32(42).string(message.ctepCertificateNumber);
        }
        if (message.model !== undefined) {
            exports.ChargerModel.encode(message.model, writer.uint32(50).fork()).join();
        }
        if (message.advertisedMaxPowerKw !== 0) {
            writer.uint32(61).float(message.advertisedMaxPowerKw);
        }
        if (message.ntepCertificateNumber !== "") {
            writer.uint32(66).string(message.ntepCertificateNumber);
        }
        if (message.serialNumber !== "") {
            writer.uint32(74).string(message.serialNumber);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseConnectedCharger();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.ocppId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 21) {
                        break;
                    }
                    message.maxPowerKw = reader.float();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.paymentTerminal = exports.PaymentTerminal.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.connectors.push(exports.ChargerConnector.decode(reader, reader.uint32()));
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.ctepCertificateNumber = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.model = exports.ChargerModel.decode(reader, reader.uint32());
                    continue;
                }
                case 7: {
                    if (tag !== 61) {
                        break;
                    }
                    message.advertisedMaxPowerKw = reader.float();
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.ntepCertificateNumber = reader.string();
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.serialNumber = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            ocppId: isSet(object.ocppId)
                ? globalThis.String(object.ocppId)
                : isSet(object.ocpp_id)
                    ? globalThis.String(object.ocpp_id)
                    : "",
            maxPowerKw: isSet(object.maxPowerKw)
                ? globalThis.Number(object.maxPowerKw)
                : isSet(object.max_power_kw)
                    ? globalThis.Number(object.max_power_kw)
                    : 0,
            paymentTerminal: isSet(object.paymentTerminal)
                ? exports.PaymentTerminal.fromJSON(object.paymentTerminal)
                : isSet(object.payment_terminal)
                    ? exports.PaymentTerminal.fromJSON(object.payment_terminal)
                    : undefined,
            connectors: globalThis.Array.isArray(object?.connectors)
                ? object.connectors.map((e) => exports.ChargerConnector.fromJSON(e))
                : [],
            ctepCertificateNumber: isSet(object.ctepCertificateNumber)
                ? globalThis.String(object.ctepCertificateNumber)
                : isSet(object.ctep_certificate_number)
                    ? globalThis.String(object.ctep_certificate_number)
                    : "",
            model: isSet(object.model)
                ? exports.ChargerModel.fromJSON(object.model)
                : undefined,
            advertisedMaxPowerKw: isSet(object.advertisedMaxPowerKw)
                ? globalThis.Number(object.advertisedMaxPowerKw)
                : isSet(object.advertised_max_power_kw)
                    ? globalThis.Number(object.advertised_max_power_kw)
                    : 0,
            ntepCertificateNumber: isSet(object.ntepCertificateNumber)
                ? globalThis.String(object.ntepCertificateNumber)
                : isSet(object.ntep_certificate_number)
                    ? globalThis.String(object.ntep_certificate_number)
                    : "",
            serialNumber: isSet(object.serialNumber)
                ? globalThis.String(object.serialNumber)
                : isSet(object.serial_number)
                    ? globalThis.String(object.serial_number)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ocppId !== "") {
            obj.ocppId = message.ocppId;
        }
        if (message.maxPowerKw !== 0) {
            obj.maxPowerKw = message.maxPowerKw;
        }
        if (message.paymentTerminal !== undefined) {
            obj.paymentTerminal = exports.PaymentTerminal.toJSON(message.paymentTerminal);
        }
        if (message.connectors?.length) {
            obj.connectors = message.connectors.map((e) => exports.ChargerConnector.toJSON(e));
        }
        if (message.ctepCertificateNumber !== "") {
            obj.ctepCertificateNumber = message.ctepCertificateNumber;
        }
        if (message.model !== undefined) {
            obj.model = exports.ChargerModel.toJSON(message.model);
        }
        if (message.advertisedMaxPowerKw !== 0) {
            obj.advertisedMaxPowerKw = message.advertisedMaxPowerKw;
        }
        if (message.ntepCertificateNumber !== "") {
            obj.ntepCertificateNumber = message.ntepCertificateNumber;
        }
        if (message.serialNumber !== "") {
            obj.serialNumber = message.serialNumber;
        }
        return obj;
    },
    create(base) {
        return exports.ConnectedCharger.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseConnectedCharger();
        message.ocppId = object.ocppId ?? "";
        message.maxPowerKw = object.maxPowerKw ?? 0;
        message.paymentTerminal =
            object.paymentTerminal !== undefined && object.paymentTerminal !== null
                ? exports.PaymentTerminal.fromPartial(object.paymentTerminal)
                : undefined;
        message.connectors =
            object.connectors?.map((e) => exports.ChargerConnector.fromPartial(e)) || [];
        message.ctepCertificateNumber = object.ctepCertificateNumber ?? "";
        message.model =
            object.model !== undefined && object.model !== null
                ? exports.ChargerModel.fromPartial(object.model)
                : undefined;
        message.advertisedMaxPowerKw = object.advertisedMaxPowerKw ?? 0;
        message.ntepCertificateNumber = object.ntepCertificateNumber ?? "";
        message.serialNumber = object.serialNumber ?? "";
        return message;
    },
};
function createBaseGetConnectedDevicesResponse() {
    return {
        siteId: 0,
        powernodeModel: "",
        connectedChargers: [],
        maxPowerKw: 0,
        timeOffsetFromUtcSeconds: 0,
        chargerPowerHardCapKw: 0,
        stationPowerMeterConnectionString: "",
        sitePowerMeterConnectionString: "",
        stationPowerMeterModel: undefined,
        maxCurrent: 0,
        gridNominalVoltage: 0,
        stationMembershipValidation: undefined,
        inverterConfiguration: undefined,
        internetDevice: undefined,
        ocppConnection: undefined,
    };
}
exports.GetConnectedDevicesResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.siteId !== 0) {
            writer.uint32(8).int32(message.siteId);
        }
        if (message.powernodeModel !== "") {
            writer.uint32(18).string(message.powernodeModel);
        }
        for (const v of message.connectedChargers) {
            exports.ConnectedCharger.encode(v, writer.uint32(26).fork()).join();
        }
        if (message.maxPowerKw !== 0) {
            writer.uint32(37).float(message.maxPowerKw);
        }
        if (message.timeOffsetFromUtcSeconds !== 0) {
            writer.uint32(40).int32(message.timeOffsetFromUtcSeconds);
        }
        if (message.chargerPowerHardCapKw !== 0) {
            writer.uint32(53).float(message.chargerPowerHardCapKw);
        }
        if (message.stationPowerMeterConnectionString !== "") {
            writer.uint32(58).string(message.stationPowerMeterConnectionString);
        }
        if (message.sitePowerMeterConnectionString !== "") {
            writer.uint32(66).string(message.sitePowerMeterConnectionString);
        }
        if (message.stationPowerMeterModel !== undefined) {
            exports.PowerMeterModel.encode(message.stationPowerMeterModel, writer.uint32(74).fork()).join();
        }
        if (message.maxCurrent !== 0) {
            writer.uint32(85).float(message.maxCurrent);
        }
        if (message.gridNominalVoltage !== 0) {
            writer.uint32(93).float(message.gridNominalVoltage);
        }
        if (message.stationMembershipValidation !== undefined) {
            charger_1.MembershipValidation.encode(message.stationMembershipValidation, writer.uint32(98).fork()).join();
        }
        if (message.inverterConfiguration !== undefined) {
            writer.uint32(106).string(message.inverterConfiguration);
        }
        if (message.internetDevice !== undefined) {
            exports.InternetDevice.encode(message.internetDevice, writer.uint32(114).fork()).join();
        }
        if (message.ocppConnection !== undefined) {
            exports.OcppConnection.encode(message.ocppConnection, writer.uint32(122).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetConnectedDevicesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.siteId = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.powernodeModel = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.connectedChargers.push(exports.ConnectedCharger.decode(reader, reader.uint32()));
                    continue;
                }
                case 4: {
                    if (tag !== 37) {
                        break;
                    }
                    message.maxPowerKw = reader.float();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.timeOffsetFromUtcSeconds = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 53) {
                        break;
                    }
                    message.chargerPowerHardCapKw = reader.float();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.stationPowerMeterConnectionString = reader.string();
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.sitePowerMeterConnectionString = reader.string();
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.stationPowerMeterModel = exports.PowerMeterModel.decode(reader, reader.uint32());
                    continue;
                }
                case 10: {
                    if (tag !== 85) {
                        break;
                    }
                    message.maxCurrent = reader.float();
                    continue;
                }
                case 11: {
                    if (tag !== 93) {
                        break;
                    }
                    message.gridNominalVoltage = reader.float();
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.stationMembershipValidation = charger_1.MembershipValidation.decode(reader, reader.uint32());
                    continue;
                }
                case 13: {
                    if (tag !== 106) {
                        break;
                    }
                    message.inverterConfiguration = reader.string();
                    continue;
                }
                case 14: {
                    if (tag !== 114) {
                        break;
                    }
                    message.internetDevice = exports.InternetDevice.decode(reader, reader.uint32());
                    continue;
                }
                case 15: {
                    if (tag !== 122) {
                        break;
                    }
                    message.ocppConnection = exports.OcppConnection.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            siteId: isSet(object.siteId)
                ? globalThis.Number(object.siteId)
                : isSet(object.site_id)
                    ? globalThis.Number(object.site_id)
                    : 0,
            powernodeModel: isSet(object.powernodeModel)
                ? globalThis.String(object.powernodeModel)
                : isSet(object.powernode_model)
                    ? globalThis.String(object.powernode_model)
                    : "",
            connectedChargers: globalThis.Array.isArray(object?.connectedChargers)
                ? object.connectedChargers.map((e) => exports.ConnectedCharger.fromJSON(e))
                : globalThis.Array.isArray(object?.connected_chargers)
                    ? object.connected_chargers.map((e) => exports.ConnectedCharger.fromJSON(e))
                    : [],
            maxPowerKw: isSet(object.maxPowerKw)
                ? globalThis.Number(object.maxPowerKw)
                : isSet(object.max_power_kw)
                    ? globalThis.Number(object.max_power_kw)
                    : 0,
            timeOffsetFromUtcSeconds: isSet(object.timeOffsetFromUtcSeconds)
                ? globalThis.Number(object.timeOffsetFromUtcSeconds)
                : isSet(object.time_offset_from_utc_seconds)
                    ? globalThis.Number(object.time_offset_from_utc_seconds)
                    : 0,
            chargerPowerHardCapKw: isSet(object.chargerPowerHardCapKw)
                ? globalThis.Number(object.chargerPowerHardCapKw)
                : isSet(object.charger_power_hard_cap_kw)
                    ? globalThis.Number(object.charger_power_hard_cap_kw)
                    : 0,
            stationPowerMeterConnectionString: isSet(object.stationPowerMeterConnectionString)
                ? globalThis.String(object.stationPowerMeterConnectionString)
                : isSet(object.station_power_meter_connection_string)
                    ? globalThis.String(object.station_power_meter_connection_string)
                    : "",
            sitePowerMeterConnectionString: isSet(object.sitePowerMeterConnectionString)
                ? globalThis.String(object.sitePowerMeterConnectionString)
                : isSet(object.site_power_meter_connection_string)
                    ? globalThis.String(object.site_power_meter_connection_string)
                    : "",
            stationPowerMeterModel: isSet(object.stationPowerMeterModel)
                ? exports.PowerMeterModel.fromJSON(object.stationPowerMeterModel)
                : isSet(object.station_power_meter_model)
                    ? exports.PowerMeterModel.fromJSON(object.station_power_meter_model)
                    : undefined,
            maxCurrent: isSet(object.maxCurrent)
                ? globalThis.Number(object.maxCurrent)
                : isSet(object.max_current)
                    ? globalThis.Number(object.max_current)
                    : 0,
            gridNominalVoltage: isSet(object.gridNominalVoltage)
                ? globalThis.Number(object.gridNominalVoltage)
                : isSet(object.grid_nominal_voltage)
                    ? globalThis.Number(object.grid_nominal_voltage)
                    : 0,
            stationMembershipValidation: isSet(object.stationMembershipValidation)
                ? charger_1.MembershipValidation.fromJSON(object.stationMembershipValidation)
                : isSet(object.station_membership_validation)
                    ? charger_1.MembershipValidation.fromJSON(object.station_membership_validation)
                    : undefined,
            inverterConfiguration: isSet(object.inverterConfiguration)
                ? globalThis.String(object.inverterConfiguration)
                : isSet(object.inverter_configuration)
                    ? globalThis.String(object.inverter_configuration)
                    : undefined,
            internetDevice: isSet(object.internetDevice)
                ? exports.InternetDevice.fromJSON(object.internetDevice)
                : isSet(object.internet_device)
                    ? exports.InternetDevice.fromJSON(object.internet_device)
                    : undefined,
            ocppConnection: isSet(object.ocppConnection)
                ? exports.OcppConnection.fromJSON(object.ocppConnection)
                : isSet(object.ocpp_connection)
                    ? exports.OcppConnection.fromJSON(object.ocpp_connection)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.siteId !== 0) {
            obj.siteId = Math.round(message.siteId);
        }
        if (message.powernodeModel !== "") {
            obj.powernodeModel = message.powernodeModel;
        }
        if (message.connectedChargers?.length) {
            obj.connectedChargers = message.connectedChargers.map((e) => exports.ConnectedCharger.toJSON(e));
        }
        if (message.maxPowerKw !== 0) {
            obj.maxPowerKw = message.maxPowerKw;
        }
        if (message.timeOffsetFromUtcSeconds !== 0) {
            obj.timeOffsetFromUtcSeconds = Math.round(message.timeOffsetFromUtcSeconds);
        }
        if (message.chargerPowerHardCapKw !== 0) {
            obj.chargerPowerHardCapKw = message.chargerPowerHardCapKw;
        }
        if (message.stationPowerMeterConnectionString !== "") {
            obj.stationPowerMeterConnectionString =
                message.stationPowerMeterConnectionString;
        }
        if (message.sitePowerMeterConnectionString !== "") {
            obj.sitePowerMeterConnectionString =
                message.sitePowerMeterConnectionString;
        }
        if (message.stationPowerMeterModel !== undefined) {
            obj.stationPowerMeterModel = exports.PowerMeterModel.toJSON(message.stationPowerMeterModel);
        }
        if (message.maxCurrent !== 0) {
            obj.maxCurrent = message.maxCurrent;
        }
        if (message.gridNominalVoltage !== 0) {
            obj.gridNominalVoltage = message.gridNominalVoltage;
        }
        if (message.stationMembershipValidation !== undefined) {
            obj.stationMembershipValidation = charger_1.MembershipValidation.toJSON(message.stationMembershipValidation);
        }
        if (message.inverterConfiguration !== undefined) {
            obj.inverterConfiguration = message.inverterConfiguration;
        }
        if (message.internetDevice !== undefined) {
            obj.internetDevice = exports.InternetDevice.toJSON(message.internetDevice);
        }
        if (message.ocppConnection !== undefined) {
            obj.ocppConnection = exports.OcppConnection.toJSON(message.ocppConnection);
        }
        return obj;
    },
    create(base) {
        return exports.GetConnectedDevicesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetConnectedDevicesResponse();
        message.siteId = object.siteId ?? 0;
        message.powernodeModel = object.powernodeModel ?? "";
        message.connectedChargers =
            object.connectedChargers?.map((e) => exports.ConnectedCharger.fromPartial(e)) ||
                [];
        message.maxPowerKw = object.maxPowerKw ?? 0;
        message.timeOffsetFromUtcSeconds = object.timeOffsetFromUtcSeconds ?? 0;
        message.chargerPowerHardCapKw = object.chargerPowerHardCapKw ?? 0;
        message.stationPowerMeterConnectionString =
            object.stationPowerMeterConnectionString ?? "";
        message.sitePowerMeterConnectionString =
            object.sitePowerMeterConnectionString ?? "";
        message.stationPowerMeterModel =
            object.stationPowerMeterModel !== undefined &&
                object.stationPowerMeterModel !== null
                ? exports.PowerMeterModel.fromPartial(object.stationPowerMeterModel)
                : undefined;
        message.maxCurrent = object.maxCurrent ?? 0;
        message.gridNominalVoltage = object.gridNominalVoltage ?? 0;
        message.stationMembershipValidation =
            object.stationMembershipValidation !== undefined &&
                object.stationMembershipValidation !== null
                ? charger_1.MembershipValidation.fromPartial(object.stationMembershipValidation)
                : undefined;
        message.inverterConfiguration = object.inverterConfiguration ?? undefined;
        message.internetDevice =
            object.internetDevice !== undefined && object.internetDevice !== null
                ? exports.InternetDevice.fromPartial(object.internetDevice)
                : undefined;
        message.ocppConnection =
            object.ocppConnection !== undefined && object.ocppConnection !== null
                ? exports.OcppConnection.fromPartial(object.ocppConnection)
                : undefined;
        return message;
    },
};
function createBaseGetChargerConnectedDeviceRequest() {
    return { ocppId: "" };
}
exports.GetChargerConnectedDeviceRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.ocppId !== "") {
            writer.uint32(10).string(message.ocppId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChargerConnectedDeviceRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.ocppId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            ocppId: isSet(object.ocppId)
                ? globalThis.String(object.ocppId)
                : isSet(object.ocpp_id)
                    ? globalThis.String(object.ocpp_id)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ocppId !== "") {
            obj.ocppId = message.ocppId;
        }
        return obj;
    },
    create(base) {
        return exports.GetChargerConnectedDeviceRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChargerConnectedDeviceRequest();
        message.ocppId = object.ocppId ?? "";
        return message;
    },
};
function createBaseGetChargerConnectedDeviceResponse() {
    return {
        connectedCharger: undefined,
        timeOffsetFromUtcSeconds: 0,
        chargerPowerHardCapKw: 0,
        ocppConnection: undefined,
        siteId: 0,
        stationMembershipValidation: undefined,
        restrictToOcppOcpiAuth: false,
        employeesOnlyAccess: false,
    };
}
exports.GetChargerConnectedDeviceResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.connectedCharger !== undefined) {
            exports.ConnectedCharger.encode(message.connectedCharger, writer.uint32(10).fork()).join();
        }
        if (message.timeOffsetFromUtcSeconds !== 0) {
            writer.uint32(16).int32(message.timeOffsetFromUtcSeconds);
        }
        if (message.chargerPowerHardCapKw !== 0) {
            writer.uint32(29).float(message.chargerPowerHardCapKw);
        }
        if (message.ocppConnection !== undefined) {
            exports.OcppConnection.encode(message.ocppConnection, writer.uint32(34).fork()).join();
        }
        if (message.siteId !== 0) {
            writer.uint32(40).int32(message.siteId);
        }
        if (message.stationMembershipValidation !== undefined) {
            charger_1.MembershipValidation.encode(message.stationMembershipValidation, writer.uint32(98).fork()).join();
        }
        if (message.restrictToOcppOcpiAuth !== false) {
            writer.uint32(104).bool(message.restrictToOcppOcpiAuth);
        }
        if (message.employeesOnlyAccess !== false) {
            writer.uint32(112).bool(message.employeesOnlyAccess);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChargerConnectedDeviceResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.connectedCharger = exports.ConnectedCharger.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.timeOffsetFromUtcSeconds = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 29) {
                        break;
                    }
                    message.chargerPowerHardCapKw = reader.float();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.ocppConnection = exports.OcppConnection.decode(reader, reader.uint32());
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.siteId = reader.int32();
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.stationMembershipValidation = charger_1.MembershipValidation.decode(reader, reader.uint32());
                    continue;
                }
                case 13: {
                    if (tag !== 104) {
                        break;
                    }
                    message.restrictToOcppOcpiAuth = reader.bool();
                    continue;
                }
                case 14: {
                    if (tag !== 112) {
                        break;
                    }
                    message.employeesOnlyAccess = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            connectedCharger: isSet(object.connectedCharger)
                ? exports.ConnectedCharger.fromJSON(object.connectedCharger)
                : isSet(object.connected_charger)
                    ? exports.ConnectedCharger.fromJSON(object.connected_charger)
                    : undefined,
            timeOffsetFromUtcSeconds: isSet(object.timeOffsetFromUtcSeconds)
                ? globalThis.Number(object.timeOffsetFromUtcSeconds)
                : isSet(object.time_offset_from_utc_seconds)
                    ? globalThis.Number(object.time_offset_from_utc_seconds)
                    : 0,
            chargerPowerHardCapKw: isSet(object.chargerPowerHardCapKw)
                ? globalThis.Number(object.chargerPowerHardCapKw)
                : isSet(object.charger_power_hard_cap_kw)
                    ? globalThis.Number(object.charger_power_hard_cap_kw)
                    : 0,
            ocppConnection: isSet(object.ocppConnection)
                ? exports.OcppConnection.fromJSON(object.ocppConnection)
                : isSet(object.ocpp_connection)
                    ? exports.OcppConnection.fromJSON(object.ocpp_connection)
                    : undefined,
            siteId: isSet(object.siteId)
                ? globalThis.Number(object.siteId)
                : isSet(object.site_id)
                    ? globalThis.Number(object.site_id)
                    : 0,
            stationMembershipValidation: isSet(object.stationMembershipValidation)
                ? charger_1.MembershipValidation.fromJSON(object.stationMembershipValidation)
                : isSet(object.station_membership_validation)
                    ? charger_1.MembershipValidation.fromJSON(object.station_membership_validation)
                    : undefined,
            restrictToOcppOcpiAuth: isSet(object.restrictToOcppOcpiAuth)
                ? globalThis.Boolean(object.restrictToOcppOcpiAuth)
                : isSet(object.restrict_to_ocpp_ocpi_auth)
                    ? globalThis.Boolean(object.restrict_to_ocpp_ocpi_auth)
                    : false,
            employeesOnlyAccess: isSet(object.employeesOnlyAccess)
                ? globalThis.Boolean(object.employeesOnlyAccess)
                : isSet(object.employees_only_access)
                    ? globalThis.Boolean(object.employees_only_access)
                    : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.connectedCharger !== undefined) {
            obj.connectedCharger = exports.ConnectedCharger.toJSON(message.connectedCharger);
        }
        if (message.timeOffsetFromUtcSeconds !== 0) {
            obj.timeOffsetFromUtcSeconds = Math.round(message.timeOffsetFromUtcSeconds);
        }
        if (message.chargerPowerHardCapKw !== 0) {
            obj.chargerPowerHardCapKw = message.chargerPowerHardCapKw;
        }
        if (message.ocppConnection !== undefined) {
            obj.ocppConnection = exports.OcppConnection.toJSON(message.ocppConnection);
        }
        if (message.siteId !== 0) {
            obj.siteId = Math.round(message.siteId);
        }
        if (message.stationMembershipValidation !== undefined) {
            obj.stationMembershipValidation = charger_1.MembershipValidation.toJSON(message.stationMembershipValidation);
        }
        if (message.restrictToOcppOcpiAuth !== false) {
            obj.restrictToOcppOcpiAuth = message.restrictToOcppOcpiAuth;
        }
        if (message.employeesOnlyAccess !== false) {
            obj.employeesOnlyAccess = message.employeesOnlyAccess;
        }
        return obj;
    },
    create(base) {
        return exports.GetChargerConnectedDeviceResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChargerConnectedDeviceResponse();
        message.connectedCharger =
            object.connectedCharger !== undefined &&
                object.connectedCharger !== null
                ? exports.ConnectedCharger.fromPartial(object.connectedCharger)
                : undefined;
        message.timeOffsetFromUtcSeconds = object.timeOffsetFromUtcSeconds ?? 0;
        message.chargerPowerHardCapKw = object.chargerPowerHardCapKw ?? 0;
        message.ocppConnection =
            object.ocppConnection !== undefined && object.ocppConnection !== null
                ? exports.OcppConnection.fromPartial(object.ocppConnection)
                : undefined;
        message.siteId = object.siteId ?? 0;
        message.stationMembershipValidation =
            object.stationMembershipValidation !== undefined &&
                object.stationMembershipValidation !== null
                ? charger_1.MembershipValidation.fromPartial(object.stationMembershipValidation)
                : undefined;
        message.restrictToOcppOcpiAuth = object.restrictToOcppOcpiAuth ?? false;
        message.employeesOnlyAccess = object.employeesOnlyAccess ?? false;
        return message;
    },
};
function createBaseMaintenanceWindow() {
    return {
        start: undefined,
        end: undefined,
        allowOperationDuringWindow: false,
    };
}
exports.MaintenanceWindow = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.start !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.start), writer.uint32(10).fork()).join();
        }
        if (message.end !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.end), writer.uint32(18).fork()).join();
        }
        if (message.allowOperationDuringWindow !== false) {
            writer.uint32(24).bool(message.allowOperationDuringWindow);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMaintenanceWindow();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.start = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.end = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.allowOperationDuringWindow = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            start: isSet(object.start) ? fromJsonTimestamp(object.start) : undefined,
            end: isSet(object.end) ? fromJsonTimestamp(object.end) : undefined,
            allowOperationDuringWindow: isSet(object.allowOperationDuringWindow)
                ? globalThis.Boolean(object.allowOperationDuringWindow)
                : isSet(object.allow_operation_during_window)
                    ? globalThis.Boolean(object.allow_operation_during_window)
                    : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.start !== undefined) {
            obj.start = message.start.toISOString();
        }
        if (message.end !== undefined) {
            obj.end = message.end.toISOString();
        }
        if (message.allowOperationDuringWindow !== false) {
            obj.allowOperationDuringWindow = message.allowOperationDuringWindow;
        }
        return obj;
    },
    create(base) {
        return exports.MaintenanceWindow.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMaintenanceWindow();
        message.start = object.start ?? undefined;
        message.end = object.end ?? undefined;
        message.allowOperationDuringWindow =
            object.allowOperationDuringWindow ?? false;
        return message;
    },
};
function createBaseGetOperationalStatusResponse() {
    return { siteId: 0, batteryAllowedInService: false, maintenanceWindows: [] };
}
exports.GetOperationalStatusResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.siteId !== 0) {
            writer.uint32(8).int32(message.siteId);
        }
        if (message.batteryAllowedInService !== false) {
            writer.uint32(16).bool(message.batteryAllowedInService);
        }
        for (const v of message.maintenanceWindows) {
            exports.MaintenanceWindow.encode(v, writer.uint32(26).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetOperationalStatusResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.siteId = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.batteryAllowedInService = reader.bool();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.maintenanceWindows.push(exports.MaintenanceWindow.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            siteId: isSet(object.siteId)
                ? globalThis.Number(object.siteId)
                : isSet(object.site_id)
                    ? globalThis.Number(object.site_id)
                    : 0,
            batteryAllowedInService: isSet(object.batteryAllowedInService)
                ? globalThis.Boolean(object.batteryAllowedInService)
                : isSet(object.battery_allowed_in_service)
                    ? globalThis.Boolean(object.battery_allowed_in_service)
                    : false,
            maintenanceWindows: globalThis.Array.isArray(object?.maintenanceWindows)
                ? object.maintenanceWindows.map((e) => exports.MaintenanceWindow.fromJSON(e))
                : globalThis.Array.isArray(object?.maintenance_windows)
                    ? object.maintenance_windows.map((e) => exports.MaintenanceWindow.fromJSON(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.siteId !== 0) {
            obj.siteId = Math.round(message.siteId);
        }
        if (message.batteryAllowedInService !== false) {
            obj.batteryAllowedInService = message.batteryAllowedInService;
        }
        if (message.maintenanceWindows?.length) {
            obj.maintenanceWindows = message.maintenanceWindows.map((e) => exports.MaintenanceWindow.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetOperationalStatusResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetOperationalStatusResponse();
        message.siteId = object.siteId ?? 0;
        message.batteryAllowedInService = object.batteryAllowedInService ?? false;
        message.maintenanceWindows =
            object.maintenanceWindows?.map((e) => exports.MaintenanceWindow.fromPartial(e)) || [];
        return message;
    },
};
function createBaseRegisterTransactionResponse() {
    return { transactionId: "" };
}
exports.RegisterTransactionResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.transactionId !== "") {
            writer.uint32(10).string(message.transactionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRegisterTransactionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.transactionId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            transactionId: isSet(object.transactionId)
                ? globalThis.String(object.transactionId)
                : isSet(object.transaction_id)
                    ? globalThis.String(object.transaction_id)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.transactionId !== "") {
            obj.transactionId = message.transactionId;
        }
        return obj;
    },
    create(base) {
        return exports.RegisterTransactionResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRegisterTransactionResponse();
        message.transactionId = object.transactionId ?? "";
        return message;
    },
};
function createBaseUpdateTransactionResponse() {
    return {};
}
exports.UpdateTransactionResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateTransactionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UpdateTransactionResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUpdateTransactionResponse();
        return message;
    },
};
function createBaseSyncChargingSessionsResponse() {
    return {};
}
exports.SyncChargingSessionsResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSyncChargingSessionsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SyncChargingSessionsResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSyncChargingSessionsResponse();
        return message;
    },
};
function createBaseSyncChargingTransactionDetailsResponse() {
    return {};
}
exports.SyncChargingTransactionDetailsResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSyncChargingTransactionDetailsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SyncChargingTransactionDetailsResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSyncChargingTransactionDetailsResponse();
        return message;
    },
};
function createBaseGetPaymentInformationRequest() {
    return { siteId: 0 };
}
exports.GetPaymentInformationRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.siteId !== 0) {
            writer.uint32(8).int32(message.siteId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetPaymentInformationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.siteId = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            siteId: isSet(object.siteId)
                ? globalThis.Number(object.siteId)
                : isSet(object.site_id)
                    ? globalThis.Number(object.site_id)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.siteId !== 0) {
            obj.siteId = Math.round(message.siteId);
        }
        return obj;
    },
    create(base) {
        return exports.GetPaymentInformationRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPaymentInformationRequest();
        message.siteId = object.siteId ?? 0;
        return message;
    },
};
function createBaseGetPaymentInformationResponse() {
    return { paymentRestriction: undefined };
}
exports.GetPaymentInformationResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.paymentRestriction !== undefined) {
            money_1.PaymentRestriction.encode(message.paymentRestriction, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetPaymentInformationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.paymentRestriction = money_1.PaymentRestriction.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            paymentRestriction: isSet(object.paymentRestriction)
                ? money_1.PaymentRestriction.fromJSON(object.paymentRestriction)
                : isSet(object.payment_restriction)
                    ? money_1.PaymentRestriction.fromJSON(object.payment_restriction)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentRestriction !== undefined) {
            obj.paymentRestriction = money_1.PaymentRestriction.toJSON(message.paymentRestriction);
        }
        return obj;
    },
    create(base) {
        return exports.GetPaymentInformationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPaymentInformationResponse();
        message.paymentRestriction =
            object.paymentRestriction !== undefined &&
                object.paymentRestriction !== null
                ? money_1.PaymentRestriction.fromPartial(object.paymentRestriction)
                : undefined;
        return message;
    },
};
function createBaseGetChargerPaymentInformationRequest() {
    return { ocppId: "" };
}
exports.GetChargerPaymentInformationRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.ocppId !== "") {
            writer.uint32(10).string(message.ocppId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChargerPaymentInformationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.ocppId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            ocppId: isSet(object.ocppId)
                ? globalThis.String(object.ocppId)
                : isSet(object.ocpp_id)
                    ? globalThis.String(object.ocpp_id)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ocppId !== "") {
            obj.ocppId = message.ocppId;
        }
        return obj;
    },
    create(base) {
        return exports.GetChargerPaymentInformationRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChargerPaymentInformationRequest();
        message.ocppId = object.ocppId ?? "";
        return message;
    },
};
function createBaseGetChargerPaymentInformationResponse() {
    return {
        paymentRestriction: undefined,
        paymentProviderApiKey: "",
        paymentTokenHmacKey: new Uint8Array(0),
        membershipTokenHmacKey: new Uint8Array(0),
    };
}
exports.GetChargerPaymentInformationResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.paymentRestriction !== undefined) {
            money_1.PaymentRestriction.encode(message.paymentRestriction, writer.uint32(10).fork()).join();
        }
        if (message.paymentProviderApiKey !== "") {
            writer.uint32(18).string(message.paymentProviderApiKey);
        }
        if (message.paymentTokenHmacKey.length !== 0) {
            writer.uint32(26).bytes(message.paymentTokenHmacKey);
        }
        if (message.membershipTokenHmacKey.length !== 0) {
            writer.uint32(34).bytes(message.membershipTokenHmacKey);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChargerPaymentInformationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.paymentRestriction = money_1.PaymentRestriction.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.paymentProviderApiKey = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.paymentTokenHmacKey = reader.bytes();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.membershipTokenHmacKey = reader.bytes();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            paymentRestriction: isSet(object.paymentRestriction)
                ? money_1.PaymentRestriction.fromJSON(object.paymentRestriction)
                : isSet(object.payment_restriction)
                    ? money_1.PaymentRestriction.fromJSON(object.payment_restriction)
                    : undefined,
            paymentProviderApiKey: isSet(object.paymentProviderApiKey)
                ? globalThis.String(object.paymentProviderApiKey)
                : isSet(object.payment_provider_api_key)
                    ? globalThis.String(object.payment_provider_api_key)
                    : "",
            paymentTokenHmacKey: isSet(object.paymentTokenHmacKey)
                ? bytesFromBase64(object.paymentTokenHmacKey)
                : isSet(object.payment_token_hmac_key)
                    ? bytesFromBase64(object.payment_token_hmac_key)
                    : new Uint8Array(0),
            membershipTokenHmacKey: isSet(object.membershipTokenHmacKey)
                ? bytesFromBase64(object.membershipTokenHmacKey)
                : isSet(object.membership_token_hmac_key)
                    ? bytesFromBase64(object.membership_token_hmac_key)
                    : new Uint8Array(0),
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentRestriction !== undefined) {
            obj.paymentRestriction = money_1.PaymentRestriction.toJSON(message.paymentRestriction);
        }
        if (message.paymentProviderApiKey !== "") {
            obj.paymentProviderApiKey = message.paymentProviderApiKey;
        }
        if (message.paymentTokenHmacKey.length !== 0) {
            obj.paymentTokenHmacKey = base64FromBytes(message.paymentTokenHmacKey);
        }
        if (message.membershipTokenHmacKey.length !== 0) {
            obj.membershipTokenHmacKey = base64FromBytes(message.membershipTokenHmacKey);
        }
        return obj;
    },
    create(base) {
        return exports.GetChargerPaymentInformationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChargerPaymentInformationResponse();
        message.paymentRestriction =
            object.paymentRestriction !== undefined &&
                object.paymentRestriction !== null
                ? money_1.PaymentRestriction.fromPartial(object.paymentRestriction)
                : undefined;
        message.paymentProviderApiKey = object.paymentProviderApiKey ?? "";
        message.paymentTokenHmacKey =
            object.paymentTokenHmacKey ?? new Uint8Array(0);
        message.membershipTokenHmacKey =
            object.membershipTokenHmacKey ?? new Uint8Array(0);
        return message;
    },
};
function createBaseGetPricingInformationRequest() {
    return { siteId: 0 };
}
exports.GetPricingInformationRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.siteId !== 0) {
            writer.uint32(8).int32(message.siteId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetPricingInformationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.siteId = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            siteId: isSet(object.siteId)
                ? globalThis.Number(object.siteId)
                : isSet(object.site_id)
                    ? globalThis.Number(object.site_id)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.siteId !== 0) {
            obj.siteId = Math.round(message.siteId);
        }
        return obj;
    },
    create(base) {
        return exports.GetPricingInformationRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPricingInformationRequest();
        message.siteId = object.siteId ?? 0;
        return message;
    },
};
function createBaseGetPricingInformationResponse() {
    return { pricingModel: undefined };
}
exports.GetPricingInformationResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pricingModel !== undefined) {
            money_1.PricingModel.encode(message.pricingModel, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetPricingInformationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.pricingModel = money_1.PricingModel.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pricingModel: isSet(object.pricingModel)
                ? money_1.PricingModel.fromJSON(object.pricingModel)
                : isSet(object.pricing_model)
                    ? money_1.PricingModel.fromJSON(object.pricing_model)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pricingModel !== undefined) {
            obj.pricingModel = money_1.PricingModel.toJSON(message.pricingModel);
        }
        return obj;
    },
    create(base) {
        return exports.GetPricingInformationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPricingInformationResponse();
        message.pricingModel =
            object.pricingModel !== undefined && object.pricingModel !== null
                ? money_1.PricingModel.fromPartial(object.pricingModel)
                : undefined;
        return message;
    },
};
function createBaseGetChargerPricingInformationRequest() {
    return { ocppId: "" };
}
exports.GetChargerPricingInformationRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.ocppId !== "") {
            writer.uint32(10).string(message.ocppId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChargerPricingInformationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.ocppId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            ocppId: isSet(object.ocppId)
                ? globalThis.String(object.ocppId)
                : isSet(object.ocpp_id)
                    ? globalThis.String(object.ocpp_id)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ocppId !== "") {
            obj.ocppId = message.ocppId;
        }
        return obj;
    },
    create(base) {
        return exports.GetChargerPricingInformationRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChargerPricingInformationRequest();
        message.ocppId = object.ocppId ?? "";
        return message;
    },
};
function createBaseGetChargerPricingInformationResponse() {
    return { pricingModel: undefined };
}
exports.GetChargerPricingInformationResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pricingModel !== undefined) {
            money_1.PricingModel.encode(message.pricingModel, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChargerPricingInformationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.pricingModel = money_1.PricingModel.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pricingModel: isSet(object.pricingModel)
                ? money_1.PricingModel.fromJSON(object.pricingModel)
                : isSet(object.pricing_model)
                    ? money_1.PricingModel.fromJSON(object.pricing_model)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pricingModel !== undefined) {
            obj.pricingModel = money_1.PricingModel.toJSON(message.pricingModel);
        }
        return obj;
    },
    create(base) {
        return exports.GetChargerPricingInformationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChargerPricingInformationResponse();
        message.pricingModel =
            object.pricingModel !== undefined && object.pricingModel !== null
                ? money_1.PricingModel.fromPartial(object.pricingModel)
                : undefined;
        return message;
    },
};
function createBaseGetStatusRequest() {
    return { pnid: 0 };
}
exports.GetStatusRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pnid !== 0) {
            writer.uint32(8).int32(message.pnid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetStatusRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pnid = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { pnid: isSet(object.pnid) ? globalThis.Number(object.pnid) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.pnid !== 0) {
            obj.pnid = Math.round(message.pnid);
        }
        return obj;
    },
    create(base) {
        return exports.GetStatusRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetStatusRequest();
        message.pnid = object.pnid ?? 0;
        return message;
    },
};
function createBaseChargerStatus() {
    return {
        allowCharging: false,
        friendlyId: 0,
        ready: false,
        forceStartAllTransactions: false,
        disabledPortIds: [],
    };
}
exports.ChargerStatus = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.allowCharging !== false) {
            writer.uint32(8).bool(message.allowCharging);
        }
        if (message.friendlyId !== 0) {
            writer.uint32(16).int32(message.friendlyId);
        }
        if (message.ready !== false) {
            writer.uint32(24).bool(message.ready);
        }
        if (message.forceStartAllTransactions !== false) {
            writer.uint32(32).bool(message.forceStartAllTransactions);
        }
        writer.uint32(42).fork();
        for (const v of message.disabledPortIds) {
            writer.uint32(v);
        }
        writer.join();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChargerStatus();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.allowCharging = reader.bool();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.friendlyId = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.ready = reader.bool();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.forceStartAllTransactions = reader.bool();
                    continue;
                }
                case 5: {
                    if (tag === 40) {
                        message.disabledPortIds.push(reader.uint32());
                        continue;
                    }
                    if (tag === 42) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.disabledPortIds.push(reader.uint32());
                        }
                        continue;
                    }
                    break;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            allowCharging: isSet(object.allowCharging)
                ? globalThis.Boolean(object.allowCharging)
                : isSet(object.allow_charging)
                    ? globalThis.Boolean(object.allow_charging)
                    : false,
            friendlyId: isSet(object.friendlyId)
                ? globalThis.Number(object.friendlyId)
                : isSet(object.friendly_id)
                    ? globalThis.Number(object.friendly_id)
                    : 0,
            ready: isSet(object.ready) ? globalThis.Boolean(object.ready) : false,
            forceStartAllTransactions: isSet(object.forceStartAllTransactions)
                ? globalThis.Boolean(object.forceStartAllTransactions)
                : isSet(object.force_start_all_transactions)
                    ? globalThis.Boolean(object.force_start_all_transactions)
                    : false,
            disabledPortIds: globalThis.Array.isArray(object?.disabledPortIds)
                ? object.disabledPortIds.map((e) => globalThis.Number(e))
                : globalThis.Array.isArray(object?.disabled_port_ids)
                    ? object.disabled_port_ids.map((e) => globalThis.Number(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.allowCharging !== false) {
            obj.allowCharging = message.allowCharging;
        }
        if (message.friendlyId !== 0) {
            obj.friendlyId = Math.round(message.friendlyId);
        }
        if (message.ready !== false) {
            obj.ready = message.ready;
        }
        if (message.forceStartAllTransactions !== false) {
            obj.forceStartAllTransactions = message.forceStartAllTransactions;
        }
        if (message.disabledPortIds?.length) {
            obj.disabledPortIds = message.disabledPortIds.map((e) => Math.round(e));
        }
        return obj;
    },
    create(base) {
        return exports.ChargerStatus.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChargerStatus();
        message.allowCharging = object.allowCharging ?? false;
        message.friendlyId = object.friendlyId ?? 0;
        message.ready = object.ready ?? false;
        message.forceStartAllTransactions =
            object.forceStartAllTransactions ?? false;
        message.disabledPortIds = object.disabledPortIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseGetStatusResponse() {
    return {
        chargerStatuses: {},
        timeOffsetFromUtcSeconds: 0,
        branding: "",
        organizationName: "",
    };
}
exports.GetStatusResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        globalThis.Object.entries(message.chargerStatuses).forEach(([key, value]) => {
            exports.GetStatusResponse_ChargerStatusesEntry.encode({ key: key, value }, writer.uint32(10).fork()).join();
        });
        if (message.timeOffsetFromUtcSeconds !== 0) {
            writer.uint32(16).int32(message.timeOffsetFromUtcSeconds);
        }
        if (message.branding !== "") {
            writer.uint32(26).string(message.branding);
        }
        if (message.organizationName !== "") {
            writer.uint32(34).string(message.organizationName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetStatusResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = exports.GetStatusResponse_ChargerStatusesEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.chargerStatuses[entry1.key] = entry1.value;
                    }
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.timeOffsetFromUtcSeconds = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.branding = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.organizationName = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chargerStatuses: isObject(object.chargerStatuses)
                ? globalThis.Object.entries(object.chargerStatuses).reduce((acc, [key, value]) => {
                    acc[key] = exports.ChargerStatus.fromJSON(value);
                    return acc;
                }, {})
                : isObject(object.charger_statuses)
                    ? globalThis.Object.entries(object.charger_statuses).reduce((acc, [key, value]) => {
                        acc[key] = exports.ChargerStatus.fromJSON(value);
                        return acc;
                    }, {})
                    : {},
            timeOffsetFromUtcSeconds: isSet(object.timeOffsetFromUtcSeconds)
                ? globalThis.Number(object.timeOffsetFromUtcSeconds)
                : isSet(object.time_offset_from_utc_seconds)
                    ? globalThis.Number(object.time_offset_from_utc_seconds)
                    : 0,
            branding: isSet(object.branding)
                ? globalThis.String(object.branding)
                : "",
            organizationName: isSet(object.organizationName)
                ? globalThis.String(object.organizationName)
                : isSet(object.organization_name)
                    ? globalThis.String(object.organization_name)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chargerStatuses) {
            const entries = globalThis.Object.entries(message.chargerStatuses);
            if (entries.length > 0) {
                obj.chargerStatuses = {};
                entries.forEach(([k, v]) => {
                    obj.chargerStatuses[k] = exports.ChargerStatus.toJSON(v);
                });
            }
        }
        if (message.timeOffsetFromUtcSeconds !== 0) {
            obj.timeOffsetFromUtcSeconds = Math.round(message.timeOffsetFromUtcSeconds);
        }
        if (message.branding !== "") {
            obj.branding = message.branding;
        }
        if (message.organizationName !== "") {
            obj.organizationName = message.organizationName;
        }
        return obj;
    },
    create(base) {
        return exports.GetStatusResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetStatusResponse();
        message.chargerStatuses = globalThis.Object.entries(object.chargerStatuses ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = exports.ChargerStatus.fromPartial(value);
            }
            return acc;
        }, {});
        message.timeOffsetFromUtcSeconds = object.timeOffsetFromUtcSeconds ?? 0;
        message.branding = object.branding ?? "";
        message.organizationName = object.organizationName ?? "";
        return message;
    },
};
function createBaseGetStatusResponse_ChargerStatusesEntry() {
    return { key: "", value: undefined };
}
exports.GetStatusResponse_ChargerStatusesEntry = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.ChargerStatus.encode(message.value, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetStatusResponse_ChargerStatusesEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.ChargerStatus.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value)
                ? exports.ChargerStatus.fromJSON(object.value)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = exports.ChargerStatus.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return exports.GetStatusResponse_ChargerStatusesEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetStatusResponse_ChargerStatusesEntry();
        message.key = object.key ?? "";
        message.value =
            object.value !== undefined && object.value !== null
                ? exports.ChargerStatus.fromPartial(object.value)
                : undefined;
        return message;
    },
};
function createBaseGetChargerOperatingStatusRequest() {
    return { ocppId: "" };
}
exports.GetChargerOperatingStatusRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.ocppId !== "") {
            writer.uint32(10).string(message.ocppId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChargerOperatingStatusRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.ocppId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            ocppId: isSet(object.ocppId)
                ? globalThis.String(object.ocppId)
                : isSet(object.ocpp_id)
                    ? globalThis.String(object.ocpp_id)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ocppId !== "") {
            obj.ocppId = message.ocppId;
        }
        return obj;
    },
    create(base) {
        return exports.GetChargerOperatingStatusRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChargerOperatingStatusRequest();
        message.ocppId = object.ocppId ?? "";
        return message;
    },
};
function createBaseGetChargerOperatingStatusResponse() {
    return {
        chargerStatus: undefined,
        timeOffsetFromUtcSeconds: 0,
        branding: "",
        organizationName: "",
    };
}
exports.GetChargerOperatingStatusResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.chargerStatus !== undefined) {
            exports.ChargerStatus.encode(message.chargerStatus, writer.uint32(10).fork()).join();
        }
        if (message.timeOffsetFromUtcSeconds !== 0) {
            writer.uint32(16).int32(message.timeOffsetFromUtcSeconds);
        }
        if (message.branding !== "") {
            writer.uint32(26).string(message.branding);
        }
        if (message.organizationName !== "") {
            writer.uint32(34).string(message.organizationName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChargerOperatingStatusResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.chargerStatus = exports.ChargerStatus.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.timeOffsetFromUtcSeconds = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.branding = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.organizationName = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chargerStatus: isSet(object.chargerStatus)
                ? exports.ChargerStatus.fromJSON(object.chargerStatus)
                : isSet(object.charger_status)
                    ? exports.ChargerStatus.fromJSON(object.charger_status)
                    : undefined,
            timeOffsetFromUtcSeconds: isSet(object.timeOffsetFromUtcSeconds)
                ? globalThis.Number(object.timeOffsetFromUtcSeconds)
                : isSet(object.time_offset_from_utc_seconds)
                    ? globalThis.Number(object.time_offset_from_utc_seconds)
                    : 0,
            branding: isSet(object.branding)
                ? globalThis.String(object.branding)
                : "",
            organizationName: isSet(object.organizationName)
                ? globalThis.String(object.organizationName)
                : isSet(object.organization_name)
                    ? globalThis.String(object.organization_name)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chargerStatus !== undefined) {
            obj.chargerStatus = exports.ChargerStatus.toJSON(message.chargerStatus);
        }
        if (message.timeOffsetFromUtcSeconds !== 0) {
            obj.timeOffsetFromUtcSeconds = Math.round(message.timeOffsetFromUtcSeconds);
        }
        if (message.branding !== "") {
            obj.branding = message.branding;
        }
        if (message.organizationName !== "") {
            obj.organizationName = message.organizationName;
        }
        return obj;
    },
    create(base) {
        return exports.GetChargerOperatingStatusResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChargerOperatingStatusResponse();
        message.chargerStatus =
            object.chargerStatus !== undefined && object.chargerStatus !== null
                ? exports.ChargerStatus.fromPartial(object.chargerStatus)
                : undefined;
        message.timeOffsetFromUtcSeconds = object.timeOffsetFromUtcSeconds ?? 0;
        message.branding = object.branding ?? "";
        message.organizationName = object.organizationName ?? "";
        return message;
    },
};
function createBaseGenerateReceiptRequest() {
    return {
        emailAddress: "",
        chargerOcppId: "",
        consumedEnergyKwh: 0,
        money: undefined,
        chargeBreakdown: undefined,
        peakPowerKw: 0,
        merchantReceiptJson: "",
        pricing: undefined,
        chargingSessionStartUtc: undefined,
        chargingSessionEndUtc: undefined,
        transactionId: undefined,
    };
}
exports.GenerateReceiptRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.emailAddress !== "") {
            writer.uint32(10).string(message.emailAddress);
        }
        if (message.chargerOcppId !== "") {
            writer.uint32(18).string(message.chargerOcppId);
        }
        if (message.consumedEnergyKwh !== 0) {
            writer.uint32(29).float(message.consumedEnergyKwh);
        }
        if (message.money !== undefined) {
            money_1.Money.encode(message.money, writer.uint32(34).fork()).join();
        }
        if (message.chargeBreakdown !== undefined) {
            money_1.ChargeBreakdown.encode(message.chargeBreakdown, writer.uint32(42).fork()).join();
        }
        if (message.peakPowerKw !== 0) {
            writer.uint32(53).float(message.peakPowerKw);
        }
        if (message.merchantReceiptJson !== "") {
            writer.uint32(58).string(message.merchantReceiptJson);
        }
        if (message.pricing !== undefined) {
            money_1.PricingModel.encode(message.pricing, writer.uint32(66).fork()).join();
        }
        if (message.chargingSessionStartUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.chargingSessionStartUtc), writer.uint32(74).fork()).join();
        }
        if (message.chargingSessionEndUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.chargingSessionEndUtc), writer.uint32(82).fork()).join();
        }
        if (message.transactionId !== undefined) {
            writer.uint32(88).uint32(message.transactionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGenerateReceiptRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.emailAddress = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.chargerOcppId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 29) {
                        break;
                    }
                    message.consumedEnergyKwh = reader.float();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.money = money_1.Money.decode(reader, reader.uint32());
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.chargeBreakdown = money_1.ChargeBreakdown.decode(reader, reader.uint32());
                    continue;
                }
                case 6: {
                    if (tag !== 53) {
                        break;
                    }
                    message.peakPowerKw = reader.float();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.merchantReceiptJson = reader.string();
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.pricing = money_1.PricingModel.decode(reader, reader.uint32());
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.chargingSessionStartUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.chargingSessionEndUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 11: {
                    if (tag !== 88) {
                        break;
                    }
                    message.transactionId = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            emailAddress: isSet(object.emailAddress)
                ? globalThis.String(object.emailAddress)
                : isSet(object.email_address)
                    ? globalThis.String(object.email_address)
                    : "",
            chargerOcppId: isSet(object.chargerOcppId)
                ? globalThis.String(object.chargerOcppId)
                : isSet(object.charger_ocpp_id)
                    ? globalThis.String(object.charger_ocpp_id)
                    : "",
            consumedEnergyKwh: isSet(object.consumedEnergyKwh)
                ? globalThis.Number(object.consumedEnergyKwh)
                : isSet(object.consumed_energy_kwh)
                    ? globalThis.Number(object.consumed_energy_kwh)
                    : 0,
            money: isSet(object.money) ? money_1.Money.fromJSON(object.money) : undefined,
            chargeBreakdown: isSet(object.chargeBreakdown)
                ? money_1.ChargeBreakdown.fromJSON(object.chargeBreakdown)
                : isSet(object.charge_breakdown)
                    ? money_1.ChargeBreakdown.fromJSON(object.charge_breakdown)
                    : undefined,
            peakPowerKw: isSet(object.peakPowerKw)
                ? globalThis.Number(object.peakPowerKw)
                : isSet(object.peak_power_kw)
                    ? globalThis.Number(object.peak_power_kw)
                    : 0,
            merchantReceiptJson: isSet(object.merchantReceiptJson)
                ? globalThis.String(object.merchantReceiptJson)
                : isSet(object.merchant_receipt_json)
                    ? globalThis.String(object.merchant_receipt_json)
                    : "",
            pricing: isSet(object.pricing)
                ? money_1.PricingModel.fromJSON(object.pricing)
                : undefined,
            chargingSessionStartUtc: isSet(object.chargingSessionStartUtc)
                ? fromJsonTimestamp(object.chargingSessionStartUtc)
                : isSet(object.charging_session_start_utc)
                    ? fromJsonTimestamp(object.charging_session_start_utc)
                    : undefined,
            chargingSessionEndUtc: isSet(object.chargingSessionEndUtc)
                ? fromJsonTimestamp(object.chargingSessionEndUtc)
                : isSet(object.charging_session_end_utc)
                    ? fromJsonTimestamp(object.charging_session_end_utc)
                    : undefined,
            transactionId: isSet(object.transactionId)
                ? globalThis.Number(object.transactionId)
                : isSet(object.transaction_id)
                    ? globalThis.Number(object.transaction_id)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.emailAddress !== "") {
            obj.emailAddress = message.emailAddress;
        }
        if (message.chargerOcppId !== "") {
            obj.chargerOcppId = message.chargerOcppId;
        }
        if (message.consumedEnergyKwh !== 0) {
            obj.consumedEnergyKwh = message.consumedEnergyKwh;
        }
        if (message.money !== undefined) {
            obj.money = money_1.Money.toJSON(message.money);
        }
        if (message.chargeBreakdown !== undefined) {
            obj.chargeBreakdown = money_1.ChargeBreakdown.toJSON(message.chargeBreakdown);
        }
        if (message.peakPowerKw !== 0) {
            obj.peakPowerKw = message.peakPowerKw;
        }
        if (message.merchantReceiptJson !== "") {
            obj.merchantReceiptJson = message.merchantReceiptJson;
        }
        if (message.pricing !== undefined) {
            obj.pricing = money_1.PricingModel.toJSON(message.pricing);
        }
        if (message.chargingSessionStartUtc !== undefined) {
            obj.chargingSessionStartUtc =
                message.chargingSessionStartUtc.toISOString();
        }
        if (message.chargingSessionEndUtc !== undefined) {
            obj.chargingSessionEndUtc = message.chargingSessionEndUtc.toISOString();
        }
        if (message.transactionId !== undefined) {
            obj.transactionId = Math.round(message.transactionId);
        }
        return obj;
    },
    create(base) {
        return exports.GenerateReceiptRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGenerateReceiptRequest();
        message.emailAddress = object.emailAddress ?? "";
        message.chargerOcppId = object.chargerOcppId ?? "";
        message.consumedEnergyKwh = object.consumedEnergyKwh ?? 0;
        message.money =
            object.money !== undefined && object.money !== null
                ? money_1.Money.fromPartial(object.money)
                : undefined;
        message.chargeBreakdown =
            object.chargeBreakdown !== undefined && object.chargeBreakdown !== null
                ? money_1.ChargeBreakdown.fromPartial(object.chargeBreakdown)
                : undefined;
        message.peakPowerKw = object.peakPowerKw ?? 0;
        message.merchantReceiptJson = object.merchantReceiptJson ?? "";
        message.pricing =
            object.pricing !== undefined && object.pricing !== null
                ? money_1.PricingModel.fromPartial(object.pricing)
                : undefined;
        message.chargingSessionStartUtc =
            object.chargingSessionStartUtc ?? undefined;
        message.chargingSessionEndUtc = object.chargingSessionEndUtc ?? undefined;
        message.transactionId = object.transactionId ?? undefined;
        return message;
    },
};
function createBaseGenerateReceiptResponse() {
    return {};
}
exports.GenerateReceiptResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGenerateReceiptResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GenerateReceiptResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGenerateReceiptResponse();
        return message;
    },
};
function createBasePortHealth() {
    return {
        portId: 0,
        ocppStatus: "",
        powerKw: 0,
        powerLimitKw: 0,
        powerRequestedKw: 0,
        carSoc: 0,
        energyDelivered: 0,
        pluggedIn: false,
        paymentReady: false,
        transactionStarted: false,
        evccid: "",
        faultCode: "",
        transactionStartTime: undefined,
        perPortPowerLimits: false,
        membershipReady: false,
        ocpiTrackingId: undefined,
        unavailableReasons: [],
        availability: 0,
        chargingState: undefined,
        connectorState: undefined,
    };
}
exports.PortHealth = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.portId !== 0) {
            writer.uint32(8).uint32(message.portId);
        }
        if (message.ocppStatus !== "") {
            writer.uint32(18).string(message.ocppStatus);
        }
        if (message.powerKw !== 0) {
            writer.uint32(29).float(message.powerKw);
        }
        if (message.powerLimitKw !== 0) {
            writer.uint32(37).float(message.powerLimitKw);
        }
        if (message.powerRequestedKw !== 0) {
            writer.uint32(45).float(message.powerRequestedKw);
        }
        if (message.carSoc !== 0) {
            writer.uint32(53).float(message.carSoc);
        }
        if (message.energyDelivered !== 0) {
            writer.uint32(61).float(message.energyDelivered);
        }
        if (message.pluggedIn !== false) {
            writer.uint32(64).bool(message.pluggedIn);
        }
        if (message.paymentReady !== false) {
            writer.uint32(72).bool(message.paymentReady);
        }
        if (message.transactionStarted !== false) {
            writer.uint32(80).bool(message.transactionStarted);
        }
        if (message.evccid !== "") {
            writer.uint32(90).string(message.evccid);
        }
        if (message.faultCode !== "") {
            writer.uint32(98).string(message.faultCode);
        }
        if (message.transactionStartTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.transactionStartTime), writer.uint32(106).fork()).join();
        }
        if (message.perPortPowerLimits !== false) {
            writer.uint32(112).bool(message.perPortPowerLimits);
        }
        if (message.membershipReady !== false) {
            writer.uint32(120).bool(message.membershipReady);
        }
        if (message.ocpiTrackingId !== undefined) {
            writer.uint32(130).string(message.ocpiTrackingId);
        }
        writer.uint32(138).fork();
        for (const v of message.unavailableReasons) {
            writer.int32(v);
        }
        writer.join();
        if (message.availability !== 0) {
            writer.uint32(144).int32(message.availability);
        }
        if (message.chargingState !== undefined) {
            writer.uint32(152).int32(message.chargingState);
        }
        if (message.connectorState !== undefined) {
            writer.uint32(160).int32(message.connectorState);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePortHealth();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.portId = reader.uint32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.ocppStatus = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 29) {
                        break;
                    }
                    message.powerKw = reader.float();
                    continue;
                }
                case 4: {
                    if (tag !== 37) {
                        break;
                    }
                    message.powerLimitKw = reader.float();
                    continue;
                }
                case 5: {
                    if (tag !== 45) {
                        break;
                    }
                    message.powerRequestedKw = reader.float();
                    continue;
                }
                case 6: {
                    if (tag !== 53) {
                        break;
                    }
                    message.carSoc = reader.float();
                    continue;
                }
                case 7: {
                    if (tag !== 61) {
                        break;
                    }
                    message.energyDelivered = reader.float();
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.pluggedIn = reader.bool();
                    continue;
                }
                case 9: {
                    if (tag !== 72) {
                        break;
                    }
                    message.paymentReady = reader.bool();
                    continue;
                }
                case 10: {
                    if (tag !== 80) {
                        break;
                    }
                    message.transactionStarted = reader.bool();
                    continue;
                }
                case 11: {
                    if (tag !== 90) {
                        break;
                    }
                    message.evccid = reader.string();
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.faultCode = reader.string();
                    continue;
                }
                case 13: {
                    if (tag !== 106) {
                        break;
                    }
                    message.transactionStartTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 14: {
                    if (tag !== 112) {
                        break;
                    }
                    message.perPortPowerLimits = reader.bool();
                    continue;
                }
                case 15: {
                    if (tag !== 120) {
                        break;
                    }
                    message.membershipReady = reader.bool();
                    continue;
                }
                case 16: {
                    if (tag !== 130) {
                        break;
                    }
                    message.ocpiTrackingId = reader.string();
                    continue;
                }
                case 17: {
                    if (tag === 136) {
                        message.unavailableReasons.push(reader.int32());
                        continue;
                    }
                    if (tag === 138) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.unavailableReasons.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                }
                case 18: {
                    if (tag !== 144) {
                        break;
                    }
                    message.availability = reader.int32();
                    continue;
                }
                case 19: {
                    if (tag !== 152) {
                        break;
                    }
                    message.chargingState = reader.int32();
                    continue;
                }
                case 20: {
                    if (tag !== 160) {
                        break;
                    }
                    message.connectorState = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            portId: isSet(object.portId)
                ? globalThis.Number(object.portId)
                : isSet(object.port_id)
                    ? globalThis.Number(object.port_id)
                    : 0,
            ocppStatus: isSet(object.ocppStatus)
                ? globalThis.String(object.ocppStatus)
                : isSet(object.ocpp_status)
                    ? globalThis.String(object.ocpp_status)
                    : "",
            powerKw: isSet(object.powerKw)
                ? globalThis.Number(object.powerKw)
                : isSet(object.power_kw)
                    ? globalThis.Number(object.power_kw)
                    : 0,
            powerLimitKw: isSet(object.powerLimitKw)
                ? globalThis.Number(object.powerLimitKw)
                : isSet(object.power_limit_kw)
                    ? globalThis.Number(object.power_limit_kw)
                    : 0,
            powerRequestedKw: isSet(object.powerRequestedKw)
                ? globalThis.Number(object.powerRequestedKw)
                : isSet(object.power_requested_kw)
                    ? globalThis.Number(object.power_requested_kw)
                    : 0,
            carSoc: isSet(object.carSoc)
                ? globalThis.Number(object.carSoc)
                : isSet(object.car_soc)
                    ? globalThis.Number(object.car_soc)
                    : 0,
            energyDelivered: isSet(object.energyDelivered)
                ? globalThis.Number(object.energyDelivered)
                : isSet(object.energy_delivered)
                    ? globalThis.Number(object.energy_delivered)
                    : 0,
            pluggedIn: isSet(object.pluggedIn)
                ? globalThis.Boolean(object.pluggedIn)
                : isSet(object.plugged_in)
                    ? globalThis.Boolean(object.plugged_in)
                    : false,
            paymentReady: isSet(object.paymentReady)
                ? globalThis.Boolean(object.paymentReady)
                : isSet(object.payment_ready)
                    ? globalThis.Boolean(object.payment_ready)
                    : false,
            transactionStarted: isSet(object.transactionStarted)
                ? globalThis.Boolean(object.transactionStarted)
                : isSet(object.transaction_started)
                    ? globalThis.Boolean(object.transaction_started)
                    : false,
            evccid: isSet(object.evccid) ? globalThis.String(object.evccid) : "",
            faultCode: isSet(object.faultCode)
                ? globalThis.String(object.faultCode)
                : isSet(object.fault_code)
                    ? globalThis.String(object.fault_code)
                    : "",
            transactionStartTime: isSet(object.transactionStartTime)
                ? fromJsonTimestamp(object.transactionStartTime)
                : isSet(object.transaction_start_time)
                    ? fromJsonTimestamp(object.transaction_start_time)
                    : undefined,
            perPortPowerLimits: isSet(object.perPortPowerLimits)
                ? globalThis.Boolean(object.perPortPowerLimits)
                : isSet(object.per_port_power_limits)
                    ? globalThis.Boolean(object.per_port_power_limits)
                    : false,
            membershipReady: isSet(object.membershipReady)
                ? globalThis.Boolean(object.membershipReady)
                : isSet(object.membership_ready)
                    ? globalThis.Boolean(object.membership_ready)
                    : false,
            ocpiTrackingId: isSet(object.ocpiTrackingId)
                ? globalThis.String(object.ocpiTrackingId)
                : isSet(object.ocpi_tracking_id)
                    ? globalThis.String(object.ocpi_tracking_id)
                    : undefined,
            unavailableReasons: globalThis.Array.isArray(object?.unavailableReasons)
                ? object.unavailableReasons.map((e) => (0, charger_1.unavailableReasonFromJSON)(e))
                : globalThis.Array.isArray(object?.unavailable_reasons)
                    ? object.unavailable_reasons.map((e) => (0, charger_1.unavailableReasonFromJSON)(e))
                    : [],
            availability: isSet(object.availability)
                ? chargerAvailabilityFromJSON(object.availability)
                : 0,
            chargingState: isSet(object.chargingState)
                ? (0, charger_1.ocppChargingStateFromJSON)(object.chargingState)
                : isSet(object.charging_state)
                    ? (0, charger_1.ocppChargingStateFromJSON)(object.charging_state)
                    : undefined,
            connectorState: isSet(object.connectorState)
                ? (0, charging_session_attempt_1.chargerPortStateFromJSON)(object.connectorState)
                : isSet(object.connector_state)
                    ? (0, charging_session_attempt_1.chargerPortStateFromJSON)(object.connector_state)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.portId !== 0) {
            obj.portId = Math.round(message.portId);
        }
        if (message.ocppStatus !== "") {
            obj.ocppStatus = message.ocppStatus;
        }
        if (message.powerKw !== 0) {
            obj.powerKw = message.powerKw;
        }
        if (message.powerLimitKw !== 0) {
            obj.powerLimitKw = message.powerLimitKw;
        }
        if (message.powerRequestedKw !== 0) {
            obj.powerRequestedKw = message.powerRequestedKw;
        }
        if (message.carSoc !== 0) {
            obj.carSoc = message.carSoc;
        }
        if (message.energyDelivered !== 0) {
            obj.energyDelivered = message.energyDelivered;
        }
        if (message.pluggedIn !== false) {
            obj.pluggedIn = message.pluggedIn;
        }
        if (message.paymentReady !== false) {
            obj.paymentReady = message.paymentReady;
        }
        if (message.transactionStarted !== false) {
            obj.transactionStarted = message.transactionStarted;
        }
        if (message.evccid !== "") {
            obj.evccid = message.evccid;
        }
        if (message.faultCode !== "") {
            obj.faultCode = message.faultCode;
        }
        if (message.transactionStartTime !== undefined) {
            obj.transactionStartTime = message.transactionStartTime.toISOString();
        }
        if (message.perPortPowerLimits !== false) {
            obj.perPortPowerLimits = message.perPortPowerLimits;
        }
        if (message.membershipReady !== false) {
            obj.membershipReady = message.membershipReady;
        }
        if (message.ocpiTrackingId !== undefined) {
            obj.ocpiTrackingId = message.ocpiTrackingId;
        }
        if (message.unavailableReasons?.length) {
            obj.unavailableReasons = message.unavailableReasons.map((e) => (0, charger_1.unavailableReasonToJSON)(e));
        }
        if (message.availability !== 0) {
            obj.availability = chargerAvailabilityToJSON(message.availability);
        }
        if (message.chargingState !== undefined) {
            obj.chargingState = (0, charger_1.ocppChargingStateToJSON)(message.chargingState);
        }
        if (message.connectorState !== undefined) {
            obj.connectorState = (0, charging_session_attempt_1.chargerPortStateToJSON)(message.connectorState);
        }
        return obj;
    },
    create(base) {
        return exports.PortHealth.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePortHealth();
        message.portId = object.portId ?? 0;
        message.ocppStatus = object.ocppStatus ?? "";
        message.powerKw = object.powerKw ?? 0;
        message.powerLimitKw = object.powerLimitKw ?? 0;
        message.powerRequestedKw = object.powerRequestedKw ?? 0;
        message.carSoc = object.carSoc ?? 0;
        message.energyDelivered = object.energyDelivered ?? 0;
        message.pluggedIn = object.pluggedIn ?? false;
        message.paymentReady = object.paymentReady ?? false;
        message.transactionStarted = object.transactionStarted ?? false;
        message.evccid = object.evccid ?? "";
        message.faultCode = object.faultCode ?? "";
        message.transactionStartTime = object.transactionStartTime ?? undefined;
        message.perPortPowerLimits = object.perPortPowerLimits ?? false;
        message.membershipReady = object.membershipReady ?? false;
        message.ocpiTrackingId = object.ocpiTrackingId ?? undefined;
        message.unavailableReasons = object.unavailableReasons?.map((e) => e) || [];
        message.availability = object.availability ?? 0;
        message.chargingState = object.chargingState ?? undefined;
        message.connectorState = object.connectorState ?? undefined;
        return message;
    },
};
function createBaseChargerHealth() {
    return { ocppId: "", availability: 0, portHealth: [] };
}
exports.ChargerHealth = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.ocppId !== "") {
            writer.uint32(10).string(message.ocppId);
        }
        if (message.availability !== 0) {
            writer.uint32(16).int32(message.availability);
        }
        for (const v of message.portHealth) {
            exports.PortHealth.encode(v, writer.uint32(26).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChargerHealth();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.ocppId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.availability = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.portHealth.push(exports.PortHealth.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            ocppId: isSet(object.ocppId)
                ? globalThis.String(object.ocppId)
                : isSet(object.ocpp_id)
                    ? globalThis.String(object.ocpp_id)
                    : "",
            availability: isSet(object.availability)
                ? chargerAvailabilityFromJSON(object.availability)
                : 0,
            portHealth: globalThis.Array.isArray(object?.portHealth)
                ? object.portHealth.map((e) => exports.PortHealth.fromJSON(e))
                : globalThis.Array.isArray(object?.port_health)
                    ? object.port_health.map((e) => exports.PortHealth.fromJSON(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ocppId !== "") {
            obj.ocppId = message.ocppId;
        }
        if (message.availability !== 0) {
            obj.availability = chargerAvailabilityToJSON(message.availability);
        }
        if (message.portHealth?.length) {
            obj.portHealth = message.portHealth.map((e) => exports.PortHealth.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ChargerHealth.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChargerHealth();
        message.ocppId = object.ocppId ?? "";
        message.availability = object.availability ?? 0;
        message.portHealth =
            object.portHealth?.map((e) => exports.PortHealth.fromPartial(e)) || [];
        return message;
    },
};
function createBaseUpdateStatusRequest() {
    return {
        chargerHealth: [],
        requestTime: undefined,
        processStartTime: undefined,
    };
}
exports.UpdateStatusRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.chargerHealth) {
            exports.ChargerHealth.encode(v, writer.uint32(18).fork()).join();
        }
        if (message.requestTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.requestTime), writer.uint32(26).fork()).join();
        }
        if (message.processStartTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.processStartTime), writer.uint32(34).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateStatusRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.chargerHealth.push(exports.ChargerHealth.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.requestTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.processStartTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chargerHealth: globalThis.Array.isArray(object?.chargerHealth)
                ? object.chargerHealth.map((e) => exports.ChargerHealth.fromJSON(e))
                : globalThis.Array.isArray(object?.charger_health)
                    ? object.charger_health.map((e) => exports.ChargerHealth.fromJSON(e))
                    : [],
            requestTime: isSet(object.requestTime)
                ? fromJsonTimestamp(object.requestTime)
                : isSet(object.request_time)
                    ? fromJsonTimestamp(object.request_time)
                    : undefined,
            processStartTime: isSet(object.processStartTime)
                ? fromJsonTimestamp(object.processStartTime)
                : isSet(object.process_start_time)
                    ? fromJsonTimestamp(object.process_start_time)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chargerHealth?.length) {
            obj.chargerHealth = message.chargerHealth.map((e) => exports.ChargerHealth.toJSON(e));
        }
        if (message.requestTime !== undefined) {
            obj.requestTime = message.requestTime.toISOString();
        }
        if (message.processStartTime !== undefined) {
            obj.processStartTime = message.processStartTime.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.UpdateStatusRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateStatusRequest();
        message.chargerHealth =
            object.chargerHealth?.map((e) => exports.ChargerHealth.fromPartial(e)) || [];
        message.requestTime = object.requestTime ?? undefined;
        message.processStartTime = object.processStartTime ?? undefined;
        return message;
    },
};
function createBaseSiteEnvironment() {
    return {
        latitude: 0,
        longitude: 0,
        sunrise: undefined,
        sunset: undefined,
        ambientTemperatureC: undefined,
        precipitationMm: undefined,
        weatherCode: undefined,
        lastUpdated: undefined,
    };
}
exports.SiteEnvironment = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.latitude !== 0) {
            writer.uint32(9).double(message.latitude);
        }
        if (message.longitude !== 0) {
            writer.uint32(17).double(message.longitude);
        }
        if (message.sunrise !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.sunrise), writer.uint32(26).fork()).join();
        }
        if (message.sunset !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.sunset), writer.uint32(34).fork()).join();
        }
        if (message.ambientTemperatureC !== undefined) {
            writer.uint32(45).float(message.ambientTemperatureC);
        }
        if (message.precipitationMm !== undefined) {
            writer.uint32(53).float(message.precipitationMm);
        }
        if (message.weatherCode !== undefined) {
            writer.uint32(56).int32(message.weatherCode);
        }
        if (message.lastUpdated !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.lastUpdated), writer.uint32(66).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSiteEnvironment();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 9) {
                        break;
                    }
                    message.latitude = reader.double();
                    continue;
                }
                case 2: {
                    if (tag !== 17) {
                        break;
                    }
                    message.longitude = reader.double();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.sunrise = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.sunset = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 5: {
                    if (tag !== 45) {
                        break;
                    }
                    message.ambientTemperatureC = reader.float();
                    continue;
                }
                case 6: {
                    if (tag !== 53) {
                        break;
                    }
                    message.precipitationMm = reader.float();
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.weatherCode = reader.int32();
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.lastUpdated = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
            longitude: isSet(object.longitude)
                ? globalThis.Number(object.longitude)
                : 0,
            sunrise: isSet(object.sunrise)
                ? fromJsonTimestamp(object.sunrise)
                : undefined,
            sunset: isSet(object.sunset)
                ? fromJsonTimestamp(object.sunset)
                : undefined,
            ambientTemperatureC: isSet(object.ambientTemperatureC)
                ? globalThis.Number(object.ambientTemperatureC)
                : isSet(object.ambient_temperature_c)
                    ? globalThis.Number(object.ambient_temperature_c)
                    : undefined,
            precipitationMm: isSet(object.precipitationMm)
                ? globalThis.Number(object.precipitationMm)
                : isSet(object.precipitation_mm)
                    ? globalThis.Number(object.precipitation_mm)
                    : undefined,
            weatherCode: isSet(object.weatherCode)
                ? weatherCodeFromJSON(object.weatherCode)
                : isSet(object.weather_code)
                    ? weatherCodeFromJSON(object.weather_code)
                    : undefined,
            lastUpdated: isSet(object.lastUpdated)
                ? fromJsonTimestamp(object.lastUpdated)
                : isSet(object.last_updated)
                    ? fromJsonTimestamp(object.last_updated)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.latitude !== 0) {
            obj.latitude = message.latitude;
        }
        if (message.longitude !== 0) {
            obj.longitude = message.longitude;
        }
        if (message.sunrise !== undefined) {
            obj.sunrise = message.sunrise.toISOString();
        }
        if (message.sunset !== undefined) {
            obj.sunset = message.sunset.toISOString();
        }
        if (message.ambientTemperatureC !== undefined) {
            obj.ambientTemperatureC = message.ambientTemperatureC;
        }
        if (message.precipitationMm !== undefined) {
            obj.precipitationMm = message.precipitationMm;
        }
        if (message.weatherCode !== undefined) {
            obj.weatherCode = weatherCodeToJSON(message.weatherCode);
        }
        if (message.lastUpdated !== undefined) {
            obj.lastUpdated = message.lastUpdated.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.SiteEnvironment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSiteEnvironment();
        message.latitude = object.latitude ?? 0;
        message.longitude = object.longitude ?? 0;
        message.sunrise = object.sunrise ?? undefined;
        message.sunset = object.sunset ?? undefined;
        message.ambientTemperatureC = object.ambientTemperatureC ?? undefined;
        message.precipitationMm = object.precipitationMm ?? undefined;
        message.weatherCode = object.weatherCode ?? undefined;
        message.lastUpdated = object.lastUpdated ?? undefined;
        return message;
    },
};
function createBaseGetSiteEnvironmentRequest() {
    return { siteId: 0 };
}
exports.GetSiteEnvironmentRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.siteId !== 0) {
            writer.uint32(8).int32(message.siteId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetSiteEnvironmentRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.siteId = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            siteId: isSet(object.siteId)
                ? globalThis.Number(object.siteId)
                : isSet(object.site_id)
                    ? globalThis.Number(object.site_id)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.siteId !== 0) {
            obj.siteId = Math.round(message.siteId);
        }
        return obj;
    },
    create(base) {
        return exports.GetSiteEnvironmentRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetSiteEnvironmentRequest();
        message.siteId = object.siteId ?? 0;
        return message;
    },
};
function createBaseGetSiteEnvironmentResponse() {
    return { siteEnvironment: undefined };
}
exports.GetSiteEnvironmentResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.siteEnvironment !== undefined) {
            exports.SiteEnvironment.encode(message.siteEnvironment, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetSiteEnvironmentResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.siteEnvironment = exports.SiteEnvironment.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            siteEnvironment: isSet(object.siteEnvironment)
                ? exports.SiteEnvironment.fromJSON(object.siteEnvironment)
                : isSet(object.site_environment)
                    ? exports.SiteEnvironment.fromJSON(object.site_environment)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.siteEnvironment !== undefined) {
            obj.siteEnvironment = exports.SiteEnvironment.toJSON(message.siteEnvironment);
        }
        return obj;
    },
    create(base) {
        return exports.GetSiteEnvironmentResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetSiteEnvironmentResponse();
        message.siteEnvironment =
            object.siteEnvironment !== undefined && object.siteEnvironment !== null
                ? exports.SiteEnvironment.fromPartial(object.siteEnvironment)
                : undefined;
        return message;
    },
};
function createBaseUpdateStatusResponse() {
    return { pendingCommandCount: 0 };
}
exports.UpdateStatusResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pendingCommandCount !== 0) {
            writer.uint32(8).int32(message.pendingCommandCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateStatusResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pendingCommandCount = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pendingCommandCount: isSet(object.pendingCommandCount)
                ? globalThis.Number(object.pendingCommandCount)
                : isSet(object.pending_command_count)
                    ? globalThis.Number(object.pending_command_count)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pendingCommandCount !== 0) {
            obj.pendingCommandCount = Math.round(message.pendingCommandCount);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateStatusResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateStatusResponse();
        message.pendingCommandCount = object.pendingCommandCount ?? 0;
        return message;
    },
};
function createBaseUpdatePowernodeStatusRequest() {
    return {
        pnid: 0,
        soc: 0,
        chargeRate: 0,
        batteryStatus: 0,
        powernodeStatus: 0,
        requestTime: undefined,
        activePowerProfileId: undefined,
    };
}
exports.UpdatePowernodeStatusRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pnid !== 0) {
            writer.uint32(8).int32(message.pnid);
        }
        if (message.soc !== 0) {
            writer.uint32(21).float(message.soc);
        }
        if (message.chargeRate !== 0) {
            writer.uint32(29).float(message.chargeRate);
        }
        if (message.batteryStatus !== 0) {
            writer.uint32(32).int32(message.batteryStatus);
        }
        if (message.powernodeStatus !== 0) {
            writer.uint32(40).int32(message.powernodeStatus);
        }
        if (message.requestTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.requestTime), writer.uint32(50).fork()).join();
        }
        if (message.activePowerProfileId !== undefined) {
            writer.uint32(56).int32(message.activePowerProfileId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdatePowernodeStatusRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pnid = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 21) {
                        break;
                    }
                    message.soc = reader.float();
                    continue;
                }
                case 3: {
                    if (tag !== 29) {
                        break;
                    }
                    message.chargeRate = reader.float();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.batteryStatus = reader.int32();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.powernodeStatus = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.requestTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.activePowerProfileId = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pnid: isSet(object.pnid) ? globalThis.Number(object.pnid) : 0,
            soc: isSet(object.soc) ? globalThis.Number(object.soc) : 0,
            chargeRate: isSet(object.chargeRate)
                ? globalThis.Number(object.chargeRate)
                : isSet(object.charge_rate)
                    ? globalThis.Number(object.charge_rate)
                    : 0,
            batteryStatus: isSet(object.batteryStatus)
                ? batteryStatusFromJSON(object.batteryStatus)
                : isSet(object.battery_status)
                    ? batteryStatusFromJSON(object.battery_status)
                    : 0,
            powernodeStatus: isSet(object.powernodeStatus)
                ? powernodeStatusFromJSON(object.powernodeStatus)
                : isSet(object.powernode_status)
                    ? powernodeStatusFromJSON(object.powernode_status)
                    : 0,
            requestTime: isSet(object.requestTime)
                ? fromJsonTimestamp(object.requestTime)
                : isSet(object.request_time)
                    ? fromJsonTimestamp(object.request_time)
                    : undefined,
            activePowerProfileId: isSet(object.activePowerProfileId)
                ? globalThis.Number(object.activePowerProfileId)
                : isSet(object.active_power_profile_id)
                    ? globalThis.Number(object.active_power_profile_id)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pnid !== 0) {
            obj.pnid = Math.round(message.pnid);
        }
        if (message.soc !== 0) {
            obj.soc = message.soc;
        }
        if (message.chargeRate !== 0) {
            obj.chargeRate = message.chargeRate;
        }
        if (message.batteryStatus !== 0) {
            obj.batteryStatus = batteryStatusToJSON(message.batteryStatus);
        }
        if (message.powernodeStatus !== 0) {
            obj.powernodeStatus = powernodeStatusToJSON(message.powernodeStatus);
        }
        if (message.requestTime !== undefined) {
            obj.requestTime = message.requestTime.toISOString();
        }
        if (message.activePowerProfileId !== undefined) {
            obj.activePowerProfileId = Math.round(message.activePowerProfileId);
        }
        return obj;
    },
    create(base) {
        return exports.UpdatePowernodeStatusRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdatePowernodeStatusRequest();
        message.pnid = object.pnid ?? 0;
        message.soc = object.soc ?? 0;
        message.chargeRate = object.chargeRate ?? 0;
        message.batteryStatus = object.batteryStatus ?? 0;
        message.powernodeStatus = object.powernodeStatus ?? 0;
        message.requestTime = object.requestTime ?? undefined;
        message.activePowerProfileId = object.activePowerProfileId ?? undefined;
        return message;
    },
};
function createBaseUpdatePowernodeStatusResponse() {
    return { pendingCommandCount: 0 };
}
exports.UpdatePowernodeStatusResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pendingCommandCount !== 0) {
            writer.uint32(8).int32(message.pendingCommandCount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdatePowernodeStatusResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pendingCommandCount = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pendingCommandCount: isSet(object.pendingCommandCount)
                ? globalThis.Number(object.pendingCommandCount)
                : isSet(object.pending_command_count)
                    ? globalThis.Number(object.pending_command_count)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pendingCommandCount !== 0) {
            obj.pendingCommandCount = Math.round(message.pendingCommandCount);
        }
        return obj;
    },
    create(base) {
        return exports.UpdatePowernodeStatusResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdatePowernodeStatusResponse();
        message.pendingCommandCount = object.pendingCommandCount ?? 0;
        return message;
    },
};
function createBasePowerEntity() {
    return { name: "", powerKw: 0, type: 0 };
}
exports.PowerEntity = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.powerKw !== 0) {
            writer.uint32(21).float(message.powerKw);
        }
        if (message.type !== 0) {
            writer.uint32(24).int32(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePowerEntity();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 21) {
                        break;
                    }
                    message.powerKw = reader.float();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            powerKw: isSet(object.powerKw)
                ? globalThis.Number(object.powerKw)
                : isSet(object.power_kw)
                    ? globalThis.Number(object.power_kw)
                    : 0,
            type: isSet(object.type) ? entityTypeFromJSON(object.type) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.powerKw !== 0) {
            obj.powerKw = message.powerKw;
        }
        if (message.type !== 0) {
            obj.type = entityTypeToJSON(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.PowerEntity.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePowerEntity();
        message.name = object.name ?? "";
        message.powerKw = object.powerKw ?? 0;
        message.type = object.type ?? 0;
        return message;
    },
};
function createBasePowerSnapshot() {
    return { entites: [], baseload: 0, gridPowerKw: 0 };
}
exports.PowerSnapshot = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.entites) {
            exports.PowerEntity.encode(v, writer.uint32(10).fork()).join();
        }
        if (message.baseload !== 0) {
            writer.uint32(21).float(message.baseload);
        }
        if (message.gridPowerKw !== 0) {
            writer.uint32(29).float(message.gridPowerKw);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePowerSnapshot();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.entites.push(exports.PowerEntity.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 21) {
                        break;
                    }
                    message.baseload = reader.float();
                    continue;
                }
                case 3: {
                    if (tag !== 29) {
                        break;
                    }
                    message.gridPowerKw = reader.float();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            entites: globalThis.Array.isArray(object?.entites)
                ? object.entites.map((e) => exports.PowerEntity.fromJSON(e))
                : [],
            baseload: isSet(object.baseload) ? globalThis.Number(object.baseload) : 0,
            gridPowerKw: isSet(object.gridPowerKw)
                ? globalThis.Number(object.gridPowerKw)
                : isSet(object.grid_power_kw)
                    ? globalThis.Number(object.grid_power_kw)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.entites?.length) {
            obj.entites = message.entites.map((e) => exports.PowerEntity.toJSON(e));
        }
        if (message.baseload !== 0) {
            obj.baseload = message.baseload;
        }
        if (message.gridPowerKw !== 0) {
            obj.gridPowerKw = message.gridPowerKw;
        }
        return obj;
    },
    create(base) {
        return exports.PowerSnapshot.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePowerSnapshot();
        message.entites =
            object.entites?.map((e) => exports.PowerEntity.fromPartial(e)) || [];
        message.baseload = object.baseload ?? 0;
        message.gridPowerKw = object.gridPowerKw ?? 0;
        return message;
    },
};
function createBaseUpdateSitePowerMeterStatusRequest() {
    return {
        pnid: 0,
        requestTime: undefined,
        energyKwh: 0,
        powerSnapshot: undefined,
    };
}
exports.UpdateSitePowerMeterStatusRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pnid !== 0) {
            writer.uint32(8).int32(message.pnid);
        }
        if (message.requestTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.requestTime), writer.uint32(18).fork()).join();
        }
        if (message.energyKwh !== 0) {
            writer.uint32(29).float(message.energyKwh);
        }
        if (message.powerSnapshot !== undefined) {
            exports.PowerSnapshot.encode(message.powerSnapshot, writer.uint32(34).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateSitePowerMeterStatusRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pnid = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.requestTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 29) {
                        break;
                    }
                    message.energyKwh = reader.float();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.powerSnapshot = exports.PowerSnapshot.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pnid: isSet(object.pnid) ? globalThis.Number(object.pnid) : 0,
            requestTime: isSet(object.requestTime)
                ? fromJsonTimestamp(object.requestTime)
                : isSet(object.request_time)
                    ? fromJsonTimestamp(object.request_time)
                    : undefined,
            energyKwh: isSet(object.energyKwh)
                ? globalThis.Number(object.energyKwh)
                : isSet(object.energy_kwh)
                    ? globalThis.Number(object.energy_kwh)
                    : 0,
            powerSnapshot: isSet(object.powerSnapshot)
                ? exports.PowerSnapshot.fromJSON(object.powerSnapshot)
                : isSet(object.power_snapshot)
                    ? exports.PowerSnapshot.fromJSON(object.power_snapshot)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pnid !== 0) {
            obj.pnid = Math.round(message.pnid);
        }
        if (message.requestTime !== undefined) {
            obj.requestTime = message.requestTime.toISOString();
        }
        if (message.energyKwh !== 0) {
            obj.energyKwh = message.energyKwh;
        }
        if (message.powerSnapshot !== undefined) {
            obj.powerSnapshot = exports.PowerSnapshot.toJSON(message.powerSnapshot);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateSitePowerMeterStatusRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateSitePowerMeterStatusRequest();
        message.pnid = object.pnid ?? 0;
        message.requestTime = object.requestTime ?? undefined;
        message.energyKwh = object.energyKwh ?? 0;
        message.powerSnapshot =
            object.powerSnapshot !== undefined && object.powerSnapshot !== null
                ? exports.PowerSnapshot.fromPartial(object.powerSnapshot)
                : undefined;
        return message;
    },
};
function createBaseUpdateSitePowerMeterStatusResponse() {
    return {};
}
exports.UpdateSitePowerMeterStatusResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateSitePowerMeterStatusResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UpdateSitePowerMeterStatusResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUpdateSitePowerMeterStatusResponse();
        return message;
    },
};
function createBasePowerProfile() {
    return {
        id: 0,
        targetSoc: undefined,
        gridLimit: undefined,
        cron: [],
        gridUseFirstBelowTargetSoc: undefined,
        gridUseFirstAboveTargetSoc: undefined,
        rechargeToTarget: undefined,
    };
}
exports.PowerProfile = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== 0) {
            writer.uint32(8).int32(message.id);
        }
        if (message.targetSoc !== undefined) {
            writer.uint32(16).int32(message.targetSoc);
        }
        if (message.gridLimit !== undefined) {
            writer.uint32(24).int32(message.gridLimit);
        }
        for (const v of message.cron) {
            writer.uint32(34).string(v);
        }
        if (message.gridUseFirstBelowTargetSoc !== undefined) {
            writer.uint32(40).int32(message.gridUseFirstBelowTargetSoc);
        }
        if (message.gridUseFirstAboveTargetSoc !== undefined) {
            writer.uint32(48).int32(message.gridUseFirstAboveTargetSoc);
        }
        if (message.rechargeToTarget !== undefined) {
            writer.uint32(56).bool(message.rechargeToTarget);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePowerProfile();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.id = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.targetSoc = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.gridLimit = reader.int32();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.cron.push(reader.string());
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.gridUseFirstBelowTargetSoc = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.gridUseFirstAboveTargetSoc = reader.int32();
                    continue;
                }
                case 7: {
                    if (tag !== 56) {
                        break;
                    }
                    message.rechargeToTarget = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            targetSoc: isSet(object.targetSoc)
                ? globalThis.Number(object.targetSoc)
                : isSet(object.target_soc)
                    ? globalThis.Number(object.target_soc)
                    : undefined,
            gridLimit: isSet(object.gridLimit)
                ? globalThis.Number(object.gridLimit)
                : isSet(object.grid_limit)
                    ? globalThis.Number(object.grid_limit)
                    : undefined,
            cron: globalThis.Array.isArray(object?.cron)
                ? object.cron.map((e) => globalThis.String(e))
                : [],
            gridUseFirstBelowTargetSoc: isSet(object.gridUseFirstBelowTargetSoc)
                ? globalThis.Number(object.gridUseFirstBelowTargetSoc)
                : isSet(object.grid_use_first_below_target_soc)
                    ? globalThis.Number(object.grid_use_first_below_target_soc)
                    : undefined,
            gridUseFirstAboveTargetSoc: isSet(object.gridUseFirstAboveTargetSoc)
                ? globalThis.Number(object.gridUseFirstAboveTargetSoc)
                : isSet(object.grid_use_first_above_target_soc)
                    ? globalThis.Number(object.grid_use_first_above_target_soc)
                    : undefined,
            rechargeToTarget: isSet(object.rechargeToTarget)
                ? globalThis.Boolean(object.rechargeToTarget)
                : isSet(object.recharge_to_target)
                    ? globalThis.Boolean(object.recharge_to_target)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.targetSoc !== undefined) {
            obj.targetSoc = Math.round(message.targetSoc);
        }
        if (message.gridLimit !== undefined) {
            obj.gridLimit = Math.round(message.gridLimit);
        }
        if (message.cron?.length) {
            obj.cron = message.cron;
        }
        if (message.gridUseFirstBelowTargetSoc !== undefined) {
            obj.gridUseFirstBelowTargetSoc = Math.round(message.gridUseFirstBelowTargetSoc);
        }
        if (message.gridUseFirstAboveTargetSoc !== undefined) {
            obj.gridUseFirstAboveTargetSoc = Math.round(message.gridUseFirstAboveTargetSoc);
        }
        if (message.rechargeToTarget !== undefined) {
            obj.rechargeToTarget = message.rechargeToTarget;
        }
        return obj;
    },
    create(base) {
        return exports.PowerProfile.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePowerProfile();
        message.id = object.id ?? 0;
        message.targetSoc = object.targetSoc ?? undefined;
        message.gridLimit = object.gridLimit ?? undefined;
        message.cron = object.cron?.map((e) => e) || [];
        message.gridUseFirstBelowTargetSoc =
            object.gridUseFirstBelowTargetSoc ?? undefined;
        message.gridUseFirstAboveTargetSoc =
            object.gridUseFirstAboveTargetSoc ?? undefined;
        message.rechargeToTarget = object.rechargeToTarget ?? undefined;
        return message;
    },
};
function createBasePowerProfileSchedule() {
    return {
        id: 0,
        priority: 0,
        timeOffsetFromUtcSeconds: 0,
        effectiveDate: undefined,
        expirationDate: undefined,
        profiles: [],
    };
}
exports.PowerProfileSchedule = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== 0) {
            writer.uint32(8).int32(message.id);
        }
        if (message.priority !== 0) {
            writer.uint32(16).int32(message.priority);
        }
        if (message.timeOffsetFromUtcSeconds !== 0) {
            writer.uint32(24).int32(message.timeOffsetFromUtcSeconds);
        }
        if (message.effectiveDate !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.effectiveDate), writer.uint32(50).fork()).join();
        }
        if (message.expirationDate !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.expirationDate), writer.uint32(34).fork()).join();
        }
        for (const v of message.profiles) {
            exports.PowerProfile.encode(v, writer.uint32(42).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePowerProfileSchedule();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.id = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.priority = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.timeOffsetFromUtcSeconds = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.effectiveDate = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.expirationDate = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.profiles.push(exports.PowerProfile.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            priority: isSet(object.priority) ? globalThis.Number(object.priority) : 0,
            timeOffsetFromUtcSeconds: isSet(object.timeOffsetFromUtcSeconds)
                ? globalThis.Number(object.timeOffsetFromUtcSeconds)
                : isSet(object.time_offset_from_utc_seconds)
                    ? globalThis.Number(object.time_offset_from_utc_seconds)
                    : 0,
            effectiveDate: isSet(object.effectiveDate)
                ? fromJsonTimestamp(object.effectiveDate)
                : isSet(object.effective_date)
                    ? fromJsonTimestamp(object.effective_date)
                    : undefined,
            expirationDate: isSet(object.expirationDate)
                ? fromJsonTimestamp(object.expirationDate)
                : isSet(object.expiration_date)
                    ? fromJsonTimestamp(object.expiration_date)
                    : undefined,
            profiles: globalThis.Array.isArray(object?.profiles)
                ? object.profiles.map((e) => exports.PowerProfile.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.priority !== 0) {
            obj.priority = Math.round(message.priority);
        }
        if (message.timeOffsetFromUtcSeconds !== 0) {
            obj.timeOffsetFromUtcSeconds = Math.round(message.timeOffsetFromUtcSeconds);
        }
        if (message.effectiveDate !== undefined) {
            obj.effectiveDate = message.effectiveDate.toISOString();
        }
        if (message.expirationDate !== undefined) {
            obj.expirationDate = message.expirationDate.toISOString();
        }
        if (message.profiles?.length) {
            obj.profiles = message.profiles.map((e) => exports.PowerProfile.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.PowerProfileSchedule.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePowerProfileSchedule();
        message.id = object.id ?? 0;
        message.priority = object.priority ?? 0;
        message.timeOffsetFromUtcSeconds = object.timeOffsetFromUtcSeconds ?? 0;
        message.effectiveDate = object.effectiveDate ?? undefined;
        message.expirationDate = object.expirationDate ?? undefined;
        message.profiles =
            object.profiles?.map((e) => exports.PowerProfile.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetPowerProfileScheduleRequest() {
    return { pnid: 0 };
}
exports.GetPowerProfileScheduleRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pnid !== 0) {
            writer.uint32(8).int32(message.pnid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetPowerProfileScheduleRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pnid = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { pnid: isSet(object.pnid) ? globalThis.Number(object.pnid) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.pnid !== 0) {
            obj.pnid = Math.round(message.pnid);
        }
        return obj;
    },
    create(base) {
        return exports.GetPowerProfileScheduleRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPowerProfileScheduleRequest();
        message.pnid = object.pnid ?? 0;
        return message;
    },
};
function createBaseGetPowerProfileScheduleResponse() {
    return { powerProfileSchedules: [] };
}
exports.GetPowerProfileScheduleResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.powerProfileSchedules) {
            exports.PowerProfileSchedule.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetPowerProfileScheduleResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.powerProfileSchedules.push(exports.PowerProfileSchedule.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            powerProfileSchedules: globalThis.Array.isArray(object?.powerProfileSchedules)
                ? object.powerProfileSchedules.map((e) => exports.PowerProfileSchedule.fromJSON(e))
                : globalThis.Array.isArray(object?.power_profile_schedules)
                    ? object.power_profile_schedules.map((e) => exports.PowerProfileSchedule.fromJSON(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.powerProfileSchedules?.length) {
            obj.powerProfileSchedules = message.powerProfileSchedules.map((e) => exports.PowerProfileSchedule.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetPowerProfileScheduleResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPowerProfileScheduleResponse();
        message.powerProfileSchedules =
            object.powerProfileSchedules?.map((e) => exports.PowerProfileSchedule.fromPartial(e)) || [];
        return message;
    },
};
function createBasePlugEventRequest() {
    return {
        chargerOcppId: "",
        portId: 0,
        plugUtc: undefined,
        unplugUtc: undefined,
    };
}
exports.PlugEventRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.chargerOcppId !== "") {
            writer.uint32(10).string(message.chargerOcppId);
        }
        if (message.portId !== 0) {
            writer.uint32(16).uint32(message.portId);
        }
        if (message.plugUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.plugUtc), writer.uint32(26).fork()).join();
        }
        if (message.unplugUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.unplugUtc), writer.uint32(34).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlugEventRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.chargerOcppId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.portId = reader.uint32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.plugUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.unplugUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chargerOcppId: isSet(object.chargerOcppId)
                ? globalThis.String(object.chargerOcppId)
                : isSet(object.charger_ocpp_id)
                    ? globalThis.String(object.charger_ocpp_id)
                    : "",
            portId: isSet(object.portId)
                ? globalThis.Number(object.portId)
                : isSet(object.port_id)
                    ? globalThis.Number(object.port_id)
                    : 0,
            plugUtc: isSet(object.plugUtc)
                ? fromJsonTimestamp(object.plugUtc)
                : isSet(object.plug_utc)
                    ? fromJsonTimestamp(object.plug_utc)
                    : undefined,
            unplugUtc: isSet(object.unplugUtc)
                ? fromJsonTimestamp(object.unplugUtc)
                : isSet(object.unplug_utc)
                    ? fromJsonTimestamp(object.unplug_utc)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chargerOcppId !== "") {
            obj.chargerOcppId = message.chargerOcppId;
        }
        if (message.portId !== 0) {
            obj.portId = Math.round(message.portId);
        }
        if (message.plugUtc !== undefined) {
            obj.plugUtc = message.plugUtc.toISOString();
        }
        if (message.unplugUtc !== undefined) {
            obj.unplugUtc = message.unplugUtc.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.PlugEventRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePlugEventRequest();
        message.chargerOcppId = object.chargerOcppId ?? "";
        message.portId = object.portId ?? 0;
        message.plugUtc = object.plugUtc ?? undefined;
        message.unplugUtc = object.unplugUtc ?? undefined;
        return message;
    },
};
function createBasePlugEventResponse() {
    return {};
}
exports.PlugEventResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePlugEventResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.PlugEventResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBasePlugEventResponse();
        return message;
    },
};
function createBaseChargerFeedbackRequest() {
    return {
        chargerOcppId: "",
        portId: 0,
        timeUtc: undefined,
        rating: 0,
        feedback: "",
        reportedIssues: [],
    };
}
exports.ChargerFeedbackRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.chargerOcppId !== "") {
            writer.uint32(10).string(message.chargerOcppId);
        }
        if (message.portId !== 0) {
            writer.uint32(16).uint32(message.portId);
        }
        if (message.timeUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.timeUtc), writer.uint32(26).fork()).join();
        }
        if (message.rating !== 0) {
            writer.uint32(32).uint32(message.rating);
        }
        if (message.feedback !== "") {
            writer.uint32(42).string(message.feedback);
        }
        writer.uint32(50).fork();
        for (const v of message.reportedIssues) {
            writer.int32(v);
        }
        writer.join();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChargerFeedbackRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.chargerOcppId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.portId = reader.uint32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.timeUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.rating = reader.uint32();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.feedback = reader.string();
                    continue;
                }
                case 6: {
                    if (tag === 48) {
                        message.reportedIssues.push(reader.int32());
                        continue;
                    }
                    if (tag === 50) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.reportedIssues.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chargerOcppId: isSet(object.chargerOcppId)
                ? globalThis.String(object.chargerOcppId)
                : isSet(object.charger_ocpp_id)
                    ? globalThis.String(object.charger_ocpp_id)
                    : "",
            portId: isSet(object.portId)
                ? globalThis.Number(object.portId)
                : isSet(object.port_id)
                    ? globalThis.Number(object.port_id)
                    : 0,
            timeUtc: isSet(object.timeUtc)
                ? fromJsonTimestamp(object.timeUtc)
                : isSet(object.time_utc)
                    ? fromJsonTimestamp(object.time_utc)
                    : undefined,
            rating: isSet(object.rating) ? globalThis.Number(object.rating) : 0,
            feedback: isSet(object.feedback)
                ? globalThis.String(object.feedback)
                : "",
            reportedIssues: globalThis.Array.isArray(object?.reportedIssues)
                ? object.reportedIssues.map((e) => (0, charger_1.reportedFeedbackIssueFromJSON)(e))
                : globalThis.Array.isArray(object?.reported_issues)
                    ? object.reported_issues.map((e) => (0, charger_1.reportedFeedbackIssueFromJSON)(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chargerOcppId !== "") {
            obj.chargerOcppId = message.chargerOcppId;
        }
        if (message.portId !== 0) {
            obj.portId = Math.round(message.portId);
        }
        if (message.timeUtc !== undefined) {
            obj.timeUtc = message.timeUtc.toISOString();
        }
        if (message.rating !== 0) {
            obj.rating = Math.round(message.rating);
        }
        if (message.feedback !== "") {
            obj.feedback = message.feedback;
        }
        if (message.reportedIssues?.length) {
            obj.reportedIssues = message.reportedIssues.map((e) => (0, charger_1.reportedFeedbackIssueToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.ChargerFeedbackRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChargerFeedbackRequest();
        message.chargerOcppId = object.chargerOcppId ?? "";
        message.portId = object.portId ?? 0;
        message.timeUtc = object.timeUtc ?? undefined;
        message.rating = object.rating ?? 0;
        message.feedback = object.feedback ?? "";
        message.reportedIssues = object.reportedIssues?.map((e) => e) || [];
        return message;
    },
};
function createBaseChargerFeedbackResponse() {
    return {};
}
exports.ChargerFeedbackResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChargerFeedbackResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ChargerFeedbackResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseChargerFeedbackResponse();
        return message;
    },
};
function createBaseOnScreenValidationFeedbackRequest() {
    return {
        timestamp: undefined,
        thumbsUp: false,
        chargingSessionAttemptId: "",
    };
}
exports.OnScreenValidationFeedbackRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.timestamp !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(10).fork()).join();
        }
        if (message.thumbsUp !== false) {
            writer.uint32(16).bool(message.thumbsUp);
        }
        if (message.chargingSessionAttemptId !== "") {
            writer.uint32(26).string(message.chargingSessionAttemptId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOnScreenValidationFeedbackRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.timestamp = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.thumbsUp = reader.bool();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.chargingSessionAttemptId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            timestamp: isSet(object.timestamp)
                ? fromJsonTimestamp(object.timestamp)
                : undefined,
            thumbsUp: isSet(object.thumbsUp)
                ? globalThis.Boolean(object.thumbsUp)
                : isSet(object.thumbs_up)
                    ? globalThis.Boolean(object.thumbs_up)
                    : false,
            chargingSessionAttemptId: isSet(object.chargingSessionAttemptId)
                ? globalThis.String(object.chargingSessionAttemptId)
                : isSet(object.charging_session_attempt_id)
                    ? globalThis.String(object.charging_session_attempt_id)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.timestamp !== undefined) {
            obj.timestamp = message.timestamp.toISOString();
        }
        if (message.thumbsUp !== false) {
            obj.thumbsUp = message.thumbsUp;
        }
        if (message.chargingSessionAttemptId !== "") {
            obj.chargingSessionAttemptId = message.chargingSessionAttemptId;
        }
        return obj;
    },
    create(base) {
        return exports.OnScreenValidationFeedbackRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOnScreenValidationFeedbackRequest();
        message.timestamp = object.timestamp ?? undefined;
        message.thumbsUp = object.thumbsUp ?? false;
        message.chargingSessionAttemptId = object.chargingSessionAttemptId ?? "";
        return message;
    },
};
function createBaseOnScreenValidationFeedbackResponse() {
    return {};
}
exports.OnScreenValidationFeedbackResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOnScreenValidationFeedbackResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.OnScreenValidationFeedbackResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseOnScreenValidationFeedbackResponse();
        return message;
    },
};
function createBaseGetCustomerInformationRequest() {
    return { paymentToken: "", siteId: 0 };
}
exports.GetCustomerInformationRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.paymentToken !== "") {
            writer.uint32(10).string(message.paymentToken);
        }
        if (message.siteId !== 0) {
            writer.uint32(16).int32(message.siteId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetCustomerInformationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.paymentToken = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.siteId = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            paymentToken: isSet(object.paymentToken)
                ? globalThis.String(object.paymentToken)
                : isSet(object.payment_token)
                    ? globalThis.String(object.payment_token)
                    : "",
            siteId: isSet(object.siteId)
                ? globalThis.Number(object.siteId)
                : isSet(object.site_id)
                    ? globalThis.Number(object.site_id)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentToken !== "") {
            obj.paymentToken = message.paymentToken;
        }
        if (message.siteId !== 0) {
            obj.siteId = Math.round(message.siteId);
        }
        return obj;
    },
    create(base) {
        return exports.GetCustomerInformationRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCustomerInformationRequest();
        message.paymentToken = object.paymentToken ?? "";
        message.siteId = object.siteId ?? 0;
        return message;
    },
};
function createBaseGetCustomerInformationResponse() {
    return {
        previousSessionCount: 0,
        pricingChangedSinceLastTransactionAtSite: false,
    };
}
exports.GetCustomerInformationResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.previousSessionCount !== 0) {
            writer.uint32(8).uint32(message.previousSessionCount);
        }
        if (message.pricingChangedSinceLastTransactionAtSite !== false) {
            writer
                .uint32(16)
                .bool(message.pricingChangedSinceLastTransactionAtSite);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetCustomerInformationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.previousSessionCount = reader.uint32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.pricingChangedSinceLastTransactionAtSite = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            previousSessionCount: isSet(object.previousSessionCount)
                ? globalThis.Number(object.previousSessionCount)
                : isSet(object.previous_session_count)
                    ? globalThis.Number(object.previous_session_count)
                    : 0,
            pricingChangedSinceLastTransactionAtSite: isSet(object.pricingChangedSinceLastTransactionAtSite)
                ? globalThis.Boolean(object.pricingChangedSinceLastTransactionAtSite)
                : isSet(object.pricing_changed_since_last_transaction_at_site)
                    ? globalThis.Boolean(object.pricing_changed_since_last_transaction_at_site)
                    : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.previousSessionCount !== 0) {
            obj.previousSessionCount = Math.round(message.previousSessionCount);
        }
        if (message.pricingChangedSinceLastTransactionAtSite !== false) {
            obj.pricingChangedSinceLastTransactionAtSite =
                message.pricingChangedSinceLastTransactionAtSite;
        }
        return obj;
    },
    create(base) {
        return exports.GetCustomerInformationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCustomerInformationResponse();
        message.previousSessionCount = object.previousSessionCount ?? 0;
        message.pricingChangedSinceLastTransactionAtSite =
            object.pricingChangedSinceLastTransactionAtSite ?? false;
        return message;
    },
};
function createBaseGetThemeRequest() {
    return { pnid: 0 };
}
exports.GetThemeRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pnid !== 0) {
            writer.uint32(8).int32(message.pnid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetThemeRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pnid = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { pnid: isSet(object.pnid) ? globalThis.Number(object.pnid) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.pnid !== 0) {
            obj.pnid = Math.round(message.pnid);
        }
        return obj;
    },
    create(base) {
        return exports.GetThemeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetThemeRequest();
        message.pnid = object.pnid ?? 0;
        return message;
    },
};
function createBaseGetThemeResponse() {
    return { theme: undefined };
}
exports.GetThemeResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.theme !== undefined) {
            charger_1.Theme.encode(message.theme, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetThemeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.theme = charger_1.Theme.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            theme: isSet(object.theme) ? charger_1.Theme.fromJSON(object.theme) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.theme !== undefined) {
            obj.theme = charger_1.Theme.toJSON(message.theme);
        }
        return obj;
    },
    create(base) {
        return exports.GetThemeResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetThemeResponse();
        message.theme =
            object.theme !== undefined && object.theme !== null
                ? charger_1.Theme.fromPartial(object.theme)
                : undefined;
        return message;
    },
};
function createBaseGetUiConfigRequest() {
    return { pnid: 0 };
}
exports.GetUiConfigRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pnid !== 0) {
            writer.uint32(8).int32(message.pnid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetUiConfigRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pnid = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { pnid: isSet(object.pnid) ? globalThis.Number(object.pnid) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.pnid !== 0) {
            obj.pnid = Math.round(message.pnid);
        }
        return obj;
    },
    create(base) {
        return exports.GetUiConfigRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUiConfigRequest();
        message.pnid = object.pnid ?? 0;
        return message;
    },
};
function createBaseGetUiConfigResponse() {
    return { uiConfig: undefined };
}
exports.GetUiConfigResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.uiConfig !== undefined) {
            charger_1.UiConfig.encode(message.uiConfig, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetUiConfigResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.uiConfig = charger_1.UiConfig.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            uiConfig: isSet(object.uiConfig)
                ? charger_1.UiConfig.fromJSON(object.uiConfig)
                : isSet(object.ui_config)
                    ? charger_1.UiConfig.fromJSON(object.ui_config)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.uiConfig !== undefined) {
            obj.uiConfig = charger_1.UiConfig.toJSON(message.uiConfig);
        }
        return obj;
    },
    create(base) {
        return exports.GetUiConfigResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUiConfigResponse();
        message.uiConfig =
            object.uiConfig !== undefined && object.uiConfig !== null
                ? charger_1.UiConfig.fromPartial(object.uiConfig)
                : undefined;
        return message;
    },
};
function createBaseGetChargerUiConfigRequest() {
    return { ocppId: "" };
}
exports.GetChargerUiConfigRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.ocppId !== "") {
            writer.uint32(10).string(message.ocppId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChargerUiConfigRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.ocppId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            ocppId: isSet(object.ocppId)
                ? globalThis.String(object.ocppId)
                : isSet(object.ocpp_id)
                    ? globalThis.String(object.ocpp_id)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ocppId !== "") {
            obj.ocppId = message.ocppId;
        }
        return obj;
    },
    create(base) {
        return exports.GetChargerUiConfigRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChargerUiConfigRequest();
        message.ocppId = object.ocppId ?? "";
        return message;
    },
};
function createBaseGetChargerUiConfigResponse() {
    return { chargerUiConfig: undefined };
}
exports.GetChargerUiConfigResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.chargerUiConfig !== undefined) {
            charger_1.ChargerUiConfig.encode(message.chargerUiConfig, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChargerUiConfigResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.chargerUiConfig = charger_1.ChargerUiConfig.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chargerUiConfig: isSet(object.chargerUiConfig)
                ? charger_1.ChargerUiConfig.fromJSON(object.chargerUiConfig)
                : isSet(object.charger_ui_config)
                    ? charger_1.ChargerUiConfig.fromJSON(object.charger_ui_config)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chargerUiConfig !== undefined) {
            obj.chargerUiConfig = charger_1.ChargerUiConfig.toJSON(message.chargerUiConfig);
        }
        return obj;
    },
    create(base) {
        return exports.GetChargerUiConfigResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChargerUiConfigResponse();
        message.chargerUiConfig =
            object.chargerUiConfig !== undefined && object.chargerUiConfig !== null
                ? charger_1.ChargerUiConfig.fromPartial(object.chargerUiConfig)
                : undefined;
        return message;
    },
};
function createBaseGetRemotePaymentAuthorizationsRequest() {
    return { pnid: 0, notBeforeUtc: undefined };
}
exports.GetRemotePaymentAuthorizationsRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pnid !== 0) {
            writer.uint32(8).int32(message.pnid);
        }
        if (message.notBeforeUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.notBeforeUtc), writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetRemotePaymentAuthorizationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pnid = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.notBeforeUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pnid: isSet(object.pnid) ? globalThis.Number(object.pnid) : 0,
            notBeforeUtc: isSet(object.notBeforeUtc)
                ? fromJsonTimestamp(object.notBeforeUtc)
                : isSet(object.not_before_utc)
                    ? fromJsonTimestamp(object.not_before_utc)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pnid !== 0) {
            obj.pnid = Math.round(message.pnid);
        }
        if (message.notBeforeUtc !== undefined) {
            obj.notBeforeUtc = message.notBeforeUtc.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.GetRemotePaymentAuthorizationsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetRemotePaymentAuthorizationsRequest();
        message.pnid = object.pnid ?? 0;
        message.notBeforeUtc = object.notBeforeUtc ?? undefined;
        return message;
    },
};
function createBaseGetChargerRemotePaymentAuthorizationsRequest() {
    return { ocppId: "", notBeforeUtc: undefined };
}
exports.GetChargerRemotePaymentAuthorizationsRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.ocppId !== "") {
            writer.uint32(10).string(message.ocppId);
        }
        if (message.notBeforeUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.notBeforeUtc), writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChargerRemotePaymentAuthorizationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.ocppId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.notBeforeUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            ocppId: isSet(object.ocppId)
                ? globalThis.String(object.ocppId)
                : isSet(object.ocpp_id)
                    ? globalThis.String(object.ocpp_id)
                    : "",
            notBeforeUtc: isSet(object.notBeforeUtc)
                ? fromJsonTimestamp(object.notBeforeUtc)
                : isSet(object.not_before_utc)
                    ? fromJsonTimestamp(object.not_before_utc)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ocppId !== "") {
            obj.ocppId = message.ocppId;
        }
        if (message.notBeforeUtc !== undefined) {
            obj.notBeforeUtc = message.notBeforeUtc.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.GetChargerRemotePaymentAuthorizationsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChargerRemotePaymentAuthorizationsRequest();
        message.ocppId = object.ocppId ?? "";
        message.notBeforeUtc = object.notBeforeUtc ?? undefined;
        return message;
    },
};
function createBaseGetStopRemotePaymentAuthorizationsRequest() {
    return { pnid: 0, notBeforeUtc: undefined };
}
exports.GetStopRemotePaymentAuthorizationsRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pnid !== 0) {
            writer.uint32(8).int32(message.pnid);
        }
        if (message.notBeforeUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.notBeforeUtc), writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetStopRemotePaymentAuthorizationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pnid = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.notBeforeUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pnid: isSet(object.pnid) ? globalThis.Number(object.pnid) : 0,
            notBeforeUtc: isSet(object.notBeforeUtc)
                ? fromJsonTimestamp(object.notBeforeUtc)
                : isSet(object.not_before_utc)
                    ? fromJsonTimestamp(object.not_before_utc)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pnid !== 0) {
            obj.pnid = Math.round(message.pnid);
        }
        if (message.notBeforeUtc !== undefined) {
            obj.notBeforeUtc = message.notBeforeUtc.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.GetStopRemotePaymentAuthorizationsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetStopRemotePaymentAuthorizationsRequest();
        message.pnid = object.pnid ?? 0;
        message.notBeforeUtc = object.notBeforeUtc ?? undefined;
        return message;
    },
};
function createBaseGetChargerStopRemotePaymentAuthorizationsRequest() {
    return { ocppId: "", notBeforeUtc: undefined };
}
exports.GetChargerStopRemotePaymentAuthorizationsRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.ocppId !== "") {
            writer.uint32(10).string(message.ocppId);
        }
        if (message.notBeforeUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.notBeforeUtc), writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChargerStopRemotePaymentAuthorizationsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.ocppId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.notBeforeUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            ocppId: isSet(object.ocppId)
                ? globalThis.String(object.ocppId)
                : isSet(object.ocpp_id)
                    ? globalThis.String(object.ocpp_id)
                    : "",
            notBeforeUtc: isSet(object.notBeforeUtc)
                ? fromJsonTimestamp(object.notBeforeUtc)
                : isSet(object.not_before_utc)
                    ? fromJsonTimestamp(object.not_before_utc)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ocppId !== "") {
            obj.ocppId = message.ocppId;
        }
        if (message.notBeforeUtc !== undefined) {
            obj.notBeforeUtc = message.notBeforeUtc.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.GetChargerStopRemotePaymentAuthorizationsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChargerStopRemotePaymentAuthorizationsRequest();
        message.ocppId = object.ocppId ?? "";
        message.notBeforeUtc = object.notBeforeUtc ?? undefined;
        return message;
    },
};
function createBaseCommandConsoleAuthorization() {
    return { money: undefined, expiryTime: undefined };
}
exports.CommandConsoleAuthorization = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.money !== undefined) {
            money_1.Money.encode(message.money, writer.uint32(10).fork()).join();
        }
        if (message.expiryTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.expiryTime), writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommandConsoleAuthorization();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.money = money_1.Money.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.expiryTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            money: isSet(object.money) ? money_1.Money.fromJSON(object.money) : undefined,
            expiryTime: isSet(object.expiryTime)
                ? fromJsonTimestamp(object.expiryTime)
                : isSet(object.expiry_time)
                    ? fromJsonTimestamp(object.expiry_time)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.money !== undefined) {
            obj.money = money_1.Money.toJSON(message.money);
        }
        if (message.expiryTime !== undefined) {
            obj.expiryTime = message.expiryTime.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.CommandConsoleAuthorization.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCommandConsoleAuthorization();
        message.money =
            object.money !== undefined && object.money !== null
                ? money_1.Money.fromPartial(object.money)
                : undefined;
        message.expiryTime = object.expiryTime ?? undefined;
        return message;
    },
};
function createBaseOCPIRemoteAuthorization() {
    return { money: undefined, expiryTime: undefined, ocpiTrackingId: "" };
}
exports.OCPIRemoteAuthorization = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.money !== undefined) {
            money_1.Money.encode(message.money, writer.uint32(10).fork()).join();
        }
        if (message.expiryTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.expiryTime), writer.uint32(18).fork()).join();
        }
        if (message.ocpiTrackingId !== "") {
            writer.uint32(26).string(message.ocpiTrackingId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOCPIRemoteAuthorization();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.money = money_1.Money.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.expiryTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.ocpiTrackingId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            money: isSet(object.money) ? money_1.Money.fromJSON(object.money) : undefined,
            expiryTime: isSet(object.expiryTime)
                ? fromJsonTimestamp(object.expiryTime)
                : isSet(object.expiry_time)
                    ? fromJsonTimestamp(object.expiry_time)
                    : undefined,
            ocpiTrackingId: isSet(object.ocpiTrackingId)
                ? globalThis.String(object.ocpiTrackingId)
                : isSet(object.ocpi_tracking_id)
                    ? globalThis.String(object.ocpi_tracking_id)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.money !== undefined) {
            obj.money = money_1.Money.toJSON(message.money);
        }
        if (message.expiryTime !== undefined) {
            obj.expiryTime = message.expiryTime.toISOString();
        }
        if (message.ocpiTrackingId !== "") {
            obj.ocpiTrackingId = message.ocpiTrackingId;
        }
        return obj;
    },
    create(base) {
        return exports.OCPIRemoteAuthorization.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOCPIRemoteAuthorization();
        message.money =
            object.money !== undefined && object.money !== null
                ? money_1.Money.fromPartial(object.money)
                : undefined;
        message.expiryTime = object.expiryTime ?? undefined;
        message.ocpiTrackingId = object.ocpiTrackingId ?? "";
        return message;
    },
};
function createBaseRemotePaymentAuthorizationDetails() {
    return {
        commandConsoleAuthorization: undefined,
        ocpiRemoteAuthorization: undefined,
    };
}
exports.RemotePaymentAuthorizationDetails = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.commandConsoleAuthorization !== undefined) {
            exports.CommandConsoleAuthorization.encode(message.commandConsoleAuthorization, writer.uint32(10).fork()).join();
        }
        if (message.ocpiRemoteAuthorization !== undefined) {
            exports.OCPIRemoteAuthorization.encode(message.ocpiRemoteAuthorization, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRemotePaymentAuthorizationDetails();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.commandConsoleAuthorization =
                        exports.CommandConsoleAuthorization.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.ocpiRemoteAuthorization = exports.OCPIRemoteAuthorization.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            commandConsoleAuthorization: isSet(object.commandConsoleAuthorization)
                ? exports.CommandConsoleAuthorization.fromJSON(object.commandConsoleAuthorization)
                : isSet(object.command_console_authorization)
                    ? exports.CommandConsoleAuthorization.fromJSON(object.command_console_authorization)
                    : undefined,
            ocpiRemoteAuthorization: isSet(object.ocpiRemoteAuthorization)
                ? exports.OCPIRemoteAuthorization.fromJSON(object.ocpiRemoteAuthorization)
                : isSet(object.ocpi_remote_authorization)
                    ? exports.OCPIRemoteAuthorization.fromJSON(object.ocpi_remote_authorization)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.commandConsoleAuthorization !== undefined) {
            obj.commandConsoleAuthorization = exports.CommandConsoleAuthorization.toJSON(message.commandConsoleAuthorization);
        }
        if (message.ocpiRemoteAuthorization !== undefined) {
            obj.ocpiRemoteAuthorization = exports.OCPIRemoteAuthorization.toJSON(message.ocpiRemoteAuthorization);
        }
        return obj;
    },
    create(base) {
        return exports.RemotePaymentAuthorizationDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRemotePaymentAuthorizationDetails();
        message.commandConsoleAuthorization =
            object.commandConsoleAuthorization !== undefined &&
                object.commandConsoleAuthorization !== null
                ? exports.CommandConsoleAuthorization.fromPartial(object.commandConsoleAuthorization)
                : undefined;
        message.ocpiRemoteAuthorization =
            object.ocpiRemoteAuthorization !== undefined &&
                object.ocpiRemoteAuthorization !== null
                ? exports.OCPIRemoteAuthorization.fromPartial(object.ocpiRemoteAuthorization)
                : undefined;
        return message;
    },
};
function createBaseRemotePaymentAuthorization() {
    return {
        id: 0,
        chargerOcppId: "",
        portId: 0,
        timeUtc: undefined,
        authorizationDetails: undefined,
        isNocAgentFreeSession: undefined,
    };
}
exports.RemotePaymentAuthorization = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== 0) {
            writer.uint32(8).int32(message.id);
        }
        if (message.chargerOcppId !== "") {
            writer.uint32(18).string(message.chargerOcppId);
        }
        if (message.portId !== 0) {
            writer.uint32(24).uint32(message.portId);
        }
        if (message.timeUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.timeUtc), writer.uint32(34).fork()).join();
        }
        if (message.authorizationDetails !== undefined) {
            exports.RemotePaymentAuthorizationDetails.encode(message.authorizationDetails, writer.uint32(42).fork()).join();
        }
        if (message.isNocAgentFreeSession !== undefined) {
            writer.uint32(48).bool(message.isNocAgentFreeSession);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRemotePaymentAuthorization();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.id = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.chargerOcppId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.portId = reader.uint32();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.timeUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.authorizationDetails =
                        exports.RemotePaymentAuthorizationDetails.decode(reader, reader.uint32());
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.isNocAgentFreeSession = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            chargerOcppId: isSet(object.chargerOcppId)
                ? globalThis.String(object.chargerOcppId)
                : isSet(object.charger_ocpp_id)
                    ? globalThis.String(object.charger_ocpp_id)
                    : "",
            portId: isSet(object.portId)
                ? globalThis.Number(object.portId)
                : isSet(object.port_id)
                    ? globalThis.Number(object.port_id)
                    : 0,
            timeUtc: isSet(object.timeUtc)
                ? fromJsonTimestamp(object.timeUtc)
                : isSet(object.time_utc)
                    ? fromJsonTimestamp(object.time_utc)
                    : undefined,
            authorizationDetails: isSet(object.authorizationDetails)
                ? exports.RemotePaymentAuthorizationDetails.fromJSON(object.authorizationDetails)
                : isSet(object.authorization_details)
                    ? exports.RemotePaymentAuthorizationDetails.fromJSON(object.authorization_details)
                    : undefined,
            isNocAgentFreeSession: isSet(object.isNocAgentFreeSession)
                ? globalThis.Boolean(object.isNocAgentFreeSession)
                : isSet(object.is_noc_agent_free_session)
                    ? globalThis.Boolean(object.is_noc_agent_free_session)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.chargerOcppId !== "") {
            obj.chargerOcppId = message.chargerOcppId;
        }
        if (message.portId !== 0) {
            obj.portId = Math.round(message.portId);
        }
        if (message.timeUtc !== undefined) {
            obj.timeUtc = message.timeUtc.toISOString();
        }
        if (message.authorizationDetails !== undefined) {
            obj.authorizationDetails = exports.RemotePaymentAuthorizationDetails.toJSON(message.authorizationDetails);
        }
        if (message.isNocAgentFreeSession !== undefined) {
            obj.isNocAgentFreeSession = message.isNocAgentFreeSession;
        }
        return obj;
    },
    create(base) {
        return exports.RemotePaymentAuthorization.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRemotePaymentAuthorization();
        message.id = object.id ?? 0;
        message.chargerOcppId = object.chargerOcppId ?? "";
        message.portId = object.portId ?? 0;
        message.timeUtc = object.timeUtc ?? undefined;
        message.authorizationDetails =
            object.authorizationDetails !== undefined &&
                object.authorizationDetails !== null
                ? exports.RemotePaymentAuthorizationDetails.fromPartial(object.authorizationDetails)
                : undefined;
        message.isNocAgentFreeSession = object.isNocAgentFreeSession ?? undefined;
        return message;
    },
};
function createBaseGetRemotePaymentAuthorizationsResponse() {
    return { remotePaymentAuthorizations: [] };
}
exports.GetRemotePaymentAuthorizationsResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.remotePaymentAuthorizations) {
            exports.RemotePaymentAuthorization.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetRemotePaymentAuthorizationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.remotePaymentAuthorizations.push(exports.RemotePaymentAuthorization.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            remotePaymentAuthorizations: globalThis.Array.isArray(object?.remotePaymentAuthorizations)
                ? object.remotePaymentAuthorizations.map((e) => exports.RemotePaymentAuthorization.fromJSON(e))
                : globalThis.Array.isArray(object?.remote_payment_authorizations)
                    ? object.remote_payment_authorizations.map((e) => exports.RemotePaymentAuthorization.fromJSON(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.remotePaymentAuthorizations?.length) {
            obj.remotePaymentAuthorizations =
                message.remotePaymentAuthorizations.map((e) => exports.RemotePaymentAuthorization.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetRemotePaymentAuthorizationsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetRemotePaymentAuthorizationsResponse();
        message.remotePaymentAuthorizations =
            object.remotePaymentAuthorizations?.map((e) => exports.RemotePaymentAuthorization.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetChargerRemotePaymentAuthorizationsResponse() {
    return { remotePaymentAuthorizations: [] };
}
exports.GetChargerRemotePaymentAuthorizationsResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.remotePaymentAuthorizations) {
            exports.RemotePaymentAuthorization.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChargerRemotePaymentAuthorizationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.remotePaymentAuthorizations.push(exports.RemotePaymentAuthorization.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            remotePaymentAuthorizations: globalThis.Array.isArray(object?.remotePaymentAuthorizations)
                ? object.remotePaymentAuthorizations.map((e) => exports.RemotePaymentAuthorization.fromJSON(e))
                : globalThis.Array.isArray(object?.remote_payment_authorizations)
                    ? object.remote_payment_authorizations.map((e) => exports.RemotePaymentAuthorization.fromJSON(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.remotePaymentAuthorizations?.length) {
            obj.remotePaymentAuthorizations =
                message.remotePaymentAuthorizations.map((e) => exports.RemotePaymentAuthorization.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetChargerRemotePaymentAuthorizationsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChargerRemotePaymentAuthorizationsResponse();
        message.remotePaymentAuthorizations =
            object.remotePaymentAuthorizations?.map((e) => exports.RemotePaymentAuthorization.fromPartial(e)) || [];
        return message;
    },
};
function createBaseStopRemotePaymentAuthorization() {
    return {
        sessionId: "",
        chargerOcppId: "",
        portId: 0,
        timeUtc: undefined,
        ocpiTrackingId: "",
    };
}
exports.StopRemotePaymentAuthorization = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.sessionId !== "") {
            writer.uint32(10).string(message.sessionId);
        }
        if (message.chargerOcppId !== "") {
            writer.uint32(18).string(message.chargerOcppId);
        }
        if (message.portId !== 0) {
            writer.uint32(24).uint32(message.portId);
        }
        if (message.timeUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.timeUtc), writer.uint32(34).fork()).join();
        }
        if (message.ocpiTrackingId !== "") {
            writer.uint32(42).string(message.ocpiTrackingId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStopRemotePaymentAuthorization();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.sessionId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.chargerOcppId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.portId = reader.uint32();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.timeUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.ocpiTrackingId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            sessionId: isSet(object.sessionId)
                ? globalThis.String(object.sessionId)
                : isSet(object.session_id)
                    ? globalThis.String(object.session_id)
                    : "",
            chargerOcppId: isSet(object.chargerOcppId)
                ? globalThis.String(object.chargerOcppId)
                : isSet(object.charger_ocpp_id)
                    ? globalThis.String(object.charger_ocpp_id)
                    : "",
            portId: isSet(object.portId)
                ? globalThis.Number(object.portId)
                : isSet(object.port_id)
                    ? globalThis.Number(object.port_id)
                    : 0,
            timeUtc: isSet(object.timeUtc)
                ? fromJsonTimestamp(object.timeUtc)
                : isSet(object.time_utc)
                    ? fromJsonTimestamp(object.time_utc)
                    : undefined,
            ocpiTrackingId: isSet(object.ocpiTrackingId)
                ? globalThis.String(object.ocpiTrackingId)
                : isSet(object.ocpi_tracking_id)
                    ? globalThis.String(object.ocpi_tracking_id)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sessionId !== "") {
            obj.sessionId = message.sessionId;
        }
        if (message.chargerOcppId !== "") {
            obj.chargerOcppId = message.chargerOcppId;
        }
        if (message.portId !== 0) {
            obj.portId = Math.round(message.portId);
        }
        if (message.timeUtc !== undefined) {
            obj.timeUtc = message.timeUtc.toISOString();
        }
        if (message.ocpiTrackingId !== "") {
            obj.ocpiTrackingId = message.ocpiTrackingId;
        }
        return obj;
    },
    create(base) {
        return exports.StopRemotePaymentAuthorization.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStopRemotePaymentAuthorization();
        message.sessionId = object.sessionId ?? "";
        message.chargerOcppId = object.chargerOcppId ?? "";
        message.portId = object.portId ?? 0;
        message.timeUtc = object.timeUtc ?? undefined;
        message.ocpiTrackingId = object.ocpiTrackingId ?? "";
        return message;
    },
};
function createBaseGetStopRemotePaymentAuthorizationsResponse() {
    return { stopRemotePaymentAuthorizations: [] };
}
exports.GetStopRemotePaymentAuthorizationsResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.stopRemotePaymentAuthorizations) {
            exports.StopRemotePaymentAuthorization.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetStopRemotePaymentAuthorizationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.stopRemotePaymentAuthorizations.push(exports.StopRemotePaymentAuthorization.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            stopRemotePaymentAuthorizations: globalThis.Array.isArray(object?.stopRemotePaymentAuthorizations)
                ? object.stopRemotePaymentAuthorizations.map((e) => exports.StopRemotePaymentAuthorization.fromJSON(e))
                : globalThis.Array.isArray(object?.stop_remote_payment_authorizations)
                    ? object.stop_remote_payment_authorizations.map((e) => exports.StopRemotePaymentAuthorization.fromJSON(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.stopRemotePaymentAuthorizations?.length) {
            obj.stopRemotePaymentAuthorizations =
                message.stopRemotePaymentAuthorizations.map((e) => exports.StopRemotePaymentAuthorization.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetStopRemotePaymentAuthorizationsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetStopRemotePaymentAuthorizationsResponse();
        message.stopRemotePaymentAuthorizations =
            object.stopRemotePaymentAuthorizations?.map((e) => exports.StopRemotePaymentAuthorization.fromPartial(e)) || [];
        return message;
    },
};
function createBaseGetChargerStopRemotePaymentAuthorizationsResponse() {
    return { stopRemotePaymentAuthorizations: [] };
}
exports.GetChargerStopRemotePaymentAuthorizationsResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.stopRemotePaymentAuthorizations) {
            exports.StopRemotePaymentAuthorization.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChargerStopRemotePaymentAuthorizationsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.stopRemotePaymentAuthorizations.push(exports.StopRemotePaymentAuthorization.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            stopRemotePaymentAuthorizations: globalThis.Array.isArray(object?.stopRemotePaymentAuthorizations)
                ? object.stopRemotePaymentAuthorizations.map((e) => exports.StopRemotePaymentAuthorization.fromJSON(e))
                : globalThis.Array.isArray(object?.stop_remote_payment_authorizations)
                    ? object.stop_remote_payment_authorizations.map((e) => exports.StopRemotePaymentAuthorization.fromJSON(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.stopRemotePaymentAuthorizations?.length) {
            obj.stopRemotePaymentAuthorizations =
                message.stopRemotePaymentAuthorizations.map((e) => exports.StopRemotePaymentAuthorization.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetChargerStopRemotePaymentAuthorizationsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetChargerStopRemotePaymentAuthorizationsResponse();
        message.stopRemotePaymentAuthorizations =
            object.stopRemotePaymentAuthorizations?.map((e) => exports.StopRemotePaymentAuthorization.fromPartial(e)) || [];
        return message;
    },
};
function createBaseValidateMembershipRequest() {
    return {
        pnid: 0,
        membershipIdentifier: "",
        ocppId: "",
        authorizationType: 0,
        authorizationMode: 0,
        membershipTransactionId: "",
    };
}
exports.ValidateMembershipRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pnid !== 0) {
            writer.uint32(8).int32(message.pnid);
        }
        if (message.membershipIdentifier !== "") {
            writer.uint32(18).string(message.membershipIdentifier);
        }
        if (message.ocppId !== "") {
            writer.uint32(26).string(message.ocppId);
        }
        if (message.authorizationType !== 0) {
            writer.uint32(32).int32(message.authorizationType);
        }
        if (message.authorizationMode !== 0) {
            writer.uint32(40).int32(message.authorizationMode);
        }
        if (message.membershipTransactionId !== "") {
            writer.uint32(50).string(message.membershipTransactionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidateMembershipRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pnid = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.membershipIdentifier = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.ocppId = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.authorizationType = reader.int32();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.authorizationMode = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.membershipTransactionId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pnid: isSet(object.pnid) ? globalThis.Number(object.pnid) : 0,
            membershipIdentifier: isSet(object.membershipIdentifier)
                ? globalThis.String(object.membershipIdentifier)
                : isSet(object.membership_identifier)
                    ? globalThis.String(object.membership_identifier)
                    : "",
            ocppId: isSet(object.ocppId)
                ? globalThis.String(object.ocppId)
                : isSet(object.ocpp_id)
                    ? globalThis.String(object.ocpp_id)
                    : "",
            authorizationType: isSet(object.authorizationType)
                ? (0, money_1.membershipAuthorizationTypeFromJSON)(object.authorizationType)
                : isSet(object.authorization_type)
                    ? (0, money_1.membershipAuthorizationTypeFromJSON)(object.authorization_type)
                    : 0,
            authorizationMode: isSet(object.authorizationMode)
                ? (0, money_1.membershipAuthorizationModeFromJSON)(object.authorizationMode)
                : isSet(object.authorization_mode)
                    ? (0, money_1.membershipAuthorizationModeFromJSON)(object.authorization_mode)
                    : 0,
            membershipTransactionId: isSet(object.membershipTransactionId)
                ? globalThis.String(object.membershipTransactionId)
                : isSet(object.membership_transaction_id)
                    ? globalThis.String(object.membership_transaction_id)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pnid !== 0) {
            obj.pnid = Math.round(message.pnid);
        }
        if (message.membershipIdentifier !== "") {
            obj.membershipIdentifier = message.membershipIdentifier;
        }
        if (message.ocppId !== "") {
            obj.ocppId = message.ocppId;
        }
        if (message.authorizationType !== 0) {
            obj.authorizationType = (0, money_1.membershipAuthorizationTypeToJSON)(message.authorizationType);
        }
        if (message.authorizationMode !== 0) {
            obj.authorizationMode = (0, money_1.membershipAuthorizationModeToJSON)(message.authorizationMode);
        }
        if (message.membershipTransactionId !== "") {
            obj.membershipTransactionId = message.membershipTransactionId;
        }
        return obj;
    },
    create(base) {
        return exports.ValidateMembershipRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseValidateMembershipRequest();
        message.pnid = object.pnid ?? 0;
        message.membershipIdentifier = object.membershipIdentifier ?? "";
        message.ocppId = object.ocppId ?? "";
        message.authorizationType = object.authorizationType ?? 0;
        message.authorizationMode = object.authorizationMode ?? 0;
        message.membershipTransactionId = object.membershipTransactionId ?? "";
        return message;
    },
};
function createBaseValidateMembershipResponse() {
    return {
        isValid: false,
        membershipStatusCode: "",
        validatedTimeUtc: undefined,
        membershipToken: "",
        actionCode: 0,
        actionId: undefined,
    };
}
exports.ValidateMembershipResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.isValid !== false) {
            writer.uint32(8).bool(message.isValid);
        }
        if (message.membershipStatusCode !== "") {
            writer.uint32(18).string(message.membershipStatusCode);
        }
        if (message.validatedTimeUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.validatedTimeUtc), writer.uint32(26).fork()).join();
        }
        if (message.membershipToken !== "") {
            writer.uint32(34).string(message.membershipToken);
        }
        if (message.actionCode !== 0) {
            writer.uint32(40).int32(message.actionCode);
        }
        if (message.actionId !== undefined) {
            writer.uint32(48).int32(message.actionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidateMembershipResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.isValid = reader.bool();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.membershipStatusCode = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.validatedTimeUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.membershipToken = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.actionCode = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.actionId = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            isValid: isSet(object.isValid)
                ? globalThis.Boolean(object.isValid)
                : isSet(object.is_valid)
                    ? globalThis.Boolean(object.is_valid)
                    : false,
            membershipStatusCode: isSet(object.membershipStatusCode)
                ? globalThis.String(object.membershipStatusCode)
                : isSet(object.membership_status_code)
                    ? globalThis.String(object.membership_status_code)
                    : "",
            validatedTimeUtc: isSet(object.validatedTimeUtc)
                ? fromJsonTimestamp(object.validatedTimeUtc)
                : isSet(object.validated_time_utc)
                    ? fromJsonTimestamp(object.validated_time_utc)
                    : undefined,
            membershipToken: isSet(object.membershipToken)
                ? globalThis.String(object.membershipToken)
                : isSet(object.membership_token)
                    ? globalThis.String(object.membership_token)
                    : "",
            actionCode: isSet(object.actionCode)
                ? (0, charging_session_attempt_1.membershipActionCodeFromJSON)(object.actionCode)
                : isSet(object.action_code)
                    ? (0, charging_session_attempt_1.membershipActionCodeFromJSON)(object.action_code)
                    : 0,
            actionId: isSet(object.actionId)
                ? globalThis.Number(object.actionId)
                : isSet(object.action_id)
                    ? globalThis.Number(object.action_id)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.isValid !== false) {
            obj.isValid = message.isValid;
        }
        if (message.membershipStatusCode !== "") {
            obj.membershipStatusCode = message.membershipStatusCode;
        }
        if (message.validatedTimeUtc !== undefined) {
            obj.validatedTimeUtc = message.validatedTimeUtc.toISOString();
        }
        if (message.membershipToken !== "") {
            obj.membershipToken = message.membershipToken;
        }
        if (message.actionCode !== 0) {
            obj.actionCode = (0, charging_session_attempt_1.membershipActionCodeToJSON)(message.actionCode);
        }
        if (message.actionId !== undefined) {
            obj.actionId = Math.round(message.actionId);
        }
        return obj;
    },
    create(base) {
        return exports.ValidateMembershipResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseValidateMembershipResponse();
        message.isValid = object.isValid ?? false;
        message.membershipStatusCode = object.membershipStatusCode ?? "";
        message.validatedTimeUtc = object.validatedTimeUtc ?? undefined;
        message.membershipToken = object.membershipToken ?? "";
        message.actionCode = object.actionCode ?? 0;
        message.actionId = object.actionId ?? undefined;
        return message;
    },
};
function createBasePollMembershipValidationRequest() {
    return { pnid: 0 };
}
exports.PollMembershipValidationRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pnid !== 0) {
            writer.uint32(8).int32(message.pnid);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePollMembershipValidationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.pnid = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { pnid: isSet(object.pnid) ? globalThis.Number(object.pnid) : 0 };
    },
    toJSON(message) {
        const obj = {};
        if (message.pnid !== 0) {
            obj.pnid = Math.round(message.pnid);
        }
        return obj;
    },
    create(base) {
        return exports.PollMembershipValidationRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePollMembershipValidationRequest();
        message.pnid = object.pnid ?? 0;
        return message;
    },
};
function createBasePollMembershipValidationResponse() {
    return { stationMembershipValidation: undefined };
}
exports.PollMembershipValidationResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.stationMembershipValidation !== undefined) {
            charger_1.MembershipValidation.encode(message.stationMembershipValidation, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePollMembershipValidationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.stationMembershipValidation = charger_1.MembershipValidation.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            stationMembershipValidation: isSet(object.stationMembershipValidation)
                ? charger_1.MembershipValidation.fromJSON(object.stationMembershipValidation)
                : isSet(object.station_membership_validation)
                    ? charger_1.MembershipValidation.fromJSON(object.station_membership_validation)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.stationMembershipValidation !== undefined) {
            obj.stationMembershipValidation = charger_1.MembershipValidation.toJSON(message.stationMembershipValidation);
        }
        return obj;
    },
    create(base) {
        return exports.PollMembershipValidationResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePollMembershipValidationResponse();
        message.stationMembershipValidation =
            object.stationMembershipValidation !== undefined &&
                object.stationMembershipValidation !== null
                ? charger_1.MembershipValidation.fromPartial(object.stationMembershipValidation)
                : undefined;
        return message;
    },
};
function createBaseRFIDCheckRequest() {
    return { ocppId: "", rfidUid: "", paymentTransactionId: "" };
}
exports.RFIDCheckRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.ocppId !== "") {
            writer.uint32(10).string(message.ocppId);
        }
        if (message.rfidUid !== "") {
            writer.uint32(18).string(message.rfidUid);
        }
        if (message.paymentTransactionId !== "") {
            writer.uint32(26).string(message.paymentTransactionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRFIDCheckRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.ocppId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.rfidUid = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.paymentTransactionId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            ocppId: isSet(object.ocppId)
                ? globalThis.String(object.ocppId)
                : isSet(object.ocpp_id)
                    ? globalThis.String(object.ocpp_id)
                    : "",
            rfidUid: isSet(object.rfidUid)
                ? globalThis.String(object.rfidUid)
                : isSet(object.rfid_uid)
                    ? globalThis.String(object.rfid_uid)
                    : "",
            paymentTransactionId: isSet(object.paymentTransactionId)
                ? globalThis.String(object.paymentTransactionId)
                : isSet(object.payment_transaction_id)
                    ? globalThis.String(object.payment_transaction_id)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ocppId !== "") {
            obj.ocppId = message.ocppId;
        }
        if (message.rfidUid !== "") {
            obj.rfidUid = message.rfidUid;
        }
        if (message.paymentTransactionId !== "") {
            obj.paymentTransactionId = message.paymentTransactionId;
        }
        return obj;
    },
    create(base) {
        return exports.RFIDCheckRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRFIDCheckRequest();
        message.ocppId = object.ocppId ?? "";
        message.rfidUid = object.rfidUid ?? "";
        message.paymentTransactionId = object.paymentTransactionId ?? "";
        return message;
    },
};
function createBaseRFIDCheckResponse() {
    return { rfidType: 0, paymentToken: "" };
}
exports.RFIDCheckResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.rfidType !== 0) {
            writer.uint32(8).int32(message.rfidType);
        }
        if (message.paymentToken !== "") {
            writer.uint32(18).string(message.paymentToken);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRFIDCheckResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.rfidType = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.paymentToken = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            rfidType: isSet(object.rfidType)
                ? rfidTypeFromJSON(object.rfidType)
                : isSet(object.rfid_type)
                    ? rfidTypeFromJSON(object.rfid_type)
                    : 0,
            paymentToken: isSet(object.paymentToken)
                ? globalThis.String(object.paymentToken)
                : isSet(object.payment_token)
                    ? globalThis.String(object.payment_token)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.rfidType !== 0) {
            obj.rfidType = rfidTypeToJSON(message.rfidType);
        }
        if (message.paymentToken !== "") {
            obj.paymentToken = message.paymentToken;
        }
        return obj;
    },
    create(base) {
        return exports.RFIDCheckResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRFIDCheckResponse();
        message.rfidType = object.rfidType ?? 0;
        message.paymentToken = object.paymentToken ?? "";
        return message;
    },
};
function createBaseRegisterStartTransactionRequest() {
    return { paymentToken: "", ocppId: "", connectorId: "", transactionId: "" };
}
exports.RegisterStartTransactionRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.paymentToken !== "") {
            writer.uint32(10).string(message.paymentToken);
        }
        if (message.ocppId !== "") {
            writer.uint32(18).string(message.ocppId);
        }
        if (message.connectorId !== "") {
            writer.uint32(26).string(message.connectorId);
        }
        if (message.transactionId !== "") {
            writer.uint32(34).string(message.transactionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRegisterStartTransactionRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.paymentToken = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.ocppId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.connectorId = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.transactionId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            paymentToken: isSet(object.paymentToken)
                ? globalThis.String(object.paymentToken)
                : isSet(object.payment_token)
                    ? globalThis.String(object.payment_token)
                    : "",
            ocppId: isSet(object.ocppId)
                ? globalThis.String(object.ocppId)
                : isSet(object.ocpp_id)
                    ? globalThis.String(object.ocpp_id)
                    : "",
            connectorId: isSet(object.connectorId)
                ? globalThis.String(object.connectorId)
                : isSet(object.connector_id)
                    ? globalThis.String(object.connector_id)
                    : "",
            transactionId: isSet(object.transactionId)
                ? globalThis.String(object.transactionId)
                : isSet(object.transaction_id)
                    ? globalThis.String(object.transaction_id)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentToken !== "") {
            obj.paymentToken = message.paymentToken;
        }
        if (message.ocppId !== "") {
            obj.ocppId = message.ocppId;
        }
        if (message.connectorId !== "") {
            obj.connectorId = message.connectorId;
        }
        if (message.transactionId !== "") {
            obj.transactionId = message.transactionId;
        }
        return obj;
    },
    create(base) {
        return exports.RegisterStartTransactionRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRegisterStartTransactionRequest();
        message.paymentToken = object.paymentToken ?? "";
        message.ocppId = object.ocppId ?? "";
        message.connectorId = object.connectorId ?? "";
        message.transactionId = object.transactionId ?? "";
        return message;
    },
};
function createBaseRegisterStartTransactionResponse() {
    return { trackingId: "" };
}
exports.RegisterStartTransactionResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.trackingId !== "") {
            writer.uint32(10).string(message.trackingId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRegisterStartTransactionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.trackingId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            trackingId: isSet(object.trackingId)
                ? globalThis.String(object.trackingId)
                : isSet(object.tracking_id)
                    ? globalThis.String(object.tracking_id)
                    : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.trackingId !== "") {
            obj.trackingId = message.trackingId;
        }
        return obj;
    },
    create(base) {
        return exports.RegisterStartTransactionResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRegisterStartTransactionResponse();
        message.trackingId = object.trackingId ?? "";
        return message;
    },
};
function createBaseRegisterBinDataRequest() {
    return { binData: undefined };
}
exports.RegisterBinDataRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.binData !== undefined) {
            money_1.BinData.encode(message.binData, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRegisterBinDataRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.binData = money_1.BinData.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            binData: isSet(object.binData)
                ? money_1.BinData.fromJSON(object.binData)
                : isSet(object.bin_data)
                    ? money_1.BinData.fromJSON(object.bin_data)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.binData !== undefined) {
            obj.binData = money_1.BinData.toJSON(message.binData);
        }
        return obj;
    },
    create(base) {
        return exports.RegisterBinDataRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRegisterBinDataRequest();
        message.binData =
            object.binData !== undefined && object.binData !== null
                ? money_1.BinData.fromPartial(object.binData)
                : undefined;
        return message;
    },
};
function createBaseRegisterBinDataResponse() {
    return {};
}
exports.RegisterBinDataResponse = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRegisterBinDataResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.RegisterBinDataResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseRegisterBinDataResponse();
        return message;
    },
};
exports.PowernodeEventsServiceServiceName = "powernode.PowernodeEventsService";
class PowernodeEventsServiceClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || exports.PowernodeEventsServiceServiceName;
        this.rpc = rpc;
        this.RegisterTransaction = this.RegisterTransaction.bind(this);
        this.UpdateTransaction = this.UpdateTransaction.bind(this);
        this.SyncChargingSessions = this.SyncChargingSessions.bind(this);
        this.SyncChargingTransactionDetails =
            this.SyncChargingTransactionDetails.bind(this);
        this.RegisterPlugEvent = this.RegisterPlugEvent.bind(this);
        this.RegisterChargerFeedback = this.RegisterChargerFeedback.bind(this);
        this.RegisterOnScreenValidationFeedback =
            this.RegisterOnScreenValidationFeedback.bind(this);
        this.GetPricingInformation = this.GetPricingInformation.bind(this);
        this.GetChargerPricingInformation =
            this.GetChargerPricingInformation.bind(this);
        this.GetPaymentInformation = this.GetPaymentInformation.bind(this);
        this.GetChargerPaymentInformation =
            this.GetChargerPaymentInformation.bind(this);
        this.GetStatus = this.GetStatus.bind(this);
        this.GetChargerOperatingStatus = this.GetChargerOperatingStatus.bind(this);
        this.GenerateReceipt = this.GenerateReceipt.bind(this);
        this.GetConnectedDevices = this.GetConnectedDevices.bind(this);
        this.GetChargerConnectedDevice = this.GetChargerConnectedDevice.bind(this);
        this.GetSiteEnvironment = this.GetSiteEnvironment.bind(this);
        this.GetOperationalStatus = this.GetOperationalStatus.bind(this);
        this.UpdateStatus = this.UpdateStatus.bind(this);
        this.UpdatePowernodeStatus = this.UpdatePowernodeStatus.bind(this);
        this.UpdateSitePowerMeterStatus =
            this.UpdateSitePowerMeterStatus.bind(this);
        this.GetCustomerInformationByPaymentToken =
            this.GetCustomerInformationByPaymentToken.bind(this);
        this.GetTheme = this.GetTheme.bind(this);
        this.GetUiConfig = this.GetUiConfig.bind(this);
        this.GetChargerUiConfig = this.GetChargerUiConfig.bind(this);
        this.GetRemotePaymentAuthorizations =
            this.GetRemotePaymentAuthorizations.bind(this);
        this.GetChargerRemotePaymentAuthorizations =
            this.GetChargerRemotePaymentAuthorizations.bind(this);
        this.GetStopRemotePaymentAuthorizations =
            this.GetStopRemotePaymentAuthorizations.bind(this);
        this.GetChargerStopRemotePaymentAuthorizations =
            this.GetChargerStopRemotePaymentAuthorizations.bind(this);
        this.GetPowerProfileSchedule = this.GetPowerProfileSchedule.bind(this);
        this.ValidateMembership = this.ValidateMembership.bind(this);
        this.PollMembershipValidation = this.PollMembershipValidation.bind(this);
        this.RFIDCheck = this.RFIDCheck.bind(this);
        this.RegisterStartTransaction = this.RegisterStartTransaction.bind(this);
        this.RegisterBinData = this.RegisterBinData.bind(this);
    }
    RegisterTransaction(request) {
        const data = exports.RegisterTransactionRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "RegisterTransaction", data);
        return promise.then((data) => exports.RegisterTransactionResponse.decode(new wire_1.BinaryReader(data)));
    }
    UpdateTransaction(request) {
        const data = exports.UpdateTransactionRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UpdateTransaction", data);
        return promise.then((data) => exports.UpdateTransactionResponse.decode(new wire_1.BinaryReader(data)));
    }
    SyncChargingSessions(request) {
        const data = exports.SyncChargingSessionsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SyncChargingSessions", data);
        return promise.then((data) => exports.SyncChargingSessionsResponse.decode(new wire_1.BinaryReader(data)));
    }
    SyncChargingTransactionDetails(request) {
        const data = exports.SyncChargingTransactionDetailsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SyncChargingTransactionDetails", data);
        return promise.then((data) => exports.SyncChargingTransactionDetailsResponse.decode(new wire_1.BinaryReader(data)));
    }
    RegisterPlugEvent(request) {
        const data = exports.PlugEventRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "RegisterPlugEvent", data);
        return promise.then((data) => exports.PlugEventResponse.decode(new wire_1.BinaryReader(data)));
    }
    RegisterChargerFeedback(request) {
        const data = exports.ChargerFeedbackRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "RegisterChargerFeedback", data);
        return promise.then((data) => exports.ChargerFeedbackResponse.decode(new wire_1.BinaryReader(data)));
    }
    RegisterOnScreenValidationFeedback(request) {
        const data = exports.OnScreenValidationFeedbackRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "RegisterOnScreenValidationFeedback", data);
        return promise.then((data) => exports.OnScreenValidationFeedbackResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetPricingInformation(request) {
        const data = exports.GetPricingInformationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetPricingInformation", data);
        return promise.then((data) => exports.GetPricingInformationResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetChargerPricingInformation(request) {
        const data = exports.GetChargerPricingInformationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetChargerPricingInformation", data);
        return promise.then((data) => exports.GetChargerPricingInformationResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetPaymentInformation(request) {
        const data = exports.GetPaymentInformationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetPaymentInformation", data);
        return promise.then((data) => exports.GetPaymentInformationResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetChargerPaymentInformation(request) {
        const data = exports.GetChargerPaymentInformationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetChargerPaymentInformation", data);
        return promise.then((data) => exports.GetChargerPaymentInformationResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetStatus(request) {
        const data = exports.GetStatusRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetStatus", data);
        return promise.then((data) => exports.GetStatusResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetChargerOperatingStatus(request) {
        const data = exports.GetChargerOperatingStatusRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetChargerOperatingStatus", data);
        return promise.then((data) => exports.GetChargerOperatingStatusResponse.decode(new wire_1.BinaryReader(data)));
    }
    GenerateReceipt(request) {
        const data = exports.GenerateReceiptRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GenerateReceipt", data);
        return promise.then((data) => exports.GenerateReceiptResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetConnectedDevices(request) {
        const data = exports.GetConnectedDevicesRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetConnectedDevices", data);
        return promise.then((data) => exports.GetConnectedDevicesResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetChargerConnectedDevice(request) {
        const data = exports.GetChargerConnectedDeviceRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetChargerConnectedDevice", data);
        return promise.then((data) => exports.GetChargerConnectedDeviceResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetSiteEnvironment(request) {
        const data = exports.GetSiteEnvironmentRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetSiteEnvironment", data);
        return promise.then((data) => exports.GetSiteEnvironmentResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetOperationalStatus(request) {
        const data = exports.GetOperationalStatusRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetOperationalStatus", data);
        return promise.then((data) => exports.GetOperationalStatusResponse.decode(new wire_1.BinaryReader(data)));
    }
    UpdateStatus(request) {
        const data = exports.UpdateStatusRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UpdateStatus", data);
        return promise.then((data) => exports.UpdateStatusResponse.decode(new wire_1.BinaryReader(data)));
    }
    UpdatePowernodeStatus(request) {
        const data = exports.UpdatePowernodeStatusRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UpdatePowernodeStatus", data);
        return promise.then((data) => exports.UpdatePowernodeStatusResponse.decode(new wire_1.BinaryReader(data)));
    }
    UpdateSitePowerMeterStatus(request) {
        const data = exports.UpdateSitePowerMeterStatusRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "UpdateSitePowerMeterStatus", data);
        return promise.then((data) => exports.UpdateSitePowerMeterStatusResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetCustomerInformationByPaymentToken(request) {
        const data = exports.GetCustomerInformationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetCustomerInformationByPaymentToken", data);
        return promise.then((data) => exports.GetCustomerInformationResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetTheme(request) {
        const data = exports.GetThemeRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetTheme", data);
        return promise.then((data) => exports.GetThemeResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetUiConfig(request) {
        const data = exports.GetUiConfigRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetUiConfig", data);
        return promise.then((data) => exports.GetUiConfigResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetChargerUiConfig(request) {
        const data = exports.GetChargerUiConfigRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetChargerUiConfig", data);
        return promise.then((data) => exports.GetChargerUiConfigResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetRemotePaymentAuthorizations(request) {
        const data = exports.GetRemotePaymentAuthorizationsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetRemotePaymentAuthorizations", data);
        return promise.then((data) => exports.GetRemotePaymentAuthorizationsResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetChargerRemotePaymentAuthorizations(request) {
        const data = exports.GetChargerRemotePaymentAuthorizationsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetChargerRemotePaymentAuthorizations", data);
        return promise.then((data) => exports.GetChargerRemotePaymentAuthorizationsResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetStopRemotePaymentAuthorizations(request) {
        const data = exports.GetStopRemotePaymentAuthorizationsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetStopRemotePaymentAuthorizations", data);
        return promise.then((data) => exports.GetStopRemotePaymentAuthorizationsResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetChargerStopRemotePaymentAuthorizations(request) {
        const data = exports.GetChargerStopRemotePaymentAuthorizationsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetChargerStopRemotePaymentAuthorizations", data);
        return promise.then((data) => exports.GetChargerStopRemotePaymentAuthorizationsResponse.decode(new wire_1.BinaryReader(data)));
    }
    GetPowerProfileSchedule(request) {
        const data = exports.GetPowerProfileScheduleRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetPowerProfileSchedule", data);
        return promise.then((data) => exports.GetPowerProfileScheduleResponse.decode(new wire_1.BinaryReader(data)));
    }
    ValidateMembership(request) {
        const data = exports.ValidateMembershipRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ValidateMembership", data);
        return promise.then((data) => exports.ValidateMembershipResponse.decode(new wire_1.BinaryReader(data)));
    }
    PollMembershipValidation(request) {
        const data = exports.PollMembershipValidationRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "PollMembershipValidation", data);
        return promise.then((data) => exports.PollMembershipValidationResponse.decode(new wire_1.BinaryReader(data)));
    }
    RFIDCheck(request) {
        const data = exports.RFIDCheckRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "RFIDCheck", data);
        return promise.then((data) => exports.RFIDCheckResponse.decode(new wire_1.BinaryReader(data)));
    }
    RegisterStartTransaction(request) {
        const data = exports.RegisterStartTransactionRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "RegisterStartTransaction", data);
        return promise.then((data) => exports.RegisterStartTransactionResponse.decode(new wire_1.BinaryReader(data)));
    }
    RegisterBinData(request) {
        const data = exports.RegisterBinDataRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "RegisterBinData", data);
        return promise.then((data) => exports.RegisterBinDataResponse.decode(new wire_1.BinaryReader(data)));
    }
}
exports.PowernodeEventsServiceClientImpl = PowernodeEventsServiceClientImpl;
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(globalThis.String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new globalThis.Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
